/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * Sifly Cloud API Documentation
 * Backend APIs for Sifly Cloud: accounts, drone command & telemetry, video streaming, integrations, and more.
 * OpenAPI spec version: v1
 */
import { apiMutator } from '../apiMutator';

// https://stackoverflow.com/questions/49579094/typescript-conditional-types-filter-out-readonly-properties-pick-only-requir/49579497#49579497
type IfEquals<X, Y, A = X, B = never> = (<T>() => T extends X ? 1 : 2) extends <
T,
>() => T extends Y ? 1 : 2
? A
: B;

type WritableKeys<T> = {
[P in keyof T]-?: IfEquals<
  { [Q in P]: T[P] },
  { -readonly [Q in P]: T[P] },
  P
>;
}[keyof T];

type UnionToIntersection<U> =
  (U extends any ? (k: U)=>void : never) extends ((k: infer I)=>void) ? I : never;
type DistributeReadOnlyOverUnions<T> = T extends any ? NonReadonly<T> : never;

type Writable<T> = Pick<T, WritableKeys<T>>;
type NonReadonly<T> = [T] extends [UnionToIntersection<T>] ? {
  [P in keyof Writable<T>]: T[P] extends object
    ? NonReadonly<NonNullable<T[P]>>
    : T[P];
} : DistributeReadOnlyOverUnions<T>;

export type AccessRequestStatus = 'pending' | 'approved' | 'rejected';
export interface AccessRequest {
  readonly id?: number;
  /** @nullable */
  organization?: number | null;
  /** @minLength 1 */
  readonly organization_name?: string;
  readonly status?: AccessRequestStatus;
  readonly created_at?: string;
  admin_email?: string;
}

export interface Address {
  readonly id?: number;
  /**
   * @maxLength 255
   * @nullable
   */
  street_address_1?: string | null;
  /**
   * @maxLength 255
   * @nullable
   */
  street_address_2?: string | null;
  /**
   * @maxLength 255
   * @nullable
   */
  city?: string | null;
  /**
   * @maxLength 20
   * @nullable
   */
  zip_code?: string | null;
  /**
   * @maxLength 255
   * @nullable
   */
  state?: string | null;
  /**
   * @maxLength 255
   * @nullable
   */
  country?: string | null;
}

export interface Company {
  readonly id?: number;
  address?: Address;
  owner_id: number;
  readonly owner?: string;
  readonly created_at?: string;
  readonly updated_at?: string;
  /**
   * @minLength 1
   * @maxLength 255
   */
  name: string;
  /**
   * @maxLength 255
   * @nullable
   */
  industry?: string | null;
}

export interface CompanyListResponse {
  status: number;
  /** @minLength 1 */
  message: string;
  data: Company[];
}

export interface ErrorDetails {
  status: number;
  /** @minLength 1 */
  message: string;
  /** @minLength 1 */
  traceback?: string;
}

export interface UnauthorizedError {
  error: ErrorDetails;
}

export interface ForbiddenError {
  error: ErrorDetails;
}

export interface InternalServerError {
  error: ErrorDetails;
}

export interface CompanyDetailResponse {
  status: number;
  /** @minLength 1 */
  message: string;
  data: Company;
}

export type ValidationErrorDetailDetails = {[key: string]: string[]};

export interface ValidationErrorDetail {
  status: number;
  /** @minLength 1 */
  message: string;
  details: ValidationErrorDetailDetails;
}

export interface ValidationError {
  error: ValidationErrorDetail;
}

export interface NotFoundError {
  error: ErrorDetails;
}

export interface Permission {
  readonly id?: number;
  /**
   * @minLength 1
   * @maxLength 255
   */
  name: string;
  /** @minLength 1 */
  description: string;
}

export type UserPreferredLanguage = 'en' | 'es';
export type UserColorSchemePreference = 'default' | 'light' | 'dark';
export type UserAssignableRolesItem = { [key: string]: unknown };

export interface User {
  id: number;
  /**
   * @minLength 1
   * @maxLength 50
   */
  username: string;
  /**
   * @maxLength 150
   * @nullable
   */
  first_name: string | null;
  /**
   * @maxLength 150
   * @nullable
   */
  last_name: string | null;
  /**
   * @minLength 1
   * @maxLength 254
   */
  email: string;
  is_verified?: boolean;
  is_active?: boolean;
  /**
   * @maxLength 255
   * @nullable
   */
  idp_id?: string | null;
  preferred_language: UserPreferredLanguage;
  color_scheme_preference: UserColorSchemePreference;
  address?: Address;
  organizations: number[];
  /** @nullable */
  last_selected_org: number | null;
  /** @nullable */
  readonly avatar?: string | null;
  readonly initials?: string;
  readonly permissions?: readonly Permission[];
  readonly assignable_roles?: readonly UserAssignableRolesItem[];
}

export interface CustomerSupport {
  /**
   * Customer support phone number
   * @minLength 1
   * @maxLength 20
   */
  phone_number: string;
  /**
   * Customer support email address
   * @minLength 1
   * @maxLength 254
   */
  email: string;
}

export interface GeneralError {
  error: ErrorDetails;
}

export interface CSRFTokenResponse {
  /** @minLength 1 */
  csrfToken: string;
}

export interface LoginRequest {
  /** @minLength 1 */
  email: string;
  /** @minLength 1 */
  password: string;
}

export interface UserResponse {
  user: User;
}

export interface UserLoginResponse {
  status: number;
  /** @minLength 1 */
  message: string;
  data: UserResponse;
}

export interface LogoutResponse {
  /** HTTP status code, e.g., 200 */
  status: number;
  /**
   * Status message
   * @minLength 1
   */
  message: string;
}

export interface OrganizationUser {
  readonly id?: number;
  /**
   * @minLength 1
   * @maxLength 254
   */
  email: string;
  /** @maxLength 150 */
  first_name?: string;
  /** @maxLength 150 */
  last_name?: string;
  readonly roles?: readonly string[];
  readonly is_owner?: boolean;
}

export interface Invitation {
  readonly id?: number;
  user: number;
  readonly user_email?: string;
  content_type: string;
  object_id: number;
  readonly token?: string;
  readonly is_accepted?: boolean;
  readonly roles?: string;
}

export interface OrganizationUsersAndInvitationsData {
  users: OrganizationUser[];
  invitations: Invitation[];
}

export interface OrganizationUsersAndInvitationsEnvelopeResponse {
  status: number;
  /** @minLength 1 */
  message: string;
  data: OrganizationUsersAndInvitationsData;
}

export interface Role {
  readonly id?: number;
  readonly created_at?: string;
  readonly updated_at?: string;
  /**
   * @minLength 1
   * @maxLength 255
   */
  name: string;
  /** @minLength 1 */
  description: string;
}

export interface SignupRequest {
  /** @minLength 1 */
  email: string;
  /** @minLength 1 */
  password: string;
  first_name?: string;
  last_name?: string;
  username?: string;
  address?: Address;
}

export interface UserSignupResponse {
  status: number;
  /** @minLength 1 */
  message: string;
  data: User;
}

export interface UserRole {
  readonly id?: number;
  user: number;
  role: number;
  organization: number;
  readonly created_at?: string;
  readonly updated_at?: string;
}

export type UserCreateInputPreferredLanguage = 'en' | 'es';
export type UserCreateInputColorSchemePreference = 'default' | 'light' | 'dark';
export interface UserCreateInput {
  /**
   * @minLength 1
   * @maxLength 50
   */
  username: string;
  /**
   * @maxLength 150
   * @nullable
   */
  first_name?: string | null;
  /**
   * @maxLength 150
   * @nullable
   */
  last_name?: string | null;
  /**
   * @minLength 1
   * @maxLength 254
   */
  email: string;
  /**
   * @minLength 1
   * @maxLength 128
   */
  password: string;
  preferred_language?: UserCreateInputPreferredLanguage;
  color_scheme_preference?: UserCreateInputColorSchemePreference;
  /**
   * @maxLength 255
   * @nullable
   */
  idp_id?: string | null;
  address?: Address;
}

export interface UserDetailData {
  user: User;
}

export interface UserDetailEnvelopeResponse {
  status: number;
  /** @minLength 1 */
  message: string;
  data: UserDetailData;
}

export interface BulkRemoveOrgRequest {
  /** Array of user IDs */
  ids: number[];
  /** Organization ID */
  org_id: number;
}

export interface MessageData {
  /** @minLength 1 */
  message: string;
}

export interface UserMessageEnvelopeResponse {
  status: number;
  /** @minLength 1 */
  message: string;
  data: MessageData;
}

export type UserUpdateInputPreferredLanguage = 'en' | 'es';
export type UserUpdateInputColorSchemePreference = 'default' | 'light' | 'dark';
export interface UserUpdateInput {
  /** @maxLength 150 */
  first_name?: string;
  /** @maxLength 150 */
  last_name?: string;
  /**
   * @minLength 1
   * @maxLength 254
   */
  email?: string;
  preferred_language?: UserUpdateInputPreferredLanguage;
  color_scheme_preference?: UserUpdateInputColorSchemePreference;
  address?: Address;
  organizations?: number[];
  /** @nullable */
  last_selected_org?: number | null;
  /** @nullable */
  readonly avatar?: string | null;
}

export interface UserPasswordUpdate {
  /** @minLength 1 */
  old_password: string;
  /** @minLength 1 */
  password: string;
}

export interface PasswordChangeEnvelopeResponse {
  status: number;
  /** @minLength 1 */
  message: string;
  data: MessageData;
}

export interface RemoveOrgRequest {
  /** Organization ID to remove */
  org_id: number;
}

export interface SessionUserData {
  user: User;
}

export interface ValidateSessionResponse {
  status: number;
  /** @minLength 1 */
  message: string;
  data: SessionUserData;
}

export interface VerifyEmailResult {
  success: boolean;
}

export interface VerifyEmailResponse {
  status: number;
  /** @minLength 1 */
  message: string;
  data: VerifyEmailResult;
}

export interface Image {
  readonly id?: string;
  readonly metadata?: string;
  readonly image_file?: string;
  created_at?: string;
  /** @nullable */
  campaign?: string | null;
}

export type AgricamMissionStatus = 'pending' | 'active' | 'completed' | 'failed' | 'cancelled';
export interface AgricamMission {
  readonly id?: string;
  /**
   * @minLength 1
   * @maxLength 200
   */
  name: string;
  /** @nullable */
  description?: string | null;
  status?: AgricamMissionStatus;
  /** @nullable */
  started_at?: string | null;
  /** @nullable */
  ended_at?: string | null;
  cruise_speed?: string;
  hover_speed?: string;
  /** @nullable */
  planned_home_lat?: string | null;
  /** @nullable */
  planned_home_lon?: string | null;
  /** @nullable */
  planned_home_alt?: string | null;
  geofence_inclusion?: boolean;
  /** @nullable */
  organization?: number | null;
  /** @nullable */
  campaign?: string | null;
}

export interface CrewCampaignSerializer {
  readonly id?: string;
  /** @minLength 1 */
  readonly name?: string;
  readonly status?: number;
  readonly organization_id?: number;
  /** @minLength 1 */
  readonly organization_name?: string;
  readonly created_at?: string;
  readonly updated_at?: string;
  readonly start_time?: string;
  readonly end_time?: string;
  readonly landing_url?: string;
  readonly has_active_session?: boolean;
}

export interface CrewCampaignListEnvelope {
  status: number;
  /** @minLength 1 */
  message: string;
  data: CrewCampaignSerializer[];
}

export interface SharedSessionResponse {
  readonly id?: string;
  /**
   * @minLength 1
   * @nullable
   */
  readonly name?: string | null;
  readonly enabled?: boolean;
  readonly device_uuid?: string;
  readonly user_id?: number;
  readonly organization_id?: number;
  /** @nullable */
  readonly campaign_id?: string | null;
  /**
   * @minLength 1
   * @nullable
   */
  readonly campaign_name?: string | null;
  /** @nullable */
  readonly last_ping_at?: string | null;
  readonly viewer_count?: number;
  readonly created_by?: number;
  readonly updated_by?: number;
  readonly created_at?: string;
  readonly updated_at?: string;
  readonly crew_base_url?: string;
  readonly landing_url?: string;
  readonly video_url?: string;
}

export interface CampaignSessionEnvelope {
  status: number;
  /** @minLength 1 */
  message: string;
  data: SharedSessionResponse;
}

export interface SharedSession {
  readonly id?: string;
  /** @minLength 1 */
  readonly name?: string;
  readonly enabled?: boolean;
  readonly device_uuid?: string;
  /** @minLength 1 */
  readonly device_name?: string;
  readonly user_id?: number;
  readonly organization_id?: number;
  /** @nullable */
  readonly campaign_id?: string | null;
  /**
   * @minLength 1
   * @nullable
   */
  readonly campaign_name?: string | null;
  readonly created_by?: number;
  readonly updated_by?: number;
  readonly created_at?: string;
  readonly updated_at?: string;
}

export interface SharedSessionListEnvelope {
  status: number;
  /** @minLength 1 */
  message: string;
  data: SharedSession[];
}

export interface CreateSharedSessionRequest {
  /** Device UUID (unique per device). */
  device_uuid: string;
  /**
   * Campaign ID (optional).
   * @nullable
   */
  campaign_id?: string | null;
  /**
   * Optional name for the shared session.
   * @minLength 1
   * @nullable
   */
  name?: string | null;
}

export interface SharedSessionCreateEnvelope {
  status: number;
  /** @minLength 1 */
  message: string;
  data: SharedSessionResponse;
}

export interface SharedSessionEnvelope {
  status: number;
  /** @minLength 1 */
  message: string;
  data: SharedSessionResponse;
}

export interface CrewEmpty { [key: string]: unknown }

export interface ATCStartCommandRequest {
  /**
   * Optional list of device UUIDs to include in the ATC start-turn dispatch. If omitted, null, or empty, the server may fall back to CREW_ATC_DEMO_DEVICES.
   * @nullable
   */
  device_uuids?: string[] | null;
}

export interface ATCCommandResponse {
  session_id: string;
  participant_id: string;
  /** @minLength 1 */
  agent_identity: string;
  /** @minLength 1 */
  rpc_topic: string;
  agent_response: string;
  dispatched_drones: string[];
}

export interface ATCCommandEnvelope {
  status: number;
  /** @minLength 1 */
  message: string;
  data: ATCCommandResponse;
}

export interface SharedSessionParticipant {
  readonly id?: string;
  readonly shared_session_id?: string;
  readonly user_id?: number;
  /** @nullable */
  readonly anon_id?: string | null;
  /**
   * @minLength 1
   * @nullable
   */
  readonly display_name?: string | null;
  readonly is_authenticated?: boolean;
  readonly is_online?: boolean;
  readonly first_seen?: string;
  readonly last_seen?: string;
  readonly join_count?: number;
  readonly created_at?: string;
  readonly updated_at?: string;
}

export interface ParticipantListEnvelope {
  status: number;
  /** @minLength 1 */
  message: string;
  data: SharedSessionParticipant[];
}

export interface ParticipantCreateAnonymousRequest {
  /**
   * Optional display name (write-once). If omitted, server auto-generates.
   * @maxLength 64
   * @nullable
   */
  display_name?: string | null;
}

export interface ParticipantEnvelope {
  status: number;
  /** @minLength 1 */
  message: string;
  data: SharedSessionParticipant;
}

export type TelemetryPointRawJson = { [key: string]: unknown };

export interface TelemetryPoint {
  timestamp: string;
  /**
   * @minLength 1
   * @nullable
   */
  latitude: string | null;
  /**
   * @minLength 1
   * @nullable
   */
  longitude: string | null;
  /**
   * @minLength 1
   * @nullable
   */
  absolute_altitude: string | null;
  /**
   * @minLength 1
   * @nullable
   */
  remaining_percent: string | null;
  /**
   * @minLength 1
   * @nullable
   */
  duration_since_takeoff_ms: string | null;
  raw_json: TelemetryPointRawJson;
}

export interface TelemetryListResponse {
  results: TelemetryPoint[];
  count: number;
  /**
   * @minLength 1
   * @nullable
   */
  next?: string | null;
  /**
   * @minLength 1
   * @nullable
   */
  previous?: string | null;
}

export interface CrewTelemetryListEnvelope {
  status: number;
  /** @minLength 1 */
  message: string;
  data: TelemetryListResponse;
}

export interface VoiceChatCredentialsResponse {
  /**
   * Access token for joining the voice chat room
   * @minLength 1
   */
  token: string;
  /**
   * Voice chat provider server URL
   * @minLength 1
   */
  url: string;
  /**
   * Room name to join
   * @minLength 1
   */
  room_name: string;
  /** Shared session ID */
  session_id: string;
  /** Participant ID */
  participant_id: string;
  /**
   * Voice chat provider type (e.g., 'livekit')
   * @minLength 1
   */
  provider: string;
}

export interface VoiceChatCredentialsEnvelope {
  status: number;
  /** @minLength 1 */
  message: string;
  data: VoiceChatCredentialsResponse;
}

export interface VoiceChatJoinRequest {
  /**
   * User email address
   * @minLength 1
   */
  email: string;
}

export interface VoiceChatJoinRequestEnvelope {
  status: number;
  /** @minLength 1 */
  message: string;
  data: VoiceChatJoinRequest;
}

export interface DeviceNested {
  id: string;
  /**
   * @minLength 1
   * @nullable
   */
  name?: string | null;
  device_uuid: string;
}

export type CampaignStatus = 0 | 1;
export interface Campaign {
  id: string;
  /**
   * @minLength 1
   * @maxLength 255
   */
  name: string;
  /** @minLength 1 */
  description: string;
  users: number[];
  status: CampaignStatus;
  /** @nullable */
  organization: number | null;
  /** @nullable */
  start_time: string | null;
  /** @nullable */
  end_time: string | null;
  /** @nullable */
  readonly created_by?: string | null;
  readonly created_at?: string;
  readonly device_details?: readonly DeviceNested[];
  chats: (number | null)[];
  preflight_checks: string[];
  postflight_checks: string[];
  enable_vantis_send: boolean;
  readonly missions?: readonly string[];
  /** Devices associated with the campaign (preferred). Provide a list of device_uuid strings. */
  devices?: string[];
}

export type CampaignCreateInputStatus = 0 | 1;
export interface CampaignCreateInput {
  /**
   * @minLength 1
   * @maxLength 255
   */
  name: string;
  /** @nullable */
  description: string | null;
  status: CampaignCreateInputStatus;
  /** @nullable */
  organization: number | null;
  /** Devices associated with the campaign (preferred). Provide a list of device_uuid strings. */
  devices?: string[];
  enable_vantis_send: boolean;
}

export interface CampaignCreateResponse {
  campaign: Campaign;
}

export interface CompaignCreateResponseEnvelope {
  status: number;
  /** @minLength 1 */
  message: string;
  data: CampaignCreateResponse;
}

export interface CampaignUserUpdateInput {
  campaign_id: string;
}

export interface MessageSerializer {
  /** @minLength 1 */
  message: string;
}

export interface MessageResponseEnvelope {
  status: number;
  /** @minLength 1 */
  message: string;
  data: MessageSerializer;
}

export interface CampaignListResponse {
  campaigns: Campaign[];
}

export interface CampaignListEnvelopeResponse {
  status: number;
  /** @minLength 1 */
  message: string;
  data: CampaignListResponse;
}

export interface NoneResponse { [key: string]: unknown }

export interface NoneResponseEnvelope {
  status: number;
  /** @minLength 1 */
  message: string;
  data: NoneResponse;
}

export interface CampaignUpdateInput { [key: string]: unknown }

export interface CampaignUpdateResponse {
  campaign: Campaign;
}

export interface CompaignUpdateResponseEnvelope {
  status: number;
  /** @minLength 1 */
  message: string;
  data: CampaignUpdateResponse;
}

export interface CampaignGetUsersResponse {
  users: User[];
}

export type DeviceTypeDetailCategory = 'DRONE' | 'SENSOR' | 'CAMERA' | 'CONTROLLER' | 'STATION' | 'OTHER';
export interface DeviceTypeDetail {
  readonly id?: string;
  /**
   * @minLength 1
   * @maxLength 100
   */
  name: string;
  description?: string;
  category: DeviceTypeDetailCategory;
  /** @minLength 1 */
  readonly manufacturer_name?: string;
  /**
   * @maxLength 100
   * @nullable
   */
  model_name?: string | null;
  /** @maxLength 100 */
  model_number?: string;
  /**
   * @maxLength 100
   * @nullable
   */
  hardware_id?: string | null;
  readonly thumbnail?: string;
  readonly images?: string;
}

export interface DeviceSettingSpecification {
  readonly id?: number;
  /** @minLength 1 */
  readonly setting_type_name?: string;
  /** @minLength 1 */
  readonly setting_type_type?: string;
  /** @nullable */
  string_value?: string | null;
  /** @nullable */
  number_value?: string | null;
  /** @nullable */
  boolean_value?: boolean | null;
  /** @nullable */
  date_value?: string | null;
}

export interface DeviceDetail {
  readonly id?: string;
  /**
   * @maxLength 100
   * @nullable
   */
  name?: string | null;
  device_type?: DeviceTypeDetail;
  description?: string;
  is_active?: boolean;
  /**
   * @minLength 1
   * @maxLength 15
   */
  serial_number: string;
  /**
   * @maxLength 20
   * @nullable
   */
  remote_id_number?: string | null;
  /**
   * @maxLength 10
   * @nullable
   */
  faa_reg_number?: string | null;
  /** @nullable */
  readonly thumbnail?: string | null;
  /** @nullable */
  readonly image?: string | null;
  /** @nullable */
  release_date?: string | null;
  readonly created_at?: string;
  readonly updated_at?: string;
  device_uuid: string;
  readonly setting_specifications?: readonly DeviceSettingSpecification[];
  readonly heart_beat?: string;
  readonly last_seen?: string;
}

export interface DeviceRetrieveApiResponse {
  status: number;
  /** @minLength 1 */
  message: string;
  data: DeviceDetail;
}

export type DeviceTypeCategory = 'DRONE' | 'SENSOR' | 'CAMERA' | 'CONTROLLER' | 'STATION' | 'OTHER';
export interface DeviceType {
  readonly id?: string;
  /** @nullable */
  readonly image?: string | null;
  readonly thumbnail?: string;
  readonly images?: string;
  readonly created_at?: string;
  readonly updated_at?: string;
  /**
   * @minLength 1
   * @maxLength 100
   */
  name: string;
  description?: string;
  /**
   * @maxLength 100
   * @nullable
   */
  model_name?: string | null;
  /** @maxLength 100 */
  model_number: string;
  category: DeviceTypeCategory;
  /**
   * @maxLength 100
   * @nullable
   */
  hardware_id?: string | null;
  /** @nullable */
  manufacturer?: number | null;
}

export interface Device {
  readonly id?: string;
  /**
   * @minLength 1
   * @nullable
   */
  readonly name?: string | null;
  readonly device_type?: string;
  /** @minLength 1 */
  readonly description?: string;
  readonly is_active?: boolean;
  /** @minLength 1 */
  readonly serial_number?: string;
  readonly device_uuid?: string;
  /**
   * @minLength 1
   * @nullable
   */
  readonly faa_reg_number?: string | null;
  /** @nullable */
  readonly thumbnail?: string | null;
  /** @nullable */
  readonly image?: string | null;
  /** @nullable */
  readonly organization?: number | null;
  readonly heart_beat?: string;
  readonly last_seen?: string;
}

export interface DeviceListResponse {
  results: Device[];
  count: number;
  /**
   * @minLength 1
   * @nullable
   */
  next?: string | null;
  /**
   * @minLength 1
   * @nullable
   */
  previous?: string | null;
}

export interface DeviceListApiResponse {
  status: number;
  /** @minLength 1 */
  message: string;
  data: DeviceListResponse;
}

export interface DeviceCreate {
  /**
   * @maxLength 100
   * @nullable
   */
  name?: string | null;
  device_type: string;
  description?: string;
  is_active?: boolean;
  /**
   * @minLength 1
   * @maxLength 15
   */
  serial_number: string;
  device_uuid: string;
  /**
   * @maxLength 10
   * @nullable
   */
  faa_reg_number?: string | null;
  /** @nullable */
  readonly thumbnail?: string | null;
  /** @nullable */
  readonly image?: string | null;
  /** @nullable */
  organization?: number | null;
}

export interface DeviceCreateApiResponse {
  status: number;
  /** @minLength 1 */
  message: string;
  data: Device;
}

export interface DeviceRegistrationStatusResponse {
  /** @minLength 1 */
  device_uuid: string;
  is_registered: boolean;
  /**
   * @minLength 1
   * @nullable
   */
  organization: string | null;
}

export interface DeviceRegistrationStatusApiResponse {
  status: number;
  /** @minLength 1 */
  message: string;
  data: DeviceRegistrationStatusResponse;
}

export interface DeviceRegistrationRequest {
  /** Device UUID to register */
  device_uuid: string;
}

export interface DeviceRegistrationResponse {
  id: string;
  device_uuid: string;
  /**
   * @minLength 1
   * @nullable
   */
  organization: string | null;
}

export interface DeviceRegistrationApiResponse {
  status: number;
  /** @minLength 1 */
  message: string;
  data: DeviceRegistrationResponse;
}

export interface DeviceUnregistrationRequest {
  /** Device UUID to unregister */
  device_uuid: string;
}

export interface DeviceUpdateRequest {
  /**
   * Device name
   * @minLength 1
   */
  name?: string;
  /**
   * Device description
   * @minLength 1
   */
  description?: string;
  /** Device active status */
  is_active?: boolean;
  /**
   * FAA registration number
   * @minLength 1
   */
  faa_reg_number?: string;
}

export interface DeviceUpdateApiResponse {
  status: number;
  /** @minLength 1 */
  message: string;
  data: Device;
}

export interface SuccessObj {
  success: boolean;
}

export interface DeviceDeleteApiResponse {
  status: number;
  /** @minLength 1 */
  message: string;
  data: SuccessObj;
}

export interface DroneModel {
  readonly id?: number;
  /**
   * @maxLength 255
   * @nullable
   */
  manufacturer?: string | null;
  /**
   * @minLength 1
   * @maxLength 255
   */
  name: string;
  /**
   * @maxLength 255
   * @nullable
   */
  type?: string | null;
  /** @nullable */
  description?: string | null;
  /** @nullable */
  configuration?: string | null;
  readonly created_at?: string;
  readonly updated_at?: string;
}

/**
 * @nullable
 */
export type BatteryInfo = {
  readonly id?: number;
  /** in mAh */
  battery_capacity: number;
  /**
   * @minLength 1
   * @maxLength 100
   */
  battery_type: string;
  /**
   * @minLength 1
   * @maxLength 100
   */
  battery_model_number: string;
  /** percentage */
  battery_backup: number;
} | null;

/**
 * @nullable
 */
export type PerformanceCharacteristic = {
  readonly id?: number;
  /** in meters per second */
  maximum_speed: number;
  /** in meters */
  maximum_altitude: number;
  /** in kilometers */
  maximum_range: number;
  /** in minutes */
  flight_time: number;
} | null;

export interface DroneProfile {
  readonly id?: number;
  /**
   * @minLength 1
   * @maxLength 100
   */
  name: string;
  /**
   * @minLength 1
   * @nullable
   */
  ip_address?: string | null;
  /** @nullable */
  flight_operations_site?: number | null;
  organization: number;
  battery_info?: BatteryInfo;
  performance_characteristics?: PerformanceCharacteristic;
  /**
   * @maxLength 100
   * @nullable
   */
  mac_address?: string | null;
  /**
   * List of sensors and specifications
   * @nullable
   */
  sensors?: string | null;
  drone_model: number;
  /** @minLength 1 */
  readonly drone_model_name?: string;
  /**
   * @minLength 1
   * @maxLength 100
   */
  eid: string;
  /** @nullable */
  device_uuid?: string | null;
}

/**
 * @nullable
 */
export type DroneHeartBeatIpAddresses = { [key: string]: unknown } | null;

/**
 * @nullable
 */
export type DroneHeartBeatIpEth0 = { [key: string]: unknown } | null;

/**
 * @nullable
 */
export type DroneHeartBeatIpWlan0 = { [key: string]: unknown } | null;

/**
 * @nullable
 */
export type DroneHeartBeatIpDocker0 = { [key: string]: unknown } | null;

/**
 * @nullable
 */
export type DroneHeartBeatIpBrCe35e312a760 = { [key: string]: unknown } | null;

/**
 * @nullable
 */
export type DroneHeartBeatIpVeth5c573f7 = { [key: string]: unknown } | null;

/**
 * @nullable
 */
export type DroneHeartBeatIpWg0 = { [key: string]: unknown } | null;

/**
 * @nullable
 */
export type DroneHeartBeatCpuLoad = { [key: string]: unknown } | null;

/**
 * @nullable
 */
export type DroneHeartBeatMemory = { [key: string]: unknown } | null;

/**
 * @nullable
 */
export type DroneHeartBeatDiskIo = { [key: string]: unknown } | null;

/**
 * @nullable
 */
export type DroneHeartBeatNetworkUsage = { [key: string]: unknown } | null;

/**
 * @nullable
 */
export type DroneHeartBeatPacketStatistics = { [key: string]: unknown } | null;

/**
 * @nullable
 */
export type DroneHeartBeatNodesMetrics = { [key: string]: unknown } | null;

/**
 * @nullable
 */
export type DroneHeartBeatRawJson = { [key: string]: unknown } | null;

export interface DroneHeartBeat {
  readonly id?: number;
  timestamp: string;
  /** @nullable */
  device_uuid?: string | null;
  /**
   * @maxLength 50
   * @nullable
   */
  device_uuid_source?: string | null;
  /** @nullable */
  ip_addresses?: DroneHeartBeatIpAddresses;
  /** @nullable */
  ip_eth0?: DroneHeartBeatIpEth0;
  /** @nullable */
  ip_wlan0?: DroneHeartBeatIpWlan0;
  /** @nullable */
  ip_docker0?: DroneHeartBeatIpDocker0;
  /** @nullable */
  ip_br_ce35e312a760?: DroneHeartBeatIpBrCe35e312a760;
  /** @nullable */
  ip_veth5c573f7?: DroneHeartBeatIpVeth5c573f7;
  /** @nullable */
  ip_wg0?: DroneHeartBeatIpWg0;
  /** @nullable */
  cpu_temperature?: number | null;
  /**
   * @minimum -9223372036854776000
   * @maximum 9223372036854776000
   * @nullable
   */
  interrupts?: number | null;
  /**
   * @minimum -2147483648
   * @maximum 2147483647
   * @nullable
   */
  uptime_seconds?: number | null;
  /**
   * @minimum -2147483648
   * @maximum 2147483647
   * @nullable
   */
  battery_percentage?: number | null;
  /** @nullable */
  cpu_load?: DroneHeartBeatCpuLoad;
  /** @nullable */
  memory?: DroneHeartBeatMemory;
  /** @nullable */
  disk_io?: DroneHeartBeatDiskIo;
  /** @nullable */
  network_usage?: DroneHeartBeatNetworkUsage;
  /** @nullable */
  packet_statistics?: DroneHeartBeatPacketStatistics;
  /** @nullable */
  nodes_metrics?: DroneHeartBeatNodesMetrics;
  /**
   * Type of connection (e.g., 4G, 5G, WiFi, Ethernet)
   * @maxLength 50
   * @nullable
   */
  connection_type?: string | null;
  /** @nullable */
  raw_json?: DroneHeartBeatRawJson;
  readonly created_at?: string;
  /** @nullable */
  drone?: number | null;
  /** @nullable */
  device?: string | null;
}

export interface Manufacturer {
  readonly id?: number;
  address: Address;
  /**
   * @minLength 1
   * @maxLength 255
   */
  name: string;
  /** @nullable */
  founded_at?: string | null;
  /**
   * @maxLength 255
   * @nullable
   */
  website?: string | null;
  /**
   * @maxLength 255
   * @nullable
   */
  email?: string | null;
  /**
   * @maxLength 20
   * @nullable
   */
  phone_number?: string | null;
  /** @nullable */
  description?: string | null;
  /** @nullable */
  readonly logo?: string | null;
  is_active?: boolean;
}

/**
 * @nullable
 */
export type MissionStepNavKind = 'TAKEOFF' | 'WAYPOINT' | 'RTH' | 'ORBIT' | null;
/**
 * @nullable
 */
export type MissionStepAux = { [key: string]: unknown } | null;

export interface MissionStep {
  /**
   * @minimum -2147483648
   * @maximum 2147483647
   */
  order: number;
  /**
   * @maxLength 120
   * @nullable
   */
  label?: string | null;
  /** @nullable */
  speed_mps?: string | null;
  /**
   * @maxLength 10
   * @nullable
   */
  camera_mode?: string | null;
  /** @nullable */
  nav_kind: MissionStepNavKind;
  /** @nullable */
  aux?: MissionStepAux;
  lat?: number;
  lon?: number;
  alt_m?: number;
  /** @nullable */
  pitch?: number | null;
  /** @nullable */
  hold_time?: number | null;
  /** @nullable */
  accept_radius?: number | null;
  /** @nullable */
  pass_radius?: number | null;
  /** @nullable */
  yaw?: number | null;
  /** @nullable */
  turns?: number | null;
}

export interface MissionSequence {
  /**
   * @minimum -2147483648
   * @maximum 2147483647
   */
  order?: number;
  steps: MissionStep[];
}

export type MissionStatus = 'pending' | 'active' | 'completed' | 'failed' | 'cancelled';
export interface Mission {
  readonly id?: string;
  readonly campaign?: string;
  tags?: string[];
  readonly sequences?: readonly MissionSequence[];
  /**
   * @minLength 1
   * @maxLength 200
   */
  name: string;
  /** @nullable */
  description?: string | null;
  status?: MissionStatus;
  /** @nullable */
  started_at?: string | null;
  /** @nullable */
  ended_at?: string | null;
  cruise_speed?: string;
  hover_speed?: string;
  /** @nullable */
  planned_home_lat?: string | null;
  /** @nullable */
  planned_home_lon?: string | null;
  /** @nullable */
  planned_home_alt?: string | null;
  geofence_inclusion?: boolean;
  /** @nullable */
  organization?: number | null;
}

export interface MissionListApiResponse {
  status: number;
  /** @minLength 1 */
  message: string;
  data: Mission[];
}

/**
 * Mission status
 */
export type MissionCreateRequestStatus = 'pending' | 'active' | 'completed' | 'failed' | 'cancelled';
export interface MissionCreateRequest {
  /**
   * Mission name
   * @minLength 1
   */
  name: string;
  /**
   * Mission description
   * @minLength 1
   */
  description?: string;
  /** Mission status */
  status?: MissionCreateRequestStatus;
  /** Campaign ID */
  campaign?: string;
  /** Cruise speed in m/s */
  cruise_speed?: number;
  /** Hover speed in m/s */
  hover_speed?: number;
  /** Geofence inclusion flag */
  geofence_inclusion?: boolean;
  /** Mission sequences */
  sequences: MissionSequence[];
}

export interface MissionCreateApiResponse {
  status: number;
  /** @minLength 1 */
  message: string;
  data: Mission;
}

export interface MissionDetailApiResponse {
  status: number;
  /** @minLength 1 */
  message: string;
  data: Mission;
}

export interface MissionUpdateApiResponse {
  status: number;
  /** @minLength 1 */
  message: string;
  data: Mission;
}

export type MissionQgcGeoFenceCirclesItem = {[key: string]: string | null};

export type MissionQgcGeoFencePolygonsItem = {[key: string]: string | null};

export interface MissionQgcGeoFence {
  circles: MissionQgcGeoFenceCirclesItem[];
  polygons: MissionQgcGeoFencePolygonsItem[];
  version: number;
}

export interface MissionQgcMissionItem {
  autoContinue: boolean;
  command: number;
  doJumpId: number;
  frame: number;
  /** @minLength 1 */
  type: string;
  /**
   * @minItems 7
   * @maxItems 7
   */
  params: number[];
  /** @nullable */
  Altitude?: number | null;
  AltitudeMode?: number;
  /** @nullable */
  AMSLAltAboveTerrain?: number | null;
}

export interface MissionQgcMission {
  cruiseSpeed: number;
  firmwareType: number;
  globalPlanAltitudeMode: number;
  hoverSpeed: number;
  items: MissionQgcMissionItem[];
  /**
   * @minItems 3
   * @maxItems 3
   */
  plannedHomePosition: number[];
  vehicleType: number;
  version: number;
}

export type MissionQgcRallyPointsPointsItem = {[key: string]: string | null};

export interface MissionQgcRallyPoints {
  points: MissionQgcRallyPointsPointsItem[];
  version: number;
}

/**
 * Mission in QGroundControl format
 */
export interface MissionQgcPayload {
  /** @minLength 1 */
  fileType: string;
  geoFence: MissionQgcGeoFence;
  /** @minLength 1 */
  groundStation: string;
  mission: MissionQgcMission;
  rallyPoints: MissionQgcRallyPoints;
  version: number;
}

export interface MissionQgc {
  payload: MissionQgcPayload;
}

export interface MissionQgcApiResponse {
  status: number;
  /** @minLength 1 */
  message: string;
  data: MissionQgc;
}

export interface PartnerAssociationResponse {
  rule_id?: string;
  already_associated?: boolean;
}

export interface PartnerAssociationEnvelope {
  status: number;
  /** @minLength 1 */
  message: string;
  data: PartnerAssociationResponse;
}

export interface PartnerDisassociateResponse {
  success: boolean;
}

export interface PartnerDisassociateEnvelope {
  status: number;
  /** @minLength 1 */
  message: string;
  data: PartnerDisassociateResponse;
}

export type StartSessionRequestProvider = 'dronesense' | 'other';
export interface StartSessionRequest {
  provider: StartSessionRequestProvider;
  /**
   * @minLength 1
   * @maxLength 128
   */
  pilot_email: string;
  /**
   * @minLength 1
   * @maxLength 128
   */
  device_id: string;
  /** @minimum 60 */
  session_ttl_sec?: number;
}

export type IntegrationSessionProvider = 'dronesense' | 'other';
/**
 * @nullable
 */
export type IntegrationSessionMetadata = { [key: string]: unknown } | null;

export interface IntegrationSession {
  readonly id?: string;
  device: string;
  /** @minLength 1 */
  readonly device_serial_number?: string;
  provider: IntegrationSessionProvider;
  /**
   * @minLength 1
   * @maxLength 64
   */
  source_drone_id: string;
  /**
   * @minLength 1
   * @maxLength 256
   */
  pilot_email: string;
  /**
   * @minLength 1
   * @maxLength 128
   */
  mqtt_username: string;
  expires_at: string;
  /** @nullable */
  ended_at?: string | null;
  is_active?: boolean;
  /** @nullable */
  last_activity?: string | null;
  /** @nullable */
  metadata?: IntegrationSessionMetadata;
  readonly created_at?: string;
}

export interface IntegrationStartSessionEnvelope {
  status: number;
  /** @minLength 1 */
  message: string;
  data: IntegrationSession;
}

export type StopSessionRequestProvider = 'dronesense' | 'other';
export interface StopSessionRequest {
  provider: StopSessionRequestProvider;
  /**
   * @minLength 1
   * @maxLength 128
   */
  device_id: string;
}

export interface IntegrationStopSessionEnvelope {
  status: number;
  /** @minLength 1 */
  message: string;
  data: IntegrationSession;
}

export interface VideoServerRead {
  /**
   * Unique identifier for the video server (e.g., 'vs-eu-1')
   * @minLength 1
   * @maxLength 100
   */
  id: string;
  /**
   * Geographic region of the server (e.g., 'eu-central', 'us-east')
   * @minLength 1
   * @maxLength 100
   */
  region: string;
  /**
   * WHEP endpoint URL for the video server
   * @minLength 1
   * @maxLength 500
   */
  whep_url: string;
  /** Whether this server is active and should be broadcast */
  enabled?: boolean;
  /**
   * Optional description or notes about this server
   * @nullable
   */
  description?: string | null;
  readonly created_at?: string;
  readonly updated_at?: string;
  /**
   * User who created this server entry
   * @nullable
   */
  readonly created_by?: number | null;
  /**
   * User who last updated this server entry
   * @nullable
   */
  readonly updated_by?: number | null;
}

export interface VideoServerListResponse {
  status: number;
  /** @minLength 1 */
  message: string;
  data: VideoServerRead[];
}

export interface VideoServerCreate {
  /**
   * Unique identifier for the video server (e.g., 'vs-eu-1')
   * @minLength 1
   * @maxLength 100
   */
  id: string;
  /**
   * Geographic region of the server (e.g., 'eu-central', 'us-east')
   * @minLength 1
   * @maxLength 100
   */
  region: string;
  /**
   * WHEP endpoint URL for the video server
   * @minLength 1
   * @maxLength 500
   */
  whep_url: string;
  /** Whether this server is active and should be broadcast */
  enabled?: boolean;
  /**
   * Optional description or notes about this server
   * @nullable
   */
  description?: string | null;
}

export interface VideoServerDetailResponse {
  status: number;
  /** @minLength 1 */
  message: string;
  data: VideoServerRead;
}

export type VideoServerBroadcastResultStatus = 'success' | 'queued' | 'success_after_retry';
export interface VideoServerBroadcastResult {
  status: VideoServerBroadcastResultStatus;
  server_count: number;
  /** @minLength 1 */
  updated_at: string;
  /** @nullable */
  message_id?: number | null;
}

export interface VideoServerBroadcast {
  /**
   * Unique identifier for the video server (e.g., 'vs-eu-1')
   * @minLength 1
   * @maxLength 100
   */
  id: string;
  /** @minLength 1 */
  url: string;
  /**
   * Geographic region of the server (e.g., 'eu-central', 'us-east')
   * @minLength 1
   * @maxLength 100
   */
  region: string;
}

export interface VideoServerEnabledList {
  count: number;
  servers: VideoServerBroadcast[];
}

export interface VideoServerUpdate {
  /**
   * Unique identifier for the video server (e.g., 'vs-eu-1')
   * @minLength 1
   */
  readonly id?: string;
  /**
   * Geographic region of the server (e.g., 'eu-central', 'us-east')
   * @minLength 1
   * @maxLength 100
   */
  region?: string;
  /**
   * WHEP endpoint URL for the video server
   * @minLength 1
   * @maxLength 500
   */
  whep_url?: string;
  /** Whether this server is active and should be broadcast */
  enabled?: boolean;
  /**
   * Optional description or notes about this server
   * @nullable
   */
  description?: string | null;
}

export type ManufacturerBody = Manufacturer;

export type UserRoleBody = UserRole;

export type DeviceTypeBody = DeviceType;

export type VideoServerUpdateBody = VideoServerUpdate;

export type CrewEmptyBody = CrewEmpty;

export type AddressBody = Address;

export type CompanyBody = Company;

export type RoleBody = Role;

export type UserUpdateInputBody = UserUpdateInput;

export type CampaignUserUpdateInputBody = CampaignUserUpdateInput;

export type CampaignUpdateInputBody = CampaignUpdateInput;

export type DroneModelBody = DroneModel;

export type DroneProfileBody = DroneProfile;

export type MissionBody = Mission;

/**
 * Preferred color scheme option
 */
export type AccountApiUpdateColorSchemePreferencePartialUpdateBodyColorSchemePreference = 'default' | 'light' | 'dark';
export type AccountApiUpdateColorSchemePreferencePartialUpdateBody = {
  /** Preferred color scheme option */
  color_scheme_preference: AccountApiUpdateColorSchemePreferencePartialUpdateBodyColorSchemePreference;
};

export type AccountCompaniesDelete204Data = {
  success?: boolean;
};

export type AccountCompaniesDelete204 = {
  status?: number;
  message?: string;
  data?: AccountCompaniesDelete204Data;
};

export type AccountRequestResetPasswordCreateBody = {
  /** User's email address */
  email: string;
};

export type AccountResetPasswordCreateBody = {
  /** Reset token */
  token: string;
  /** New password */
  new_password: string;
};

export type AccountUserrolesCreateBody = {
  /** ID of the user to assign the role */
  user_id: number;
  /** ID of the role to assign */
  role_id: number;
  /** ID of the organization the role is assigned within */
  organization_id: number;
};

export type AccountUserrolesCreate201 = {
  /** ID of the user to assign the role */
  user_id: number;
  /** ID of the role to assign */
  role_id: number;
  /** ID of the organization the role is assigned within */
  organization_id: number;
};

export type AccountUserrolesBulkUpdateBody = {
  /** Array of user role IDs to update */
  ids: number[];
  /** Role ID to assign to the users */
  role_id: number;
};

export type AccountUserrolesBulkUpdate200 = {
  /** Array of user role IDs to update */
  ids: number[];
  /** Role ID to assign to the users */
  role_id: number;
};

/**
 * Metadata associated with the image
 */
export type AgricamImagesUploadCreateBodyMetadata = { [key: string]: unknown };

export type AgricamImagesUploadCreateBody = {
  /** The image file to upload */
  image_file: Blob;
  /** Metadata associated with the image */
  metadata: AgricamImagesUploadCreateBodyMetadata;
  /** UUID of the device to associate the image with */
  device_uuid: string;
};

export type AgricamMissionsCreateBody = {
  /** name of the mission */
  name: string;
  /** user who created the mission */
  created_by: string;
  /** status of the mission */
  status: string;
};

export type CrewCampaignsListParams = {
/**
 * Filter campaigns by status. 1=Active, 0=Inactive
 */
status?: CrewCampaignsListStatus;
/**
 * If provided, list only campaigns in the organization that owns this device (must also be an org the user belongs to).
 */
device_uuid?: string;
};

export type CrewCampaignsListStatus = 0 | 1;
export type CrewCampaignsSessionRedirect404Data = {
  campaign_id?: string;
  campaign_name?: string;
  has_active_session?: boolean;
};

export type CrewCampaignsSessionRedirect404 = {
  status?: number;
  message?: string;
  data?: CrewCampaignsSessionRedirect404Data;
};

export type CrewSharedSessionsListParams = {
/**
 * Filter sessions by status. Defaults to 'enabled'.
 */
status?: CrewSharedSessionsListStatus;
/**
 * Ordering field (default: -created_at). Examples: -created_at, created_at
 */
ordering?: string;
/**
 * Filter by device UUID
 */
device_uuid?: string;
};

export type CrewSharedSessionsListStatus = 'enabled' | 'disabled' | 'all';
export type CrewSharedSessionsByOrganizationParams = {
/**
 * Filter sessions by status. Defaults to 'enabled'.
 */
status?: CrewSharedSessionsByOrganizationStatus;
/**
 * Ordering field (default: -created_at). Examples: -created_at, created_at
 */
ordering?: string;
/**
 * Filter by device UUID
 */
device_uuid?: string;
};

export type CrewSharedSessionsByOrganizationStatus = 'enabled' | 'disabled' | 'all';
export type CrewSharedSessionsParticipantsDeviceTelemetryListParams = {
/**
 * ISO-8601 with timezone (e.g. 2025-10-21T12:00:00Z). Default: earliest telemetry for device.
 */
start?: string;
/**
 * ISO-8601 with timezone. Default: now (UTC).
 */
end?: string;
/**
 * Downsample window in seconds (optional). If absent, returns raw points.
 * @minimum 1
 */
resolution?: number;
/**
 * @minimum 1
 */
limit?: number;
/**
 * @minimum 0
 */
offset?: number;
};

export type CrewSharedSessionsParticipantsVoiceChatCredentialsCreateBody = { [key: string]: unknown };

export type CrewTerrainCarpetListParams = {
/**
 * Comma-separated coordinates defining the bounding box. Format: 'lat1,lon1,lat2,lon2' (e.g., '37.78,-122.45,37.79,-122.44')
 */
points: string;
};

export type CrewTerrainCarpetList200DataBounds = {
  ne?: number[];
  sw?: number[];
};

export type CrewTerrainCarpetList200DataStats = {
  avg?: number;
  max?: number;
  min?: number;
};

export type CrewTerrainCarpetList200Data = {
  bounds?: CrewTerrainCarpetList200DataBounds;
  /** 2D array of elevation values */
  carpet?: number[][];
  stats?: CrewTerrainCarpetList200DataStats;
};

export type CrewTerrainCarpetList200 = {
  status?: string;
  data?: CrewTerrainCarpetList200Data;
};

export type DroneCommanderDeviceTypesList200DataItem = {
  id?: string;
  name?: string;
  description?: string;
  model_name?: string;
  model_number?: string;
  category?: string;
  manufacturer?: string;
  hardware_id?: string;
  image?: string;
  thumbnail?: string;
  created_at?: string;
  updated_at?: string;
};

export type DroneCommanderDeviceTypesList200 = {
  status?: number;
  message?: string;
  data?: DroneCommanderDeviceTypesList200DataItem[];
};

export type DroneCommanderDeviceTypesList401 = {
  status?: number;
  message?: string;
};

export type DroneCommanderDeviceTypesCreate400 = {
  status?: number;
  message?: string;
};

export type DroneCommanderDeviceTypesCreate403 = {
  status?: number;
  message?: string;
};

export type DroneCommanderDeviceTypesRead200 = {
  id?: string;
  name?: string;
  description?: string;
  model_name?: string;
  model_number?: string;
  category?: string;
  manufacturer?: string;
  hardware_id?: string;
  image?: string;
  thumbnail?: string;
  created_at?: string;
  updated_at?: string;
};

export type DroneCommanderDeviceTypesRead403 = {
  status?: number;
  message?: string;
};

export type DroneCommanderDeviceTypesRead404 = {
  status?: number;
  message?: string;
};

export type DroneCommanderDeviceTypesUpdate400 = {
  status?: number;
  message?: string;
};

export type DroneCommanderDeviceTypesUpdate403 = {
  status?: number;
  message?: string;
};

export type DroneCommanderDeviceTypesUpdate404 = {
  status?: number;
  message?: string;
};

export type DroneCommanderDeviceTypesPartialUpdate400 = {
  status?: number;
  message?: string;
};

export type DroneCommanderDeviceTypesPartialUpdate403 = {
  status?: number;
  message?: string;
};

export type DroneCommanderDeviceTypesPartialUpdate404 = {
  status?: number;
  message?: string;
};

export type DroneCommanderDeviceTypesDelete403 = {
  status?: number;
  message?: string;
};

export type DroneCommanderDeviceTypesDelete404 = {
  status?: number;
  message?: string;
};

export type DroneCommanderDevicesListParams = {
/**
 * @minimum 1
 * @maximum 100
 */
limit?: number;
/**
 * @minimum 0
 */
offset?: number;
/**
 * @minLength 1
 */
search?: string;
/**
 * @minLength 1
 */
ordering?: string;
device_type?: string;
/**
 * Filter by active status (true/false)
 */
is_active?: boolean;
};

export type DroneCommanderDevicesAllDevicesParams = {
/**
 * @minimum 1
 * @maximum 100
 */
limit?: number;
/**
 * @minimum 0
 */
offset?: number;
/**
 * @minLength 1
 */
search?: string;
/**
 * @minLength 1
 */
ordering?: string;
device_type?: string;
/**
 * Filter by active status (true/false)
 */
is_active?: boolean;
};

export type DroneCommanderDevicesCheckRegistrationParams = {
/**
 * Device UUID (device_uuid field)
 */
device_uuid: string;
};

export type DroneCommanderDevicesRegisteredDevicesParams = {
/**
 * @minimum 1
 * @maximum 100
 */
limit?: number;
/**
 * @minimum 0
 */
offset?: number;
/**
 * @minLength 1
 */
search?: string;
/**
 * @minLength 1
 */
ordering?: string;
device_type?: string;
/**
 * Filter by active status (true/false)
 */
is_active?: boolean;
};

export type DroneCommanderDroneProfilesBulkRemoveDroneprofilesBody = {
  /** List of DroneProfile IDs to delete */
  ids: number[];
};

export type DroneCommanderMultispectralIndexChoicesList200DataItem = {
  /** Choice value */
  value?: string;
  /** Choice label */
  label?: string;
};

export type DroneCommanderMultispectralIndexChoicesList200 = {
  /** HTTP status code */
  status?: number;
  /** Success message */
  message?: string;
  data?: DroneCommanderMultispectralIndexChoicesList200DataItem[];
};

export type DroneCommanderWindscreenStatusList200Data = {
  /** Current IP address of the drone */
  current_ip?: string;
  /** Status of the windscreen service */
  service_status?: string;
};

export type DroneCommanderWindscreenStatusList200 = {
  /** HTTP status code */
  status?: number;
  /** Success message */
  message?: string;
  data?: DroneCommanderWindscreenStatusList200Data;
};

export type DroneCommanderWindscreenUpdateIpCreateBody = {
  /** New IP address for the drone */
  ip_address: string;
};

export type DroneCommanderWindscreenUpdateIpCreate200Data = {
  /** Script output */
  output?: string;
};

export type DroneCommanderWindscreenUpdateIpCreate200 = {
  /** HTTP status code */
  status?: number;
  /** Success message */
  message?: string;
  data?: DroneCommanderWindscreenUpdateIpCreate200Data;
};

export type VideostreamhubCampaignStreamsList200StreamsItemVideoMetadata = { [key: string]: unknown };

export type VideostreamhubCampaignStreamsList200StreamsItemMetadata = { [key: string]: unknown };

/**
 * Active stream details
 */
export type VideostreamhubCampaignStreamsList200StreamsItem = {
  id?: number;
  task_id?: string;
  room_id?: number;
  stream_url?: string;
  display_name?: string;
  status?: string;
  video_metadata?: VideostreamhubCampaignStreamsList200StreamsItemVideoMetadata;
  metadata?: VideostreamhubCampaignStreamsList200StreamsItemMetadata;
};

export type VideostreamhubCampaignStreamsList200 = {
  /** Janus room ID */
  janus_room_id?: number;
  /** List of active streams */
  streams?: VideostreamhubCampaignStreamsList200StreamsItem[];
};

export type VideostreamhubStopStreamCreateBody = {
  /** ID of the stream to stop */
  stream_id: string;
};

export type accountAcceptInvitationReadResponse200 = {
  data: null
  status: 200
}
    
export type accountAcceptInvitationReadResponseComposite = accountAcceptInvitationReadResponse200;
    
export type accountAcceptInvitationReadResponse = accountAcceptInvitationReadResponseComposite & {
  headers: Headers;
}

export const getAccountAcceptInvitationReadUrl = (token: string,) => {


  

  return `/api/account/accept-invitation/${token}/`
}

export const accountAcceptInvitationRead = async (token: string, options?: RequestInit): Promise<accountAcceptInvitationReadResponse> => {
  
  return apiMutator<accountAcceptInvitationReadResponse>(getAccountAcceptInvitationReadUrl(token),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * API to request access to an organization admin
 */
export type accountAccessRequestCreateResponse201 = {
  data: AccessRequest
  status: 201
}
    
export type accountAccessRequestCreateResponseComposite = accountAccessRequestCreateResponse201;
    
export type accountAccessRequestCreateResponse = accountAccessRequestCreateResponseComposite & {
  headers: Headers;
}

export const getAccountAccessRequestCreateUrl = () => {


  

  return `/api/account/access-request/`
}

export const accountAccessRequestCreate = async (accessRequest: NonReadonly<AccessRequest>, options?: RequestInit): Promise<accountAccessRequestCreateResponse> => {
  
  return apiMutator<accountAccessRequestCreateResponse>(getAccountAccessRequestCreateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      accessRequest,)
  }
);}



/**
 * @summary List all Addresses
 */
export type accountAddressesListResponse200 = {
  data: Address[]
  status: 200
}
    
export type accountAddressesListResponseComposite = accountAddressesListResponse200;
    
export type accountAddressesListResponse = accountAddressesListResponseComposite & {
  headers: Headers;
}

export const getAccountAddressesListUrl = () => {


  

  return `/api/account/addresses/`
}

export const accountAddressesList = async ( options?: RequestInit): Promise<accountAddressesListResponse> => {
  
  return apiMutator<accountAddressesListResponse>(getAccountAddressesListUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Create a new Address
 */
export type accountAddressesCreateResponse201 = {
  data: Address
  status: 201
}
    
export type accountAddressesCreateResponseComposite = accountAddressesCreateResponse201;
    
export type accountAddressesCreateResponse = accountAddressesCreateResponseComposite & {
  headers: Headers;
}

export const getAccountAddressesCreateUrl = () => {


  

  return `/api/account/addresses/`
}

export const accountAddressesCreate = async (addressBody: AddressBody, options?: RequestInit): Promise<accountAddressesCreateResponse> => {
  
  return apiMutator<accountAddressesCreateResponse>(getAccountAddressesCreateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      addressBody,)
  }
);}



/**
 * @summary Retrieve a Address
 */
export type accountAddressesReadResponse200 = {
  data: Address
  status: 200
}
    
export type accountAddressesReadResponseComposite = accountAddressesReadResponse200;
    
export type accountAddressesReadResponse = accountAddressesReadResponseComposite & {
  headers: Headers;
}

export const getAccountAddressesReadUrl = (id: number,) => {


  

  return `/api/account/addresses/${id}/`
}

export const accountAddressesRead = async (id: number, options?: RequestInit): Promise<accountAddressesReadResponse> => {
  
  return apiMutator<accountAddressesReadResponse>(getAccountAddressesReadUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Update a Address
 */
export type accountAddressesUpdateResponse200 = {
  data: Address
  status: 200
}
    
export type accountAddressesUpdateResponseComposite = accountAddressesUpdateResponse200;
    
export type accountAddressesUpdateResponse = accountAddressesUpdateResponseComposite & {
  headers: Headers;
}

export const getAccountAddressesUpdateUrl = (id: number,) => {


  

  return `/api/account/addresses/${id}/`
}

export const accountAddressesUpdate = async (id: number,
    addressBody: AddressBody, options?: RequestInit): Promise<accountAddressesUpdateResponse> => {
  
  return apiMutator<accountAddressesUpdateResponse>(getAccountAddressesUpdateUrl(id),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      addressBody,)
  }
);}



/**
 * @summary Partially update a Address
 */
export type accountAddressesPartialUpdateResponse200 = {
  data: Address
  status: 200
}
    
export type accountAddressesPartialUpdateResponseComposite = accountAddressesPartialUpdateResponse200;
    
export type accountAddressesPartialUpdateResponse = accountAddressesPartialUpdateResponseComposite & {
  headers: Headers;
}

export const getAccountAddressesPartialUpdateUrl = (id: number,) => {


  

  return `/api/account/addresses/${id}/`
}

export const accountAddressesPartialUpdate = async (id: number,
    addressBody: AddressBody, options?: RequestInit): Promise<accountAddressesPartialUpdateResponse> => {
  
  return apiMutator<accountAddressesPartialUpdateResponse>(getAccountAddressesPartialUpdateUrl(id),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      addressBody,)
  }
);}



/**
 * @summary Delete a Address
 */
export type accountAddressesDeleteResponse204 = {
  data: null
  status: 204
}
    
export type accountAddressesDeleteResponseComposite = accountAddressesDeleteResponse204;
    
export type accountAddressesDeleteResponse = accountAddressesDeleteResponseComposite & {
  headers: Headers;
}

export const getAccountAddressesDeleteUrl = (id: number,) => {


  

  return `/api/account/addresses/${id}/`
}

export const accountAddressesDelete = async (id: number, options?: RequestInit): Promise<accountAddressesDeleteResponse> => {
  
  return apiMutator<accountAddressesDeleteResponse>(getAccountAddressesDeleteUrl(id),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}



/**
 * This API allows users to update their preferred color scheme.
 * @summary Update preferred color scheme options
 */
export type accountApiUpdateColorSchemePreferencePartialUpdateResponse200 = {
  data: null
  status: 200
}

export type accountApiUpdateColorSchemePreferencePartialUpdateResponse400 = {
  data: null
  status: 400
}

export type accountApiUpdateColorSchemePreferencePartialUpdateResponse500 = {
  data: null
  status: 500
}
    
export type accountApiUpdateColorSchemePreferencePartialUpdateResponseComposite = accountApiUpdateColorSchemePreferencePartialUpdateResponse200 | accountApiUpdateColorSchemePreferencePartialUpdateResponse400 | accountApiUpdateColorSchemePreferencePartialUpdateResponse500;
    
export type accountApiUpdateColorSchemePreferencePartialUpdateResponse = accountApiUpdateColorSchemePreferencePartialUpdateResponseComposite & {
  headers: Headers;
}

export const getAccountApiUpdateColorSchemePreferencePartialUpdateUrl = () => {


  

  return `/api/account/api/update-color-scheme-preference/`
}

export const accountApiUpdateColorSchemePreferencePartialUpdate = async (accountApiUpdateColorSchemePreferencePartialUpdateBody: AccountApiUpdateColorSchemePreferencePartialUpdateBody, options?: RequestInit): Promise<accountApiUpdateColorSchemePreferencePartialUpdateResponse> => {
  
  return apiMutator<accountApiUpdateColorSchemePreferencePartialUpdateResponse>(getAccountApiUpdateColorSchemePreferencePartialUpdateUrl(),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      accountApiUpdateColorSchemePreferencePartialUpdateBody,)
  }
);}



/**
 * Retrieve a list of all companies/organizations that the authenticated user has access to. If the X-Mobile-Access-Key header is provided with a valid key, the response will include organization device keys (organization_device_private_key and organization_device_token).
 * @summary List all companies
 */
export type accountCompaniesListResponse200 = {
  data: CompanyListResponse
  status: 200
}

export type accountCompaniesListResponse401 = {
  data: UnauthorizedError
  status: 401
}

export type accountCompaniesListResponse403 = {
  data: ForbiddenError
  status: 403
}

export type accountCompaniesListResponse500 = {
  data: InternalServerError
  status: 500
}
    
export type accountCompaniesListResponseComposite = accountCompaniesListResponse200 | accountCompaniesListResponse401 | accountCompaniesListResponse403 | accountCompaniesListResponse500;
    
export type accountCompaniesListResponse = accountCompaniesListResponseComposite & {
  headers: Headers;
}

export const getAccountCompaniesListUrl = () => {


  

  return `/api/account/companies/`
}

export const accountCompaniesList = async ( options?: RequestInit): Promise<accountCompaniesListResponse> => {
  
  return apiMutator<accountCompaniesListResponse>(getAccountCompaniesListUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Create a new company
 */
export type accountCompaniesCreateResponse201 = {
  data: CompanyDetailResponse
  status: 201
}

export type accountCompaniesCreateResponse400 = {
  data: ValidationError
  status: 400
}

export type accountCompaniesCreateResponse401 = {
  data: UnauthorizedError
  status: 401
}

export type accountCompaniesCreateResponse403 = {
  data: ForbiddenError
  status: 403
}

export type accountCompaniesCreateResponse404 = {
  data: NotFoundError
  status: 404
}

export type accountCompaniesCreateResponse500 = {
  data: InternalServerError
  status: 500
}
    
export type accountCompaniesCreateResponseComposite = accountCompaniesCreateResponse201 | accountCompaniesCreateResponse400 | accountCompaniesCreateResponse401 | accountCompaniesCreateResponse403 | accountCompaniesCreateResponse404 | accountCompaniesCreateResponse500;
    
export type accountCompaniesCreateResponse = accountCompaniesCreateResponseComposite & {
  headers: Headers;
}

export const getAccountCompaniesCreateUrl = () => {


  

  return `/api/account/companies/`
}

export const accountCompaniesCreate = async (companyBody: CompanyBody, options?: RequestInit): Promise<accountCompaniesCreateResponse> => {
  
  return apiMutator<accountCompaniesCreateResponse>(getAccountCompaniesCreateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      companyBody,)
  }
);}



/**
 * @summary Retrieve a company
 */
export type accountCompaniesReadResponse200 = {
  data: CompanyDetailResponse
  status: 200
}

export type accountCompaniesReadResponse401 = {
  data: UnauthorizedError
  status: 401
}

export type accountCompaniesReadResponse403 = {
  data: ForbiddenError
  status: 403
}

export type accountCompaniesReadResponse404 = {
  data: NotFoundError
  status: 404
}

export type accountCompaniesReadResponse500 = {
  data: InternalServerError
  status: 500
}
    
export type accountCompaniesReadResponseComposite = accountCompaniesReadResponse200 | accountCompaniesReadResponse401 | accountCompaniesReadResponse403 | accountCompaniesReadResponse404 | accountCompaniesReadResponse500;
    
export type accountCompaniesReadResponse = accountCompaniesReadResponseComposite & {
  headers: Headers;
}

export const getAccountCompaniesReadUrl = (id: string,) => {


  

  return `/api/account/companies/${id}/`
}

export const accountCompaniesRead = async (id: string, options?: RequestInit): Promise<accountCompaniesReadResponse> => {
  
  return apiMutator<accountCompaniesReadResponse>(getAccountCompaniesReadUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Update a company
 */
export type accountCompaniesUpdateResponse200 = {
  data: CompanyDetailResponse
  status: 200
}

export type accountCompaniesUpdateResponse400 = {
  data: ValidationError
  status: 400
}

export type accountCompaniesUpdateResponse401 = {
  data: UnauthorizedError
  status: 401
}

export type accountCompaniesUpdateResponse403 = {
  data: ForbiddenError
  status: 403
}

export type accountCompaniesUpdateResponse404 = {
  data: NotFoundError
  status: 404
}

export type accountCompaniesUpdateResponse500 = {
  data: InternalServerError
  status: 500
}
    
export type accountCompaniesUpdateResponseComposite = accountCompaniesUpdateResponse200 | accountCompaniesUpdateResponse400 | accountCompaniesUpdateResponse401 | accountCompaniesUpdateResponse403 | accountCompaniesUpdateResponse404 | accountCompaniesUpdateResponse500;
    
export type accountCompaniesUpdateResponse = accountCompaniesUpdateResponseComposite & {
  headers: Headers;
}

export const getAccountCompaniesUpdateUrl = (id: string,) => {


  

  return `/api/account/companies/${id}/`
}

export const accountCompaniesUpdate = async (id: string,
    companyBody: CompanyBody, options?: RequestInit): Promise<accountCompaniesUpdateResponse> => {
  
  return apiMutator<accountCompaniesUpdateResponse>(getAccountCompaniesUpdateUrl(id),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      companyBody,)
  }
);}



/**
 * @summary Partially update a company
 */
export type accountCompaniesPartialUpdateResponse200 = {
  data: CompanyDetailResponse
  status: 200
}

export type accountCompaniesPartialUpdateResponse400 = {
  data: ValidationError
  status: 400
}

export type accountCompaniesPartialUpdateResponse401 = {
  data: UnauthorizedError
  status: 401
}

export type accountCompaniesPartialUpdateResponse403 = {
  data: ForbiddenError
  status: 403
}

export type accountCompaniesPartialUpdateResponse404 = {
  data: NotFoundError
  status: 404
}

export type accountCompaniesPartialUpdateResponse500 = {
  data: InternalServerError
  status: 500
}
    
export type accountCompaniesPartialUpdateResponseComposite = accountCompaniesPartialUpdateResponse200 | accountCompaniesPartialUpdateResponse400 | accountCompaniesPartialUpdateResponse401 | accountCompaniesPartialUpdateResponse403 | accountCompaniesPartialUpdateResponse404 | accountCompaniesPartialUpdateResponse500;
    
export type accountCompaniesPartialUpdateResponse = accountCompaniesPartialUpdateResponseComposite & {
  headers: Headers;
}

export const getAccountCompaniesPartialUpdateUrl = (id: string,) => {


  

  return `/api/account/companies/${id}/`
}

export const accountCompaniesPartialUpdate = async (id: string,
    companyBody: CompanyBody, options?: RequestInit): Promise<accountCompaniesPartialUpdateResponse> => {
  
  return apiMutator<accountCompaniesPartialUpdateResponse>(getAccountCompaniesPartialUpdateUrl(id),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      companyBody,)
  }
);}



/**
 * @summary Delete a company
 */
export type accountCompaniesDeleteResponse204 = {
  data: AccountCompaniesDelete204
  status: 204
}

export type accountCompaniesDeleteResponse401 = {
  data: UnauthorizedError
  status: 401
}

export type accountCompaniesDeleteResponse403 = {
  data: ForbiddenError
  status: 403
}

export type accountCompaniesDeleteResponse404 = {
  data: NotFoundError
  status: 404
}

export type accountCompaniesDeleteResponse500 = {
  data: InternalServerError
  status: 500
}
    
export type accountCompaniesDeleteResponseComposite = accountCompaniesDeleteResponse204 | accountCompaniesDeleteResponse401 | accountCompaniesDeleteResponse403 | accountCompaniesDeleteResponse404 | accountCompaniesDeleteResponse500;
    
export type accountCompaniesDeleteResponse = accountCompaniesDeleteResponseComposite & {
  headers: Headers;
}

export const getAccountCompaniesDeleteUrl = (id: string,) => {


  

  return `/api/account/companies/${id}/`
}

export const accountCompaniesDelete = async (id: string, options?: RequestInit): Promise<accountCompaniesDeleteResponse> => {
  
  return apiMutator<accountCompaniesDeleteResponse>(getAccountCompaniesDeleteUrl(id),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}



/**
 * Allow authenticated users to partially update their own profile.
 * @summary Get the current user
 */
export type accountCurrentUserReadResponse200 = {
  data: User
  status: 200
}
    
export type accountCurrentUserReadResponseComposite = accountCurrentUserReadResponse200;
    
export type accountCurrentUserReadResponse = accountCurrentUserReadResponseComposite & {
  headers: Headers;
}

export const getAccountCurrentUserReadUrl = () => {


  

  return `/api/account/current-user/`
}

export const accountCurrentUserRead = async ( options?: RequestInit): Promise<accountCurrentUserReadResponse> => {
  
  return apiMutator<accountCurrentUserReadResponse>(getAccountCurrentUserReadUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * Allow authenticated users to partially update their own profile.
 * @summary Partially update the current user
 */
export type accountCurrentUserPartialUpdateResponse200 = {
  data: User
  status: 200
}
    
export type accountCurrentUserPartialUpdateResponseComposite = accountCurrentUserPartialUpdateResponse200;
    
export type accountCurrentUserPartialUpdateResponse = accountCurrentUserPartialUpdateResponseComposite & {
  headers: Headers;
}

export const getAccountCurrentUserPartialUpdateUrl = () => {


  

  return `/api/account/current-user/`
}

export const accountCurrentUserPartialUpdate = async (user: NonReadonly<User>, options?: RequestInit): Promise<accountCurrentUserPartialUpdateResponse> => {
  
  return apiMutator<accountCurrentUserPartialUpdateResponse>(getAccountCurrentUserPartialUpdateUrl(),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      user,)
  }
);}



/**
 * API endpoint that retrieves customer support contact information including phone number and email.
 */
export type accountCustomerSupportListResponse200 = {
  data: CustomerSupport
  status: 200
}

export type accountCustomerSupportListResponse401 = {
  data: GeneralError
  status: 401
}

export type accountCustomerSupportListResponse403 = {
  data: GeneralError
  status: 403
}

export type accountCustomerSupportListResponse404 = {
  data: GeneralError
  status: 404
}

export type accountCustomerSupportListResponse500 = {
  data: GeneralError
  status: 500
}
    
export type accountCustomerSupportListResponseComposite = accountCustomerSupportListResponse200 | accountCustomerSupportListResponse401 | accountCustomerSupportListResponse403 | accountCustomerSupportListResponse404 | accountCustomerSupportListResponse500;
    
export type accountCustomerSupportListResponse = accountCustomerSupportListResponseComposite & {
  headers: Headers;
}

export const getAccountCustomerSupportListUrl = () => {


  

  return `/api/account/customer-support/`
}

export const accountCustomerSupportList = async ( options?: RequestInit): Promise<accountCustomerSupportListResponse> => {
  
  return apiMutator<accountCustomerSupportListResponse>(getAccountCustomerSupportListUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * Sets the CSRF cookie and returns the CSRF token.
 */
export type getCsrfTokenResponse200 = {
  data: CSRFTokenResponse
  status: 200
}
    
export type getCsrfTokenResponseComposite = getCsrfTokenResponse200;
    
export type getCsrfTokenResponse = getCsrfTokenResponseComposite & {
  headers: Headers;
}

export const getGetCsrfTokenUrl = () => {


  

  return `/api/account/getcsrf/`
}

export const getCsrfToken = async ( options?: RequestInit): Promise<getCsrfTokenResponse> => {
  
  return apiMutator<getCsrfTokenResponse>(getGetCsrfTokenUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * API endpoint for user login. Validates user credentials and returns user profile if successful.
 */
export type accountLoginCreateResponse200 = {
  data: UserLoginResponse
  status: 200
}

export type accountLoginCreateResponse400 = {
  data: GeneralError
  status: 400
}

export type accountLoginCreateResponse403 = {
  data: GeneralError
  status: 403
}

export type accountLoginCreateResponse404 = {
  data: GeneralError
  status: 404
}

export type accountLoginCreateResponse422 = {
  data: GeneralError
  status: 422
}

export type accountLoginCreateResponse500 = {
  data: GeneralError
  status: 500
}
    
export type accountLoginCreateResponseComposite = accountLoginCreateResponse200 | accountLoginCreateResponse400 | accountLoginCreateResponse403 | accountLoginCreateResponse404 | accountLoginCreateResponse422 | accountLoginCreateResponse500;
    
export type accountLoginCreateResponse = accountLoginCreateResponseComposite & {
  headers: Headers;
}

export const getAccountLoginCreateUrl = () => {


  

  return `/api/account/login/`
}

export const accountLoginCreate = async (loginRequest: LoginRequest, options?: RequestInit): Promise<accountLoginCreateResponse> => {
  
  return apiMutator<accountLoginCreateResponse>(getAccountLoginCreateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      loginRequest,)
  }
);}



/**
 * Logs out the current authenticated user, destroying the session.
 */
export type logoutUserResponse200 = {
  data: LogoutResponse
  status: 200
}

export type logoutUserResponse401 = {
  data: GeneralError
  status: 401
}
    
export type logoutUserResponseComposite = logoutUserResponse200 | logoutUserResponse401;
    
export type logoutUserResponse = logoutUserResponseComposite & {
  headers: Headers;
}

export const getLogoutUserUrl = () => {


  

  return `/api/account/logout/`
}

export const logoutUser = async ( options?: RequestInit): Promise<logoutUserResponse> => {
  
  return apiMutator<logoutUserResponse>(getLogoutUserUrl(),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}



/**
 * This API retrieves both users associated with a specific organization and invitations sent to users to join the organization.
 * @summary Retrieve users and invitations for an organization
 */
export type accountOrganizationsGetResponse200 = {
  data: OrganizationUsersAndInvitationsEnvelopeResponse
  status: 200
}

export type accountOrganizationsGetResponse400 = {
  data: ValidationError
  status: 400
}

export type accountOrganizationsGetResponse401 = {
  data: UnauthorizedError
  status: 401
}

export type accountOrganizationsGetResponse403 = {
  data: ForbiddenError
  status: 403
}

export type accountOrganizationsGetResponse404 = {
  data: NotFoundError
  status: 404
}

export type accountOrganizationsGetResponse500 = {
  data: InternalServerError
  status: 500
}
    
export type accountOrganizationsGetResponseComposite = accountOrganizationsGetResponse200 | accountOrganizationsGetResponse400 | accountOrganizationsGetResponse401 | accountOrganizationsGetResponse403 | accountOrganizationsGetResponse404 | accountOrganizationsGetResponse500;
    
export type accountOrganizationsGetResponse = accountOrganizationsGetResponseComposite & {
  headers: Headers;
}

export const getAccountOrganizationsGetUrl = (orgId: string,) => {


  

  return `/api/account/organizations/${orgId}/users-and-invitations/`
}

export const accountOrganizationsGet = async (orgId: string, options?: RequestInit): Promise<accountOrganizationsGetResponse> => {
  
  return apiMutator<accountOrganizationsGetResponse>(getAccountOrganizationsGetUrl(orgId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * This API returns the list of preferred languages available for users, represented as a list of language codes and names.
 * @summary Retrieve preferred language options
 */
export type accountPreferredLanguagesListResponse400 = {
  data: null
  status: 400
}

export type accountPreferredLanguagesListResponse500 = {
  data: null
  status: 500
}
    
export type accountPreferredLanguagesListResponseComposite = accountPreferredLanguagesListResponse400 | accountPreferredLanguagesListResponse500;
    
export type accountPreferredLanguagesListResponse = accountPreferredLanguagesListResponseComposite & {
  headers: Headers;
}

export const getAccountPreferredLanguagesListUrl = () => {


  

  return `/api/account/preferred-languages/`
}

export const accountPreferredLanguagesList = async ( options?: RequestInit): Promise<accountPreferredLanguagesListResponse> => {
  
  return apiMutator<accountPreferredLanguagesListResponse>(getAccountPreferredLanguagesListUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * API view to handle password reset requests.
 * @summary Request Password Reset
 */
export type accountRequestResetPasswordCreateResponse400 = {
  data: ValidationError
  status: 400
}

export type accountRequestResetPasswordCreateResponse500 = {
  data: GeneralError
  status: 500
}
    
export type accountRequestResetPasswordCreateResponseComposite = accountRequestResetPasswordCreateResponse400 | accountRequestResetPasswordCreateResponse500;
    
export type accountRequestResetPasswordCreateResponse = accountRequestResetPasswordCreateResponseComposite & {
  headers: Headers;
}

export const getAccountRequestResetPasswordCreateUrl = () => {


  

  return `/api/account/request-reset-password/`
}

export const accountRequestResetPasswordCreate = async (accountRequestResetPasswordCreateBody: AccountRequestResetPasswordCreateBody, options?: RequestInit): Promise<accountRequestResetPasswordCreateResponse> => {
  
  return apiMutator<accountRequestResetPasswordCreateResponse>(getAccountRequestResetPasswordCreateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      accountRequestResetPasswordCreateBody,)
  }
);}



/**
 * API view to handle password resets using a token.
 * @summary Reset Password
 */
export type accountResetPasswordCreateResponse400 = {
  data: ValidationError
  status: 400
}

export type accountResetPasswordCreateResponse500 = {
  data: GeneralError
  status: 500
}
    
export type accountResetPasswordCreateResponseComposite = accountResetPasswordCreateResponse400 | accountResetPasswordCreateResponse500;
    
export type accountResetPasswordCreateResponse = accountResetPasswordCreateResponseComposite & {
  headers: Headers;
}

export const getAccountResetPasswordCreateUrl = () => {


  

  return `/api/account/reset-password/`
}

export const accountResetPasswordCreate = async (accountResetPasswordCreateBody: AccountResetPasswordCreateBody, options?: RequestInit): Promise<accountResetPasswordCreateResponse> => {
  
  return apiMutator<accountResetPasswordCreateResponse>(getAccountResetPasswordCreateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      accountResetPasswordCreateBody,)
  }
);}



/**
 * @summary List all roles
 */
export type accountRolesListResponse200 = {
  data: Role[]
  status: 200
}
    
export type accountRolesListResponseComposite = accountRolesListResponse200;
    
export type accountRolesListResponse = accountRolesListResponseComposite & {
  headers: Headers;
}

export const getAccountRolesListUrl = () => {


  

  return `/api/account/roles/`
}

export const accountRolesList = async ( options?: RequestInit): Promise<accountRolesListResponse> => {
  
  return apiMutator<accountRolesListResponse>(getAccountRolesListUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Create a new role
 */
export type accountRolesCreateResponse201 = {
  data: Role
  status: 201
}
    
export type accountRolesCreateResponseComposite = accountRolesCreateResponse201;
    
export type accountRolesCreateResponse = accountRolesCreateResponseComposite & {
  headers: Headers;
}

export const getAccountRolesCreateUrl = () => {


  

  return `/api/account/roles/`
}

export const accountRolesCreate = async (roleBody: RoleBody, options?: RequestInit): Promise<accountRolesCreateResponse> => {
  
  return apiMutator<accountRolesCreateResponse>(getAccountRolesCreateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      roleBody,)
  }
);}



/**
 * @summary Retrieve a role
 */
export type accountRolesReadResponse200 = {
  data: Role
  status: 200
}
    
export type accountRolesReadResponseComposite = accountRolesReadResponse200;
    
export type accountRolesReadResponse = accountRolesReadResponseComposite & {
  headers: Headers;
}

export const getAccountRolesReadUrl = (id: number,) => {


  

  return `/api/account/roles/${id}/`
}

export const accountRolesRead = async (id: number, options?: RequestInit): Promise<accountRolesReadResponse> => {
  
  return apiMutator<accountRolesReadResponse>(getAccountRolesReadUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Update a role
 */
export type accountRolesUpdateResponse200 = {
  data: Role
  status: 200
}
    
export type accountRolesUpdateResponseComposite = accountRolesUpdateResponse200;
    
export type accountRolesUpdateResponse = accountRolesUpdateResponseComposite & {
  headers: Headers;
}

export const getAccountRolesUpdateUrl = (id: number,) => {


  

  return `/api/account/roles/${id}/`
}

export const accountRolesUpdate = async (id: number,
    roleBody: RoleBody, options?: RequestInit): Promise<accountRolesUpdateResponse> => {
  
  return apiMutator<accountRolesUpdateResponse>(getAccountRolesUpdateUrl(id),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      roleBody,)
  }
);}



/**
 * @summary Partially update a role
 */
export type accountRolesPartialUpdateResponse200 = {
  data: Role
  status: 200
}
    
export type accountRolesPartialUpdateResponseComposite = accountRolesPartialUpdateResponse200;
    
export type accountRolesPartialUpdateResponse = accountRolesPartialUpdateResponseComposite & {
  headers: Headers;
}

export const getAccountRolesPartialUpdateUrl = (id: number,) => {


  

  return `/api/account/roles/${id}/`
}

export const accountRolesPartialUpdate = async (id: number,
    roleBody: RoleBody, options?: RequestInit): Promise<accountRolesPartialUpdateResponse> => {
  
  return apiMutator<accountRolesPartialUpdateResponse>(getAccountRolesPartialUpdateUrl(id),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      roleBody,)
  }
);}



/**
 * @summary Delete a role
 */
export type accountRolesDeleteResponse204 = {
  data: null
  status: 204
}
    
export type accountRolesDeleteResponseComposite = accountRolesDeleteResponse204;
    
export type accountRolesDeleteResponse = accountRolesDeleteResponseComposite & {
  headers: Headers;
}

export const getAccountRolesDeleteUrl = (id: number,) => {


  

  return `/api/account/roles/${id}/`
}

export const accountRolesDelete = async (id: number, options?: RequestInit): Promise<accountRolesDeleteResponse> => {
  
  return apiMutator<accountRolesDeleteResponse>(getAccountRolesDeleteUrl(id),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}



export type accountSendInvitationCreateResponse201 = {
  data: Invitation
  status: 201
}
    
export type accountSendInvitationCreateResponseComposite = accountSendInvitationCreateResponse201;
    
export type accountSendInvitationCreateResponse = accountSendInvitationCreateResponseComposite & {
  headers: Headers;
}

export const getAccountSendInvitationCreateUrl = () => {


  

  return `/api/account/send-invitation/`
}

export const accountSendInvitationCreate = async (invitation: NonReadonly<Invitation>, options?: RequestInit): Promise<accountSendInvitationCreateResponse> => {
  
  return apiMutator<accountSendInvitationCreateResponse>(getAccountSendInvitationCreateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      invitation,)
  }
);}



/**
 * API view that either signs up a new user or updates an existing user's profile.
 */
export type accountSignupCreateResponse201 = {
  data: UserSignupResponse
  status: 201
}

export type accountSignupCreateResponse400 = {
  data: ValidationError
  status: 400
}

export type accountSignupCreateResponse500 = {
  data: GeneralError
  status: 500
}
    
export type accountSignupCreateResponseComposite = accountSignupCreateResponse201 | accountSignupCreateResponse400 | accountSignupCreateResponse500;
    
export type accountSignupCreateResponse = accountSignupCreateResponseComposite & {
  headers: Headers;
}

export const getAccountSignupCreateUrl = () => {


  

  return `/api/account/signup/`
}

export const accountSignupCreate = async (signupRequest: SignupRequest, options?: RequestInit): Promise<accountSignupCreateResponse> => {
  
  return apiMutator<accountSignupCreateResponse>(getAccountSignupCreateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      signupRequest,)
  }
);}



/**
 * API view that either signs up a new user or updates an existing user's profile.
If the user does not exist, it will create a new user with the provided email and password.
If the user exists, it will update their profile based on the provided data.
 */
export type accountSignupPartialUpdateResponse200 = {
  data: null
  status: 200
}
    
export type accountSignupPartialUpdateResponseComposite = accountSignupPartialUpdateResponse200;
    
export type accountSignupPartialUpdateResponse = accountSignupPartialUpdateResponseComposite & {
  headers: Headers;
}

export const getAccountSignupPartialUpdateUrl = () => {


  

  return `/api/account/signup/`
}

export const accountSignupPartialUpdate = async ( options?: RequestInit): Promise<accountSignupPartialUpdateResponse> => {
  
  return apiMutator<accountSignupPartialUpdateResponse>(getAccountSignupPartialUpdateUrl(),
  {      
    ...options,
    method: 'PATCH'
    
    
  }
);}



export type accountUserOrganizationsListResponse200 = {
  data: null
  status: 200
}
    
export type accountUserOrganizationsListResponseComposite = accountUserOrganizationsListResponse200;
    
export type accountUserOrganizationsListResponse = accountUserOrganizationsListResponseComposite & {
  headers: Headers;
}

export const getAccountUserOrganizationsListUrl = () => {


  

  return `/api/account/user-organizations/`
}

export const accountUserOrganizationsList = async ( options?: RequestInit): Promise<accountUserOrganizationsListResponse> => {
  
  return apiMutator<accountUserOrganizationsListResponse>(getAccountUserOrganizationsListUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary List all user roles
 */
export type accountUserrolesListResponse200 = {
  data: UserRole[]
  status: 200
}
    
export type accountUserrolesListResponseComposite = accountUserrolesListResponse200;
    
export type accountUserrolesListResponse = accountUserrolesListResponseComposite & {
  headers: Headers;
}

export const getAccountUserrolesListUrl = () => {


  

  return `/api/account/userroles/`
}

export const accountUserrolesList = async ( options?: RequestInit): Promise<accountUserrolesListResponse> => {
  
  return apiMutator<accountUserrolesListResponse>(getAccountUserrolesListUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Create a new user role
 */
export type accountUserrolesCreateResponse201 = {
  data: AccountUserrolesCreate201
  status: 201
}
    
export type accountUserrolesCreateResponseComposite = accountUserrolesCreateResponse201;
    
export type accountUserrolesCreateResponse = accountUserrolesCreateResponseComposite & {
  headers: Headers;
}

export const getAccountUserrolesCreateUrl = () => {


  

  return `/api/account/userroles/`
}

export const accountUserrolesCreate = async (accountUserrolesCreateBody: AccountUserrolesCreateBody, options?: RequestInit): Promise<accountUserrolesCreateResponse> => {
  
  return apiMutator<accountUserrolesCreateResponse>(getAccountUserrolesCreateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      accountUserrolesCreateBody,)
  }
);}



/**
 * @summary Bulk update roles for multiple users
 */
export type accountUserrolesBulkUpdateResponse200 = {
  data: AccountUserrolesBulkUpdate200
  status: 200
}
    
export type accountUserrolesBulkUpdateResponseComposite = accountUserrolesBulkUpdateResponse200;
    
export type accountUserrolesBulkUpdateResponse = accountUserrolesBulkUpdateResponseComposite & {
  headers: Headers;
}

export const getAccountUserrolesBulkUpdateUrl = () => {


  

  return `/api/account/userroles/bulk-update/`
}

export const accountUserrolesBulkUpdate = async (accountUserrolesBulkUpdateBody: AccountUserrolesBulkUpdateBody, options?: RequestInit): Promise<accountUserrolesBulkUpdateResponse> => {
  
  return apiMutator<accountUserrolesBulkUpdateResponse>(getAccountUserrolesBulkUpdateUrl(),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      accountUserrolesBulkUpdateBody,)
  }
);}



/**
 * @summary Retrieve a user role
 */
export type accountUserrolesReadResponse200 = {
  data: UserRole
  status: 200
}
    
export type accountUserrolesReadResponseComposite = accountUserrolesReadResponse200;
    
export type accountUserrolesReadResponse = accountUserrolesReadResponseComposite & {
  headers: Headers;
}

export const getAccountUserrolesReadUrl = (id: number,) => {


  

  return `/api/account/userroles/${id}/`
}

export const accountUserrolesRead = async (id: number, options?: RequestInit): Promise<accountUserrolesReadResponse> => {
  
  return apiMutator<accountUserrolesReadResponse>(getAccountUserrolesReadUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Update a user role
 */
export type accountUserrolesUpdateResponse200 = {
  data: UserRole
  status: 200
}
    
export type accountUserrolesUpdateResponseComposite = accountUserrolesUpdateResponse200;
    
export type accountUserrolesUpdateResponse = accountUserrolesUpdateResponseComposite & {
  headers: Headers;
}

export const getAccountUserrolesUpdateUrl = (id: number,) => {


  

  return `/api/account/userroles/${id}/`
}

export const accountUserrolesUpdate = async (id: number,
    userRoleBody: UserRoleBody, options?: RequestInit): Promise<accountUserrolesUpdateResponse> => {
  
  return apiMutator<accountUserrolesUpdateResponse>(getAccountUserrolesUpdateUrl(id),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      userRoleBody,)
  }
);}



/**
 * @summary Partially update a user role
 */
export type accountUserrolesPartialUpdateResponse200 = {
  data: UserRole
  status: 200
}
    
export type accountUserrolesPartialUpdateResponseComposite = accountUserrolesPartialUpdateResponse200;
    
export type accountUserrolesPartialUpdateResponse = accountUserrolesPartialUpdateResponseComposite & {
  headers: Headers;
}

export const getAccountUserrolesPartialUpdateUrl = (id: number,) => {


  

  return `/api/account/userroles/${id}/`
}

export const accountUserrolesPartialUpdate = async (id: number,
    userRoleBody: UserRoleBody, options?: RequestInit): Promise<accountUserrolesPartialUpdateResponse> => {
  
  return apiMutator<accountUserrolesPartialUpdateResponse>(getAccountUserrolesPartialUpdateUrl(id),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      userRoleBody,)
  }
);}



/**
 * @summary Delete a user role
 */
export type accountUserrolesDeleteResponse204 = {
  data: null
  status: 204
}
    
export type accountUserrolesDeleteResponseComposite = accountUserrolesDeleteResponse204;
    
export type accountUserrolesDeleteResponse = accountUserrolesDeleteResponseComposite & {
  headers: Headers;
}

export const getAccountUserrolesDeleteUrl = (id: number,) => {


  

  return `/api/account/userroles/${id}/`
}

export const accountUserrolesDelete = async (id: number, options?: RequestInit): Promise<accountUserrolesDeleteResponse> => {
  
  return apiMutator<accountUserrolesDeleteResponse>(getAccountUserrolesDeleteUrl(id),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}



/**
 * ViewSet for managing user operations including CRUD operations,
password changes, and organization management.
 */
export type accountUsersListResponse200 = {
  data: User[]
  status: 200
}
    
export type accountUsersListResponseComposite = accountUsersListResponse200;
    
export type accountUsersListResponse = accountUsersListResponseComposite & {
  headers: Headers;
}

export const getAccountUsersListUrl = () => {


  

  return `/api/account/users/`
}

export const accountUsersList = async ( options?: RequestInit): Promise<accountUsersListResponse> => {
  
  return apiMutator<accountUsersListResponse>(getAccountUsersListUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * Create a new user account in the system. Requires valid user data including email and password.
 */
export type accountUsersCreateResponse201 = {
  data: UserDetailEnvelopeResponse
  status: 201
}

export type accountUsersCreateResponse400 = {
  data: ValidationError
  status: 400
}

export type accountUsersCreateResponse401 = {
  data: UnauthorizedError
  status: 401
}

export type accountUsersCreateResponse403 = {
  data: ForbiddenError
  status: 403
}

export type accountUsersCreateResponse404 = {
  data: NotFoundError
  status: 404
}

export type accountUsersCreateResponse500 = {
  data: InternalServerError
  status: 500
}
    
export type accountUsersCreateResponseComposite = accountUsersCreateResponse201 | accountUsersCreateResponse400 | accountUsersCreateResponse401 | accountUsersCreateResponse403 | accountUsersCreateResponse404 | accountUsersCreateResponse500;
    
export type accountUsersCreateResponse = accountUsersCreateResponseComposite & {
  headers: Headers;
}

export const getAccountUsersCreateUrl = () => {


  

  return `/api/account/users/`
}

export const accountUsersCreate = async (userCreateInput: UserCreateInput, options?: RequestInit): Promise<accountUsersCreateResponse> => {
  
  return apiMutator<accountUsersCreateResponse>(getAccountUsersCreateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      userCreateInput,)
  }
);}



/**
 * Remove a specific organization from multiple users at once. Also handles deletion of pending invitations for the specified organization.
 */
export type accountUsersBulkRemoveOrganizationResponse200 = {
  data: UserMessageEnvelopeResponse
  status: 200
}

export type accountUsersBulkRemoveOrganizationResponse400 = {
  data: ValidationError
  status: 400
}

export type accountUsersBulkRemoveOrganizationResponse401 = {
  data: UnauthorizedError
  status: 401
}

export type accountUsersBulkRemoveOrganizationResponse403 = {
  data: ForbiddenError
  status: 403
}

export type accountUsersBulkRemoveOrganizationResponse404 = {
  data: NotFoundError
  status: 404
}

export type accountUsersBulkRemoveOrganizationResponse500 = {
  data: InternalServerError
  status: 500
}
    
export type accountUsersBulkRemoveOrganizationResponseComposite = accountUsersBulkRemoveOrganizationResponse200 | accountUsersBulkRemoveOrganizationResponse400 | accountUsersBulkRemoveOrganizationResponse401 | accountUsersBulkRemoveOrganizationResponse403 | accountUsersBulkRemoveOrganizationResponse404 | accountUsersBulkRemoveOrganizationResponse500;
    
export type accountUsersBulkRemoveOrganizationResponse = accountUsersBulkRemoveOrganizationResponseComposite & {
  headers: Headers;
}

export const getAccountUsersBulkRemoveOrganizationUrl = () => {


  

  return `/api/account/users/bulk-remove-organization/`
}

export const accountUsersBulkRemoveOrganization = async (bulkRemoveOrgRequest: BulkRemoveOrgRequest, options?: RequestInit): Promise<accountUsersBulkRemoveOrganizationResponse> => {
  
  return apiMutator<accountUsersBulkRemoveOrganizationResponse>(getAccountUsersBulkRemoveOrganizationUrl(),
  {      
    ...options,
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      bulkRemoveOrgRequest,)
  }
);}



/**
 * Retrieve detailed information for a specific user by their ID.
 */
export type accountUsersReadResponse200 = {
  data: UserDetailEnvelopeResponse
  status: 200
}

export type accountUsersReadResponse400 = {
  data: ValidationError
  status: 400
}

export type accountUsersReadResponse401 = {
  data: UnauthorizedError
  status: 401
}

export type accountUsersReadResponse403 = {
  data: ForbiddenError
  status: 403
}

export type accountUsersReadResponse404 = {
  data: NotFoundError
  status: 404
}

export type accountUsersReadResponse500 = {
  data: InternalServerError
  status: 500
}
    
export type accountUsersReadResponseComposite = accountUsersReadResponse200 | accountUsersReadResponse400 | accountUsersReadResponse401 | accountUsersReadResponse403 | accountUsersReadResponse404 | accountUsersReadResponse500;
    
export type accountUsersReadResponse = accountUsersReadResponseComposite & {
  headers: Headers;
}

export const getAccountUsersReadUrl = (id: number,) => {


  

  return `/api/account/users/${id}/`
}

export const accountUsersRead = async (id: number, options?: RequestInit): Promise<accountUsersReadResponse> => {
  
  return apiMutator<accountUsersReadResponse>(getAccountUsersReadUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * Update all fields(excluding username and password) of a specific user.
 */
export type accountUsersUpdateResponse200 = {
  data: UserDetailEnvelopeResponse
  status: 200
}

export type accountUsersUpdateResponse400 = {
  data: ValidationError
  status: 400
}

export type accountUsersUpdateResponse401 = {
  data: UnauthorizedError
  status: 401
}

export type accountUsersUpdateResponse403 = {
  data: ForbiddenError
  status: 403
}

export type accountUsersUpdateResponse404 = {
  data: NotFoundError
  status: 404
}

export type accountUsersUpdateResponse500 = {
  data: InternalServerError
  status: 500
}
    
export type accountUsersUpdateResponseComposite = accountUsersUpdateResponse200 | accountUsersUpdateResponse400 | accountUsersUpdateResponse401 | accountUsersUpdateResponse403 | accountUsersUpdateResponse404 | accountUsersUpdateResponse500;
    
export type accountUsersUpdateResponse = accountUsersUpdateResponseComposite & {
  headers: Headers;
}

export const getAccountUsersUpdateUrl = (id: number,) => {


  

  return `/api/account/users/${id}/`
}

export const accountUsersUpdate = async (id: number,
    userUpdateInputBody: UserUpdateInputBody, options?: RequestInit): Promise<accountUsersUpdateResponse> => {
  
  return apiMutator<accountUsersUpdateResponse>(getAccountUsersUpdateUrl(id),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      userUpdateInputBody,)
  }
);}



/**
 * Partially update specific fields(excluding username and password) of a user. Only provided fields will be updated.
 */
export type accountUsersPartialUpdateResponse200 = {
  data: UserDetailEnvelopeResponse
  status: 200
}

export type accountUsersPartialUpdateResponse400 = {
  data: ValidationError
  status: 400
}

export type accountUsersPartialUpdateResponse401 = {
  data: UnauthorizedError
  status: 401
}

export type accountUsersPartialUpdateResponse403 = {
  data: ForbiddenError
  status: 403
}

export type accountUsersPartialUpdateResponse404 = {
  data: NotFoundError
  status: 404
}

export type accountUsersPartialUpdateResponse500 = {
  data: InternalServerError
  status: 500
}
    
export type accountUsersPartialUpdateResponseComposite = accountUsersPartialUpdateResponse200 | accountUsersPartialUpdateResponse400 | accountUsersPartialUpdateResponse401 | accountUsersPartialUpdateResponse403 | accountUsersPartialUpdateResponse404 | accountUsersPartialUpdateResponse500;
    
export type accountUsersPartialUpdateResponse = accountUsersPartialUpdateResponseComposite & {
  headers: Headers;
}

export const getAccountUsersPartialUpdateUrl = (id: number,) => {


  

  return `/api/account/users/${id}/`
}

export const accountUsersPartialUpdate = async (id: number,
    userUpdateInputBody: UserUpdateInputBody, options?: RequestInit): Promise<accountUsersPartialUpdateResponse> => {
  
  return apiMutator<accountUsersPartialUpdateResponse>(getAccountUsersPartialUpdateUrl(id),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      userUpdateInputBody,)
  }
);}



/**
 * Permanently delete a user from the system. This action cannot be undone.
 */
export type accountUsersDeleteResponse204 = {
  data: null
  status: 204
}

export type accountUsersDeleteResponse401 = {
  data: UnauthorizedError
  status: 401
}

export type accountUsersDeleteResponse403 = {
  data: ForbiddenError
  status: 403
}

export type accountUsersDeleteResponse404 = {
  data: NotFoundError
  status: 404
}

export type accountUsersDeleteResponse500 = {
  data: InternalServerError
  status: 500
}
    
export type accountUsersDeleteResponseComposite = accountUsersDeleteResponse204 | accountUsersDeleteResponse401 | accountUsersDeleteResponse403 | accountUsersDeleteResponse404 | accountUsersDeleteResponse500;
    
export type accountUsersDeleteResponse = accountUsersDeleteResponseComposite & {
  headers: Headers;
}

export const getAccountUsersDeleteUrl = (id: number,) => {


  

  return `/api/account/users/${id}/`
}

export const accountUsersDelete = async (id: number, options?: RequestInit): Promise<accountUsersDeleteResponse> => {
  
  return apiMutator<accountUsersDeleteResponse>(getAccountUsersDeleteUrl(id),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}



/**
 * Change the password for a specific user. Requires current password verification and new password confirmation.
 */
export type accountUsersChangePasswordResponse200 = {
  data: PasswordChangeEnvelopeResponse
  status: 200
}

export type accountUsersChangePasswordResponse400 = {
  data: ValidationError
  status: 400
}

export type accountUsersChangePasswordResponse401 = {
  data: UnauthorizedError
  status: 401
}

export type accountUsersChangePasswordResponse403 = {
  data: ForbiddenError
  status: 403
}

export type accountUsersChangePasswordResponse404 = {
  data: NotFoundError
  status: 404
}

export type accountUsersChangePasswordResponse500 = {
  data: InternalServerError
  status: 500
}
    
export type accountUsersChangePasswordResponseComposite = accountUsersChangePasswordResponse200 | accountUsersChangePasswordResponse400 | accountUsersChangePasswordResponse401 | accountUsersChangePasswordResponse403 | accountUsersChangePasswordResponse404 | accountUsersChangePasswordResponse500;
    
export type accountUsersChangePasswordResponse = accountUsersChangePasswordResponseComposite & {
  headers: Headers;
}

export const getAccountUsersChangePasswordUrl = (id: number,) => {


  

  return `/api/account/users/${id}/change_password/`
}

export const accountUsersChangePassword = async (id: number,
    userPasswordUpdate: UserPasswordUpdate, options?: RequestInit): Promise<accountUsersChangePasswordResponse> => {
  
  return apiMutator<accountUsersChangePasswordResponse>(getAccountUsersChangePasswordUrl(id),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      userPasswordUpdate,)
  }
);}



/**
 * Remove a specific organization from a user's list of organizations. Requires the organization ID in the request body.
 */
export type accountUsersRemoveOrganizationResponse200 = {
  data: UserMessageEnvelopeResponse
  status: 200
}

export type accountUsersRemoveOrganizationResponse400 = {
  data: ValidationError
  status: 400
}

export type accountUsersRemoveOrganizationResponse401 = {
  data: UnauthorizedError
  status: 401
}

export type accountUsersRemoveOrganizationResponse403 = {
  data: ForbiddenError
  status: 403
}

export type accountUsersRemoveOrganizationResponse404 = {
  data: NotFoundError
  status: 404
}

export type accountUsersRemoveOrganizationResponse500 = {
  data: InternalServerError
  status: 500
}
    
export type accountUsersRemoveOrganizationResponseComposite = accountUsersRemoveOrganizationResponse200 | accountUsersRemoveOrganizationResponse400 | accountUsersRemoveOrganizationResponse401 | accountUsersRemoveOrganizationResponse403 | accountUsersRemoveOrganizationResponse404 | accountUsersRemoveOrganizationResponse500;
    
export type accountUsersRemoveOrganizationResponse = accountUsersRemoveOrganizationResponseComposite & {
  headers: Headers;
}

export const getAccountUsersRemoveOrganizationUrl = (id: number,) => {


  

  return `/api/account/users/${id}/remove_organization/`
}

export const accountUsersRemoveOrganization = async (id: number,
    removeOrgRequest: RemoveOrgRequest, options?: RequestInit): Promise<accountUsersRemoveOrganizationResponse> => {
  
  return apiMutator<accountUsersRemoveOrganizationResponse>(getAccountUsersRemoveOrganizationUrl(id),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      removeOrgRequest,)
  }
);}



export type accountValidateInvitationListResponse200 = {
  data: null
  status: 200
}
    
export type accountValidateInvitationListResponseComposite = accountValidateInvitationListResponse200;
    
export type accountValidateInvitationListResponse = accountValidateInvitationListResponseComposite & {
  headers: Headers;
}

export const getAccountValidateInvitationListUrl = () => {


  

  return `/api/account/validate-invitation/`
}

export const accountValidateInvitationList = async ( options?: RequestInit): Promise<accountValidateInvitationListResponse> => {
  
  return apiMutator<accountValidateInvitationListResponse>(getAccountValidateInvitationListUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * Validate if the current user's session is still active.
 */
export type accountValidateSessionListResponse200 = {
  data: ValidateSessionResponse
  status: 200
}

export type accountValidateSessionListResponse401 = {
  data: GeneralError
  status: 401
}

export type accountValidateSessionListResponse500 = {
  data: GeneralError
  status: 500
}
    
export type accountValidateSessionListResponseComposite = accountValidateSessionListResponse200 | accountValidateSessionListResponse401 | accountValidateSessionListResponse500;
    
export type accountValidateSessionListResponse = accountValidateSessionListResponseComposite & {
  headers: Headers;
}

export const getAccountValidateSessionListUrl = () => {


  

  return `/api/account/validate-session/`
}

export const accountValidateSessionList = async ( options?: RequestInit): Promise<accountValidateSessionListResponse> => {
  
  return apiMutator<accountValidateSessionListResponse>(getAccountValidateSessionListUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * Verify a user's email using a token sent via email.
 */
export type accountVerifyCreateResponse200 = {
  data: VerifyEmailResponse
  status: 200
}

export type accountVerifyCreateResponse400 = {
  data: ValidationError
  status: 400
}

export type accountVerifyCreateResponse500 = {
  data: GeneralError
  status: 500
}
    
export type accountVerifyCreateResponseComposite = accountVerifyCreateResponse200 | accountVerifyCreateResponse400 | accountVerifyCreateResponse500;
    
export type accountVerifyCreateResponse = accountVerifyCreateResponseComposite & {
  headers: Headers;
}

export const getAccountVerifyCreateUrl = (token: string,) => {


  

  return `/api/account/verify/${token}/`
}

export const accountVerifyCreate = async (token: string, options?: RequestInit): Promise<accountVerifyCreateResponse> => {
  
  return apiMutator<accountVerifyCreateResponse>(getAccountVerifyCreateUrl(token),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}



/**
 * Retrieve all image IDs and GPS coordinates for a specific mission.
 * @summary Get Mission Image Metadata
 */
export type agricamImagesMetaDataReadResponse200 = {
  data: null
  status: 200
}

export type agricamImagesMetaDataReadResponse404 = {
  data: null
  status: 404
}

export type agricamImagesMetaDataReadResponse500 = {
  data: null
  status: 500
}
    
export type agricamImagesMetaDataReadResponseComposite = agricamImagesMetaDataReadResponse200 | agricamImagesMetaDataReadResponse404 | agricamImagesMetaDataReadResponse500;
    
export type agricamImagesMetaDataReadResponse = agricamImagesMetaDataReadResponseComposite & {
  headers: Headers;
}

export const getAgricamImagesMetaDataReadUrl = (missionId: string,) => {


  

  return `/api/agricam/images/meta-data/${missionId}/`
}

export const agricamImagesMetaDataRead = async (missionId: string, options?: RequestInit): Promise<agricamImagesMetaDataReadResponse> => {
  
  return apiMutator<agricamImagesMetaDataReadResponse>(getAgricamImagesMetaDataReadUrl(missionId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * Upload and save an image along with its metadata.
 * @summary Save Image
 */
export type agricamImagesUploadCreateResponse201 = {
  data: null
  status: 201
}

export type agricamImagesUploadCreateResponse400 = {
  data: null
  status: 400
}

export type agricamImagesUploadCreateResponse500 = {
  data: null
  status: 500
}
    
export type agricamImagesUploadCreateResponseComposite = agricamImagesUploadCreateResponse201 | agricamImagesUploadCreateResponse400 | agricamImagesUploadCreateResponse500;
    
export type agricamImagesUploadCreateResponse = agricamImagesUploadCreateResponseComposite & {
  headers: Headers;
}

export const getAgricamImagesUploadCreateUrl = () => {


  

  return `/api/agricam/images/upload/`
}

export const agricamImagesUploadCreate = async (agricamImagesUploadCreateBody: AgricamImagesUploadCreateBody, options?: RequestInit): Promise<agricamImagesUploadCreateResponse> => {
  
  return apiMutator<agricamImagesUploadCreateResponse>(getAgricamImagesUploadCreateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      agricamImagesUploadCreateBody,)
  }
);}



/**
 * Fetch the JPEG data and metadata for the specified image ID.
 * @summary Retrieve Image Data
 */
export type agricamImagesReadResponse200 = {
  data: Image
  status: 200
}

export type agricamImagesReadResponse404 = {
  data: null
  status: 404
}

export type agricamImagesReadResponse500 = {
  data: null
  status: 500
}
    
export type agricamImagesReadResponseComposite = agricamImagesReadResponse200 | agricamImagesReadResponse404 | agricamImagesReadResponse500;
    
export type agricamImagesReadResponse = agricamImagesReadResponseComposite & {
  headers: Headers;
}

export const getAgricamImagesReadUrl = (imageId: string,) => {


  

  return `/api/agricam/images/${imageId}/`
}

export const agricamImagesRead = async (imageId: string, options?: RequestInit): Promise<agricamImagesReadResponse> => {
  
  return apiMutator<agricamImagesReadResponse>(getAgricamImagesReadUrl(imageId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * ViewSet for managing Agricam missions.
 */
export type agricamMissionsListResponse200 = {
  data: AgricamMission[]
  status: 200
}

export type agricamMissionsListResponse400 = {
  data: ValidationError
  status: 400
}

export type agricamMissionsListResponse500 = {
  data: GeneralError
  status: 500
}
    
export type agricamMissionsListResponseComposite = agricamMissionsListResponse200 | agricamMissionsListResponse400 | agricamMissionsListResponse500;
    
export type agricamMissionsListResponse = agricamMissionsListResponseComposite & {
  headers: Headers;
}

export const getAgricamMissionsListUrl = () => {


  

  return `/api/agricam/missions/`
}

export const agricamMissionsList = async ( options?: RequestInit): Promise<agricamMissionsListResponse> => {
  
  return apiMutator<agricamMissionsListResponse>(getAgricamMissionsListUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * This API allows you to create a new mission for 'Agricam' and associates it with the 'SiFly' organization. The created mission is linked to the active campaign, if one exists, or the most recently created campaign if no active campaign is found.
 * @summary Create Agricam Mission
 */
export type agricamMissionsCreateResponse201 = {
  data: AgricamMission
  status: 201
}

export type agricamMissionsCreateResponse400 = {
  data: ValidationError
  status: 400
}

export type agricamMissionsCreateResponse500 = {
  data: GeneralError
  status: 500
}
    
export type agricamMissionsCreateResponseComposite = agricamMissionsCreateResponse201 | agricamMissionsCreateResponse400 | agricamMissionsCreateResponse500;
    
export type agricamMissionsCreateResponse = agricamMissionsCreateResponseComposite & {
  headers: Headers;
}

export const getAgricamMissionsCreateUrl = () => {


  

  return `/api/agricam/missions/`
}

export const agricamMissionsCreate = async (agricamMissionsCreateBody: AgricamMissionsCreateBody, options?: RequestInit): Promise<agricamMissionsCreateResponse> => {
  
  return apiMutator<agricamMissionsCreateResponse>(getAgricamMissionsCreateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      agricamMissionsCreateBody,)
  }
);}



/**
 * ViewSet for managing Agricam missions.
 */
export type agricamMissionsReadResponse200 = {
  data: AgricamMission
  status: 200
}

export type agricamMissionsReadResponse404 = {
  data: GeneralError
  status: 404
}

export type agricamMissionsReadResponse500 = {
  data: GeneralError
  status: 500
}
    
export type agricamMissionsReadResponseComposite = agricamMissionsReadResponse200 | agricamMissionsReadResponse404 | agricamMissionsReadResponse500;
    
export type agricamMissionsReadResponse = agricamMissionsReadResponseComposite & {
  headers: Headers;
}

export const getAgricamMissionsReadUrl = (id: string,) => {


  

  return `/api/agricam/missions/${id}/`
}

export const agricamMissionsRead = async (id: string, options?: RequestInit): Promise<agricamMissionsReadResponse> => {
  
  return apiMutator<agricamMissionsReadResponse>(getAgricamMissionsReadUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * ViewSet for managing Agricam missions.
 */
export type agricamMissionsUpdateResponse200 = {
  data: AgricamMission
  status: 200
}

export type agricamMissionsUpdateResponse400 = {
  data: ValidationError
  status: 400
}

export type agricamMissionsUpdateResponse404 = {
  data: GeneralError
  status: 404
}
    
export type agricamMissionsUpdateResponseComposite = agricamMissionsUpdateResponse200 | agricamMissionsUpdateResponse400 | agricamMissionsUpdateResponse404;
    
export type agricamMissionsUpdateResponse = agricamMissionsUpdateResponseComposite & {
  headers: Headers;
}

export const getAgricamMissionsUpdateUrl = (id: string,) => {


  

  return `/api/agricam/missions/${id}/`
}

export const agricamMissionsUpdate = async (id: string,
    agricamMission: NonReadonly<AgricamMission>, options?: RequestInit): Promise<agricamMissionsUpdateResponse> => {
  
  return apiMutator<agricamMissionsUpdateResponse>(getAgricamMissionsUpdateUrl(id),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      agricamMission,)
  }
);}



/**
 * ViewSet for managing Agricam missions.
 */
export type agricamMissionsDeleteResponse204 = {
  data: null
  status: 204
}

export type agricamMissionsDeleteResponse404 = {
  data: GeneralError
  status: 404
}
    
export type agricamMissionsDeleteResponseComposite = agricamMissionsDeleteResponse204 | agricamMissionsDeleteResponse404;
    
export type agricamMissionsDeleteResponse = agricamMissionsDeleteResponseComposite & {
  headers: Headers;
}

export const getAgricamMissionsDeleteUrl = (id: string,) => {


  

  return `/api/agricam/missions/${id}/`
}

export const agricamMissionsDelete = async (id: string, options?: RequestInit): Promise<agricamMissionsDeleteResponse> => {
  
  return apiMutator<agricamMissionsDeleteResponse>(getAgricamMissionsDeleteUrl(id),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}



/**
 * Return bootstrap data for the authenticated user.
 */
export type authBootstrapListResponse200 = {
  data: null
  status: 200
}
    
export type authBootstrapListResponseComposite = authBootstrapListResponse200;
    
export type authBootstrapListResponse = authBootstrapListResponseComposite & {
  headers: Headers;
}

export const getAuthBootstrapListUrl = () => {


  

  return `/api/auth/bootstrap`
}

export const authBootstrapList = async ( options?: RequestInit): Promise<authBootstrapListResponse> => {
  
  return apiMutator<authBootstrapListResponse>(getAuthBootstrapListUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * Clear the user's session.
 */
export type authLogoutCreateResponse201 = {
  data: null
  status: 201
}
    
export type authLogoutCreateResponseComposite = authLogoutCreateResponse201;
    
export type authLogoutCreateResponse = authLogoutCreateResponseComposite & {
  headers: Headers;
}

export const getAuthLogoutCreateUrl = () => {


  

  return `/api/auth/logout`
}

export const authLogoutCreate = async ( options?: RequestInit): Promise<authLogoutCreateResponse> => {
  
  return apiMutator<authLogoutCreateResponse>(getAuthLogoutCreateUrl(),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}



/**
 * Create a Django session from a valid Clerk token.
 */
export type authSessionCreateResponse201 = {
  data: null
  status: 201
}
    
export type authSessionCreateResponseComposite = authSessionCreateResponse201;
    
export type authSessionCreateResponse = authSessionCreateResponseComposite & {
  headers: Headers;
}

export const getAuthSessionCreateUrl = () => {


  

  return `/api/auth/session`
}

export const authSessionCreate = async ( options?: RequestInit): Promise<authSessionCreateResponse> => {
  
  return apiMutator<authSessionCreateResponse>(getAuthSessionCreateUrl(),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}



/**
 * Receives confirmed voice commands from the ATC service and dispatches
them to the drone via MQTT. The ATC service only sends confirmed
commands — errors, cancellations, and timeouts are handled on its side.
 * @summary POST /api/crew/drone-command/
 */
export type crewAtcCallbackCreateResponse201 = {
  data: null
  status: 201
}
    
export type crewAtcCallbackCreateResponseComposite = crewAtcCallbackCreateResponse201;
    
export type crewAtcCallbackCreateResponse = crewAtcCallbackCreateResponseComposite & {
  headers: Headers;
}

export const getCrewAtcCallbackCreateUrl = (sessionId: string,
    droneUuid: string,) => {


  

  return `/api/crew/atc-callback/${sessionId}/${droneUuid}/`
}

export const crewAtcCallbackCreate = async (sessionId: string,
    droneUuid: string, options?: RequestInit): Promise<crewAtcCallbackCreateResponse> => {
  
  return apiMutator<crewAtcCallbackCreateResponse>(getCrewAtcCallbackCreateUrl(sessionId,droneUuid),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}



/**
 * @summary List campaigns across user's organizations (optionally filter by device's organization)
 */
export type crewCampaignsListResponse200 = {
  data: CrewCampaignListEnvelope
  status: 200
}
    
export type crewCampaignsListResponseComposite = crewCampaignsListResponse200;
    
export type crewCampaignsListResponse = crewCampaignsListResponseComposite & {
  headers: Headers;
}

export const getCrewCampaignsListUrl = (params?: CrewCampaignsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/crew/campaigns/?${stringifiedParams}` : `/api/crew/campaigns/`
}

export const crewCampaignsList = async (params?: CrewCampaignsListParams, options?: RequestInit): Promise<crewCampaignsListResponse> => {
  
  return apiMutator<crewCampaignsListResponse>(getCrewCampaignsListUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



export type crewCampaignsCreateResponse201 = {
  data: CrewCampaignSerializer
  status: 201
}

export type crewCampaignsCreateResponse400 = {
  data: ValidationError
  status: 400
}
    
export type crewCampaignsCreateResponseComposite = crewCampaignsCreateResponse201 | crewCampaignsCreateResponse400;
    
export type crewCampaignsCreateResponse = crewCampaignsCreateResponseComposite & {
  headers: Headers;
}

export const getCrewCampaignsCreateUrl = () => {


  

  return `/api/crew/campaigns/`
}

export const crewCampaignsCreate = async (crewCampaignSerializer: NonReadonly<CrewCampaignSerializer>, options?: RequestInit): Promise<crewCampaignsCreateResponse> => {
  
  return apiMutator<crewCampaignsCreateResponse>(getCrewCampaignsCreateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      crewCampaignSerializer,)
  }
);}



/**
 * HTTP 302 redirect to active session landing URL.
This endpoint replaces the standard retrieve endpoint.
Public endpoint - no authentication required for redirect.
 * @summary HTTP redirect to active session landing URL (public endpoint)
 */
export type crewCampaignsSessionRedirectResponse200 = {
  data: CrewCampaignSerializer
  status: 200
}

export type crewCampaignsSessionRedirectResponse302 = {
  data: null
  status: 302
}

export type crewCampaignsSessionRedirectResponse404 = {
  data: CrewCampaignsSessionRedirect404
  status: 404
}
    
export type crewCampaignsSessionRedirectResponseComposite = crewCampaignsSessionRedirectResponse200 | crewCampaignsSessionRedirectResponse302 | crewCampaignsSessionRedirectResponse404;
    
export type crewCampaignsSessionRedirectResponse = crewCampaignsSessionRedirectResponseComposite & {
  headers: Headers;
}

export const getCrewCampaignsSessionRedirectUrl = (id: string,) => {


  

  return `/api/crew/campaigns/${id}/`
}

export const crewCampaignsSessionRedirect = async (id: string, options?: RequestInit): Promise<crewCampaignsSessionRedirectResponse> => {
  
  return apiMutator<crewCampaignsSessionRedirectResponse>(getCrewCampaignsSessionRedirectUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Get active session for a campaign
 */
export type crewCampaignsGetSessionResponse200 = {
  data: CampaignSessionEnvelope
  status: 200
}

export type crewCampaignsGetSessionResponse404 = {
  data: null
  status: 404
}
    
export type crewCampaignsGetSessionResponseComposite = crewCampaignsGetSessionResponse200 | crewCampaignsGetSessionResponse404;
    
export type crewCampaignsGetSessionResponse = crewCampaignsGetSessionResponseComposite & {
  headers: Headers;
}

export const getCrewCampaignsGetSessionUrl = (id: string,) => {


  

  return `/api/crew/campaigns/${id}/shared-sessions/`
}

export const crewCampaignsGetSession = async (id: string, options?: RequestInit): Promise<crewCampaignsGetSessionResponse> => {
  
  return apiMutator<crewCampaignsGetSessionResponse>(getCrewCampaignsGetSessionUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * Accepts a command and dispatches it based on type:
- pressed_push_to_command  → snapshot + mute + callback
- released / cancel / timeout / in_progress → restore snapshot
- TAKE_OFF / LAND / FLY_TO / HOVER / ORBIT → MQTT publish
 * @summary POST /api/crew/drone-command/
 */
export type crewDroneCommandCreateResponse201 = {
  data: null
  status: 201
}
    
export type crewDroneCommandCreateResponseComposite = crewDroneCommandCreateResponse201;
    
export type crewDroneCommandCreateResponse = crewDroneCommandCreateResponseComposite & {
  headers: Headers;
}

export const getCrewDroneCommandCreateUrl = () => {


  

  return `/api/crew/drone-command/`
}

export const crewDroneCommandCreate = async ( options?: RequestInit): Promise<crewDroneCommandCreateResponse> => {
  
  return apiMutator<crewDroneCommandCreateResponse>(getCrewDroneCommandCreateUrl(),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}



/**
 * @summary List shared sessions (status=enabled by default)
 */
export type crewSharedSessionsListResponse200 = {
  data: SharedSessionListEnvelope
  status: 200
}
    
export type crewSharedSessionsListResponseComposite = crewSharedSessionsListResponse200;
    
export type crewSharedSessionsListResponse = crewSharedSessionsListResponseComposite & {
  headers: Headers;
}

export const getCrewSharedSessionsListUrl = (params?: CrewSharedSessionsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/crew/shared-sessions/?${stringifiedParams}` : `/api/crew/shared-sessions/`
}

export const crewSharedSessionsList = async (params?: CrewSharedSessionsListParams, options?: RequestInit): Promise<crewSharedSessionsListResponse> => {
  
  return apiMutator<crewSharedSessionsListResponse>(getCrewSharedSessionsListUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Create a shared session (owner = request.user)
 */
export type crewSharedSessionsCreateResponse201 = {
  data: SharedSessionCreateEnvelope
  status: 201
}

export type crewSharedSessionsCreateResponse400 = {
  data: null
  status: 400
}
    
export type crewSharedSessionsCreateResponseComposite = crewSharedSessionsCreateResponse201 | crewSharedSessionsCreateResponse400;
    
export type crewSharedSessionsCreateResponse = crewSharedSessionsCreateResponseComposite & {
  headers: Headers;
}

export const getCrewSharedSessionsCreateUrl = () => {


  

  return `/api/crew/shared-sessions/`
}

export const crewSharedSessionsCreate = async (createSharedSessionRequest: CreateSharedSessionRequest, options?: RequestInit): Promise<crewSharedSessionsCreateResponse> => {
  
  return apiMutator<crewSharedSessionsCreateResponse>(getCrewSharedSessionsCreateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createSharedSessionRequest,)
  }
);}



/**
 * @summary List shared sessions by organization (status=enabled by default)
 */
export type crewSharedSessionsByOrganizationResponse200 = {
  data: SharedSessionListEnvelope
  status: 200
}
    
export type crewSharedSessionsByOrganizationResponseComposite = crewSharedSessionsByOrganizationResponse200;
    
export type crewSharedSessionsByOrganizationResponse = crewSharedSessionsByOrganizationResponseComposite & {
  headers: Headers;
}

export const getCrewSharedSessionsByOrganizationUrl = (organizationId: string,
    params?: CrewSharedSessionsByOrganizationParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/crew/shared-sessions/by-organization/${organizationId}/?${stringifiedParams}` : `/api/crew/shared-sessions/by-organization/${organizationId}/`
}

export const crewSharedSessionsByOrganization = async (organizationId: string,
    params?: CrewSharedSessionsByOrganizationParams, options?: RequestInit): Promise<crewSharedSessionsByOrganizationResponse> => {
  
  return apiMutator<crewSharedSessionsByOrganizationResponse>(getCrewSharedSessionsByOrganizationUrl(organizationId,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Get a shared session
 */
export type crewSharedSessionsRetrieveResponse200 = {
  data: SharedSessionEnvelope
  status: 200
}

export type crewSharedSessionsRetrieveResponse404 = {
  data: null
  status: 404
}
    
export type crewSharedSessionsRetrieveResponseComposite = crewSharedSessionsRetrieveResponse200 | crewSharedSessionsRetrieveResponse404;
    
export type crewSharedSessionsRetrieveResponse = crewSharedSessionsRetrieveResponseComposite & {
  headers: Headers;
}

export const getCrewSharedSessionsRetrieveUrl = (id: string,) => {


  

  return `/api/crew/shared-sessions/${id}/`
}

export const crewSharedSessionsRetrieve = async (id: string, options?: RequestInit): Promise<crewSharedSessionsRetrieveResponse> => {
  
  return apiMutator<crewSharedSessionsRetrieveResponse>(getCrewSharedSessionsRetrieveUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Enable a shared session (actor = request.user)
 */
export type crewSharedSessionsEnableResponse200 = {
  data: SharedSessionEnvelope
  status: 200
}

export type crewSharedSessionsEnableResponse404 = {
  data: null
  status: 404
}
    
export type crewSharedSessionsEnableResponseComposite = crewSharedSessionsEnableResponse200 | crewSharedSessionsEnableResponse404;
    
export type crewSharedSessionsEnableResponse = crewSharedSessionsEnableResponseComposite & {
  headers: Headers;
}

export const getCrewSharedSessionsEnableUrl = (id: string,) => {


  

  return `/api/crew/shared-sessions/${id}/enable/`
}

export const crewSharedSessionsEnable = async (id: string,
    crewEmptyBody: CrewEmptyBody, options?: RequestInit): Promise<crewSharedSessionsEnableResponse> => {
  
  return apiMutator<crewSharedSessionsEnableResponse>(getCrewSharedSessionsEnableUrl(id),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      crewEmptyBody,)
  }
);}



/**
 * @summary Ping a shared session (owner-only) to keep it alive
 */
export type crewSharedSessionsPingResponse200 = {
  data: SharedSessionEnvelope
  status: 200
}
    
export type crewSharedSessionsPingResponseComposite = crewSharedSessionsPingResponse200;
    
export type crewSharedSessionsPingResponse = crewSharedSessionsPingResponseComposite & {
  headers: Headers;
}

export const getCrewSharedSessionsPingUrl = (id: string,) => {


  

  return `/api/crew/shared-sessions/${id}/ping/`
}

export const crewSharedSessionsPing = async (id: string,
    crewEmptyBody: CrewEmptyBody, options?: RequestInit): Promise<crewSharedSessionsPingResponse> => {
  
  return apiMutator<crewSharedSessionsPingResponse>(getCrewSharedSessionsPingUrl(id),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      crewEmptyBody,)
  }
);}



/**
 * @summary Stop a shared session (actor = request.user)
 */
export type crewSharedSessionsStopResponse200 = {
  data: SharedSessionEnvelope
  status: 200
}

export type crewSharedSessionsStopResponse404 = {
  data: null
  status: 404
}
    
export type crewSharedSessionsStopResponseComposite = crewSharedSessionsStopResponse200 | crewSharedSessionsStopResponse404;
    
export type crewSharedSessionsStopResponse = crewSharedSessionsStopResponseComposite & {
  headers: Headers;
}

export const getCrewSharedSessionsStopUrl = (id: string,) => {


  

  return `/api/crew/shared-sessions/${id}/stop/`
}

export const crewSharedSessionsStop = async (id: string,
    crewEmptyBody: CrewEmptyBody, options?: RequestInit): Promise<crewSharedSessionsStopResponse> => {
  
  return apiMutator<crewSharedSessionsStopResponse>(getCrewSharedSessionsStopUrl(id),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      crewEmptyBody,)
  }
);}



/**
 * Dispatches an ATC command for the authenticated participant. Use `command=start` with optional `device_uuids` in the request body, or `command=end` with an empty body.
 * @summary Dispatch an ATC command for a shared session
 */
export type crewAtcCommandDispatchResponse200 = {
  data: ATCCommandEnvelope
  status: 200
}

export type crewAtcCommandDispatchResponse400 = {
  data: ValidationError
  status: 400
}

export type crewAtcCommandDispatchResponse401 = {
  data: UnauthorizedError
  status: 401
}

export type crewAtcCommandDispatchResponse403 = {
  data: ForbiddenError
  status: 403
}

export type crewAtcCommandDispatchResponse404 = {
  data: NotFoundError
  status: 404
}

export type crewAtcCommandDispatchResponse500 = {
  data: InternalServerError
  status: 500
}
    
export type crewAtcCommandDispatchResponseComposite = crewAtcCommandDispatchResponse200 | crewAtcCommandDispatchResponse400 | crewAtcCommandDispatchResponse401 | crewAtcCommandDispatchResponse403 | crewAtcCommandDispatchResponse404 | crewAtcCommandDispatchResponse500;
    
export type crewAtcCommandDispatchResponse = crewAtcCommandDispatchResponseComposite & {
  headers: Headers;
}

export const getCrewAtcCommandDispatchUrl = (sharedSessionId: string,
    command: string,) => {


  

  return `/api/crew/shared-sessions/${sharedSessionId}/atc-command/${command}`
}

export const crewAtcCommandDispatch = async (sharedSessionId: string,
    command: string,
    aTCStartCommandRequest: ATCStartCommandRequest, options?: RequestInit): Promise<crewAtcCommandDispatchResponse> => {
  
  return apiMutator<crewAtcCommandDispatchResponse>(getCrewAtcCommandDispatchUrl(sharedSessionId,command),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      aTCStartCommandRequest,)
  }
);}



/**
 * @summary List participants in a shared session
 */
export type crewSharedSessionsParticipantsListResponse200 = {
  data: ParticipantListEnvelope
  status: 200
}
    
export type crewSharedSessionsParticipantsListResponseComposite = crewSharedSessionsParticipantsListResponse200;
    
export type crewSharedSessionsParticipantsListResponse = crewSharedSessionsParticipantsListResponseComposite & {
  headers: Headers;
}

export const getCrewSharedSessionsParticipantsListUrl = (sharedSessionId: string,) => {


  

  return `/api/crew/shared-sessions/${sharedSessionId}/participants/`
}

export const crewSharedSessionsParticipantsList = async (sharedSessionId: string, options?: RequestInit): Promise<crewSharedSessionsParticipantsListResponse> => {
  
  return apiMutator<crewSharedSessionsParticipantsListResponse>(getCrewSharedSessionsParticipantsListUrl(sharedSessionId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Register anonymous participant (write-once display_name)
 */
export type crewSharedSessionsParticipantsRegisterAnonymousResponse201 = {
  data: ParticipantEnvelope
  status: 201
}

export type crewSharedSessionsParticipantsRegisterAnonymousResponse400 = {
  data: ValidationError
  status: 400
}

export type crewSharedSessionsParticipantsRegisterAnonymousResponse401 = {
  data: UnauthorizedError
  status: 401
}

export type crewSharedSessionsParticipantsRegisterAnonymousResponse403 = {
  data: ForbiddenError
  status: 403
}

export type crewSharedSessionsParticipantsRegisterAnonymousResponse404 = {
  data: NotFoundError
  status: 404
}

export type crewSharedSessionsParticipantsRegisterAnonymousResponse500 = {
  data: InternalServerError
  status: 500
}
    
export type crewSharedSessionsParticipantsRegisterAnonymousResponseComposite = crewSharedSessionsParticipantsRegisterAnonymousResponse201 | crewSharedSessionsParticipantsRegisterAnonymousResponse400 | crewSharedSessionsParticipantsRegisterAnonymousResponse401 | crewSharedSessionsParticipantsRegisterAnonymousResponse403 | crewSharedSessionsParticipantsRegisterAnonymousResponse404 | crewSharedSessionsParticipantsRegisterAnonymousResponse500;
    
export type crewSharedSessionsParticipantsRegisterAnonymousResponse = crewSharedSessionsParticipantsRegisterAnonymousResponseComposite & {
  headers: Headers;
}

export const getCrewSharedSessionsParticipantsRegisterAnonymousUrl = (sharedSessionId: string,) => {


  

  return `/api/crew/shared-sessions/${sharedSessionId}/participants/anonymous`
}

export const crewSharedSessionsParticipantsRegisterAnonymous = async (sharedSessionId: string,
    participantCreateAnonymousRequest: ParticipantCreateAnonymousRequest, options?: RequestInit): Promise<crewSharedSessionsParticipantsRegisterAnonymousResponse> => {
  
  return apiMutator<crewSharedSessionsParticipantsRegisterAnonymousResponse>(getCrewSharedSessionsParticipantsRegisterAnonymousUrl(sharedSessionId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      participantCreateAnonymousRequest,)
  }
);}



/**
 * @summary Register authenticated participant (idempotent)
 */
export type crewSharedSessionsParticipantsRegisterAuthResponse200 = {
  data: ParticipantEnvelope
  status: 200
}

export type crewSharedSessionsParticipantsRegisterAuthResponse400 = {
  data: ValidationError
  status: 400
}

export type crewSharedSessionsParticipantsRegisterAuthResponse401 = {
  data: UnauthorizedError
  status: 401
}

export type crewSharedSessionsParticipantsRegisterAuthResponse403 = {
  data: ForbiddenError
  status: 403
}

export type crewSharedSessionsParticipantsRegisterAuthResponse404 = {
  data: NotFoundError
  status: 404
}

export type crewSharedSessionsParticipantsRegisterAuthResponse500 = {
  data: InternalServerError
  status: 500
}
    
export type crewSharedSessionsParticipantsRegisterAuthResponseComposite = crewSharedSessionsParticipantsRegisterAuthResponse200 | crewSharedSessionsParticipantsRegisterAuthResponse400 | crewSharedSessionsParticipantsRegisterAuthResponse401 | crewSharedSessionsParticipantsRegisterAuthResponse403 | crewSharedSessionsParticipantsRegisterAuthResponse404 | crewSharedSessionsParticipantsRegisterAuthResponse500;
    
export type crewSharedSessionsParticipantsRegisterAuthResponse = crewSharedSessionsParticipantsRegisterAuthResponseComposite & {
  headers: Headers;
}

export const getCrewSharedSessionsParticipantsRegisterAuthUrl = (sharedSessionId: string,) => {


  

  return `/api/crew/shared-sessions/${sharedSessionId}/participants/auth`
}

export const crewSharedSessionsParticipantsRegisterAuth = async (sharedSessionId: string,
    crewEmptyBody: CrewEmptyBody, options?: RequestInit): Promise<crewSharedSessionsParticipantsRegisterAuthResponse> => {
  
  return apiMutator<crewSharedSessionsParticipantsRegisterAuthResponse>(getCrewSharedSessionsParticipantsRegisterAuthUrl(sharedSessionId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      crewEmptyBody,)
  }
);}



/**
 * GET historic telemetry for a session/participant/device.
Anonymous allowed; we authorize via session/participant checks in the service.
 * @summary Historic telemetry (with optional downsampling)
 */
export type crewSharedSessionsParticipantsDeviceTelemetryListResponse200 = {
  data: CrewTelemetryListEnvelope
  status: 200
}

export type crewSharedSessionsParticipantsDeviceTelemetryListResponse400 = {
  data: ValidationError
  status: 400
}

export type crewSharedSessionsParticipantsDeviceTelemetryListResponse401 = {
  data: UnauthorizedError
  status: 401
}

export type crewSharedSessionsParticipantsDeviceTelemetryListResponse403 = {
  data: ForbiddenError
  status: 403
}

export type crewSharedSessionsParticipantsDeviceTelemetryListResponse404 = {
  data: NotFoundError
  status: 404
}

export type crewSharedSessionsParticipantsDeviceTelemetryListResponse500 = {
  data: InternalServerError
  status: 500
}
    
export type crewSharedSessionsParticipantsDeviceTelemetryListResponseComposite = crewSharedSessionsParticipantsDeviceTelemetryListResponse200 | crewSharedSessionsParticipantsDeviceTelemetryListResponse400 | crewSharedSessionsParticipantsDeviceTelemetryListResponse401 | crewSharedSessionsParticipantsDeviceTelemetryListResponse403 | crewSharedSessionsParticipantsDeviceTelemetryListResponse404 | crewSharedSessionsParticipantsDeviceTelemetryListResponse500;
    
export type crewSharedSessionsParticipantsDeviceTelemetryListResponse = crewSharedSessionsParticipantsDeviceTelemetryListResponseComposite & {
  headers: Headers;
}

export const getCrewSharedSessionsParticipantsDeviceTelemetryListUrl = (sharedSessionId: string,
    participantId: string,
    deviceUuid: string,
    params?: CrewSharedSessionsParticipantsDeviceTelemetryListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/crew/shared-sessions/${sharedSessionId}/participants/${participantId}/device/${deviceUuid}/telemetry/?${stringifiedParams}` : `/api/crew/shared-sessions/${sharedSessionId}/participants/${participantId}/device/${deviceUuid}/telemetry/`
}

export const crewSharedSessionsParticipantsDeviceTelemetryList = async (sharedSessionId: string,
    participantId: string,
    deviceUuid: string,
    params?: CrewSharedSessionsParticipantsDeviceTelemetryListParams, options?: RequestInit): Promise<crewSharedSessionsParticipantsDeviceTelemetryListResponse> => {
  
  return apiMutator<crewSharedSessionsParticipantsDeviceTelemetryListResponse>(getCrewSharedSessionsParticipantsDeviceTelemetryListUrl(sharedSessionId,participantId,deviceUuid,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * Generate access token and connection information for joining a voice chat room. This endpoint replaces the WebSocket-based voice chat connection. The frontend should use the returned credentials to connect directly to the voice chat provider (e.g., LiveKit SDK).
 * @summary Generate voice chat credentials
 */
export type crewSharedSessionsParticipantsVoiceChatCredentialsCreateResponse200 = {
  data: VoiceChatCredentialsEnvelope
  status: 200
}

export type crewSharedSessionsParticipantsVoiceChatCredentialsCreateResponse400 = {
  data: ValidationError
  status: 400
}

export type crewSharedSessionsParticipantsVoiceChatCredentialsCreateResponse401 = {
  data: UnauthorizedError
  status: 401
}

export type crewSharedSessionsParticipantsVoiceChatCredentialsCreateResponse403 = {
  data: ForbiddenError
  status: 403
}

export type crewSharedSessionsParticipantsVoiceChatCredentialsCreateResponse404 = {
  data: NotFoundError
  status: 404
}

export type crewSharedSessionsParticipantsVoiceChatCredentialsCreateResponse500 = {
  data: InternalServerError
  status: 500
}
    
export type crewSharedSessionsParticipantsVoiceChatCredentialsCreateResponseComposite = crewSharedSessionsParticipantsVoiceChatCredentialsCreateResponse200 | crewSharedSessionsParticipantsVoiceChatCredentialsCreateResponse400 | crewSharedSessionsParticipantsVoiceChatCredentialsCreateResponse401 | crewSharedSessionsParticipantsVoiceChatCredentialsCreateResponse403 | crewSharedSessionsParticipantsVoiceChatCredentialsCreateResponse404 | crewSharedSessionsParticipantsVoiceChatCredentialsCreateResponse500;
    
export type crewSharedSessionsParticipantsVoiceChatCredentialsCreateResponse = crewSharedSessionsParticipantsVoiceChatCredentialsCreateResponseComposite & {
  headers: Headers;
}

export const getCrewSharedSessionsParticipantsVoiceChatCredentialsCreateUrl = (sharedSessionId: string,
    participantId: string,) => {


  

  return `/api/crew/shared-sessions/${sharedSessionId}/participants/${participantId}/voice-chat/credentials/`
}

export const crewSharedSessionsParticipantsVoiceChatCredentialsCreate = async (sharedSessionId: string,
    participantId: string,
    crewSharedSessionsParticipantsVoiceChatCredentialsCreateBody: CrewSharedSessionsParticipantsVoiceChatCredentialsCreateBody, options?: RequestInit): Promise<crewSharedSessionsParticipantsVoiceChatCredentialsCreateResponse> => {
  
  return apiMutator<crewSharedSessionsParticipantsVoiceChatCredentialsCreateResponse>(getCrewSharedSessionsParticipantsVoiceChatCredentialsCreateUrl(sharedSessionId,participantId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      crewSharedSessionsParticipantsVoiceChatCredentialsCreateBody,)
  }
);}



/**
 * Fetches terrain elevation data from Auterion's terrain API. Responses are cached based on query parameters to reduce redundant requests. This endpoint bypasses CORS restrictions.
 * @summary Get terrain carpet data (CORS proxy with caching)
 */
export type crewTerrainCarpetListResponse200 = {
  data: CrewTerrainCarpetList200
  status: 200
}

export type crewTerrainCarpetListResponse400 = {
  data: ValidationError
  status: 400
}

export type crewTerrainCarpetListResponse401 = {
  data: UnauthorizedError
  status: 401
}

export type crewTerrainCarpetListResponse403 = {
  data: ForbiddenError
  status: 403
}

export type crewTerrainCarpetListResponse404 = {
  data: NotFoundError
  status: 404
}

export type crewTerrainCarpetListResponse500 = {
  data: InternalServerError
  status: 500
}
    
export type crewTerrainCarpetListResponseComposite = crewTerrainCarpetListResponse200 | crewTerrainCarpetListResponse400 | crewTerrainCarpetListResponse401 | crewTerrainCarpetListResponse403 | crewTerrainCarpetListResponse404 | crewTerrainCarpetListResponse500;
    
export type crewTerrainCarpetListResponse = crewTerrainCarpetListResponseComposite & {
  headers: Headers;
}

export const getCrewTerrainCarpetListUrl = (params: CrewTerrainCarpetListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/crew/terrain/carpet/?${stringifiedParams}` : `/api/crew/terrain/carpet/`
}

export const crewTerrainCarpetList = async (params: CrewTerrainCarpetListParams, options?: RequestInit): Promise<crewTerrainCarpetListResponse> => {
  
  return apiMutator<crewTerrainCarpetListResponse>(getCrewTerrainCarpetListUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * Generate access token and connection information for joining a voice chat room using email. This endpoint looks up the user by email, finds the user's enabled session, gets or creates a participant for the user, and updates last_seen. This endpoint does not require CSRF token. The frontend should use the returned credentials to connect directly to the voice chat provider (e.g., LiveKit SDK).
 * @summary Join voice chat room with user info
 */
export type crewVoiceChatJoinCreateResponse200 = {
  data: VoiceChatCredentialsEnvelope
  status: 200
}

export type crewVoiceChatJoinCreateResponse400 = {
  data: ValidationError
  status: 400
}

export type crewVoiceChatJoinCreateResponse401 = {
  data: UnauthorizedError
  status: 401
}

export type crewVoiceChatJoinCreateResponse403 = {
  data: ForbiddenError
  status: 403
}

export type crewVoiceChatJoinCreateResponse404 = {
  data: NotFoundError
  status: 404
}

export type crewVoiceChatJoinCreateResponse500 = {
  data: InternalServerError
  status: 500
}
    
export type crewVoiceChatJoinCreateResponseComposite = crewVoiceChatJoinCreateResponse200 | crewVoiceChatJoinCreateResponse400 | crewVoiceChatJoinCreateResponse401 | crewVoiceChatJoinCreateResponse403 | crewVoiceChatJoinCreateResponse404 | crewVoiceChatJoinCreateResponse500;
    
export type crewVoiceChatJoinCreateResponse = crewVoiceChatJoinCreateResponseComposite & {
  headers: Headers;
}

export const getCrewVoiceChatJoinCreateUrl = () => {


  

  return `/api/crew/voice-chat/join/`
}

export const crewVoiceChatJoinCreate = async (voiceChatJoinRequestEnvelope: VoiceChatJoinRequestEnvelope, options?: RequestInit): Promise<crewVoiceChatJoinCreateResponse> => {
  
  return apiMutator<crewVoiceChatJoinCreateResponse>(getCrewVoiceChatJoinCreateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      voiceChatJoinRequestEnvelope,)
  }
);}



export type droneCommanderCampaignsListResponse200 = {
  data: Campaign[]
  status: 200
}

export type droneCommanderCampaignsListResponse400 = {
  data: ValidationError
  status: 400
}

export type droneCommanderCampaignsListResponse500 = {
  data: GeneralError
  status: 500
}
    
export type droneCommanderCampaignsListResponseComposite = droneCommanderCampaignsListResponse200 | droneCommanderCampaignsListResponse400 | droneCommanderCampaignsListResponse500;
    
export type droneCommanderCampaignsListResponse = droneCommanderCampaignsListResponseComposite & {
  headers: Headers;
}

export const getDroneCommanderCampaignsListUrl = () => {


  

  return `/api/drone_commander/campaigns/`
}

export const droneCommanderCampaignsList = async ( options?: RequestInit): Promise<droneCommanderCampaignsListResponse> => {
  
  return apiMutator<droneCommanderCampaignsListResponse>(getDroneCommanderCampaignsListUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * Create a new campaign in the system. Requires valid campaign data including name, description, organization, drones, and status.
 */
export type droneCommanderCampaignsCreateResponse201 = {
  data: CompaignCreateResponseEnvelope
  status: 201
}

export type droneCommanderCampaignsCreateResponse400 = {
  data: ValidationError
  status: 400
}

export type droneCommanderCampaignsCreateResponse401 = {
  data: UnauthorizedError
  status: 401
}

export type droneCommanderCampaignsCreateResponse403 = {
  data: ForbiddenError
  status: 403
}

export type droneCommanderCampaignsCreateResponse404 = {
  data: NotFoundError
  status: 404
}

export type droneCommanderCampaignsCreateResponse500 = {
  data: InternalServerError
  status: 500
}
    
export type droneCommanderCampaignsCreateResponseComposite = droneCommanderCampaignsCreateResponse201 | droneCommanderCampaignsCreateResponse400 | droneCommanderCampaignsCreateResponse401 | droneCommanderCampaignsCreateResponse403 | droneCommanderCampaignsCreateResponse404 | droneCommanderCampaignsCreateResponse500;
    
export type droneCommanderCampaignsCreateResponse = droneCommanderCampaignsCreateResponseComposite & {
  headers: Headers;
}

export const getDroneCommanderCampaignsCreateUrl = () => {


  

  return `/api/drone_commander/campaigns/`
}

export const droneCommanderCampaignsCreate = async (campaignCreateInput: CampaignCreateInput, options?: RequestInit): Promise<droneCommanderCampaignsCreateResponse> => {
  
  return apiMutator<droneCommanderCampaignsCreateResponse>(getDroneCommanderCampaignsCreateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      campaignCreateInput,)
  }
);}



/**
 * Add a verified user to a specific campaign.
 * @summary Add a User to a Campaign
 */
export type droneCommanderCampaignsAddUsersResponse201 = {
  data: MessageResponseEnvelope
  status: 201
}

export type droneCommanderCampaignsAddUsersResponse400 = {
  data: ValidationError
  status: 400
}

export type droneCommanderCampaignsAddUsersResponse401 = {
  data: UnauthorizedError
  status: 401
}

export type droneCommanderCampaignsAddUsersResponse403 = {
  data: ForbiddenError
  status: 403
}

export type droneCommanderCampaignsAddUsersResponse404 = {
  data: NotFoundError
  status: 404
}

export type droneCommanderCampaignsAddUsersResponse500 = {
  data: InternalServerError
  status: 500
}
    
export type droneCommanderCampaignsAddUsersResponseComposite = droneCommanderCampaignsAddUsersResponse201 | droneCommanderCampaignsAddUsersResponse400 | droneCommanderCampaignsAddUsersResponse401 | droneCommanderCampaignsAddUsersResponse403 | droneCommanderCampaignsAddUsersResponse404 | droneCommanderCampaignsAddUsersResponse500;
    
export type droneCommanderCampaignsAddUsersResponse = droneCommanderCampaignsAddUsersResponseComposite & {
  headers: Headers;
}

export const getDroneCommanderCampaignsAddUsersUrl = () => {


  

  return `/api/drone_commander/campaigns/add-users/`
}

export const droneCommanderCampaignsAddUsers = async (campaignUserUpdateInputBody: CampaignUserUpdateInputBody, options?: RequestInit): Promise<droneCommanderCampaignsAddUsersResponse> => {
  
  return apiMutator<droneCommanderCampaignsAddUsersResponse>(getDroneCommanderCampaignsAddUsersUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      campaignUserUpdateInputBody,)
  }
);}



/**
 * Retrieve a list of all campaigns for a specific organization.
 */
export type droneCommanderCampaignsOrgReadResponse200 = {
  data: CampaignListEnvelopeResponse
  status: 200
}

export type droneCommanderCampaignsOrgReadResponse400 = {
  data: ValidationError
  status: 400
}

export type droneCommanderCampaignsOrgReadResponse401 = {
  data: UnauthorizedError
  status: 401
}

export type droneCommanderCampaignsOrgReadResponse403 = {
  data: ForbiddenError
  status: 403
}

export type droneCommanderCampaignsOrgReadResponse404 = {
  data: NotFoundError
  status: 404
}

export type droneCommanderCampaignsOrgReadResponse500 = {
  data: InternalServerError
  status: 500
}
    
export type droneCommanderCampaignsOrgReadResponseComposite = droneCommanderCampaignsOrgReadResponse200 | droneCommanderCampaignsOrgReadResponse400 | droneCommanderCampaignsOrgReadResponse401 | droneCommanderCampaignsOrgReadResponse403 | droneCommanderCampaignsOrgReadResponse404 | droneCommanderCampaignsOrgReadResponse500;
    
export type droneCommanderCampaignsOrgReadResponse = droneCommanderCampaignsOrgReadResponseComposite & {
  headers: Headers;
}

export const getDroneCommanderCampaignsOrgReadUrl = (orgId: string,) => {


  

  return `/api/drone_commander/campaigns/org/${orgId}/`
}

export const droneCommanderCampaignsOrgRead = async (orgId: string, options?: RequestInit): Promise<droneCommanderCampaignsOrgReadResponse> => {
  
  return apiMutator<droneCommanderCampaignsOrgReadResponse>(getDroneCommanderCampaignsOrgReadUrl(orgId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * Remove a verified user from a specific campaign.
 * @summary Remove a User from a Campaign
 */
export type droneCommanderCampaignsRemoveUsersResponse204 = {
  data: NoneResponseEnvelope
  status: 204
}

export type droneCommanderCampaignsRemoveUsersResponse400 = {
  data: ValidationError
  status: 400
}

export type droneCommanderCampaignsRemoveUsersResponse401 = {
  data: UnauthorizedError
  status: 401
}

export type droneCommanderCampaignsRemoveUsersResponse403 = {
  data: ForbiddenError
  status: 403
}

export type droneCommanderCampaignsRemoveUsersResponse404 = {
  data: NotFoundError
  status: 404
}

export type droneCommanderCampaignsRemoveUsersResponse500 = {
  data: InternalServerError
  status: 500
}
    
export type droneCommanderCampaignsRemoveUsersResponseComposite = droneCommanderCampaignsRemoveUsersResponse204 | droneCommanderCampaignsRemoveUsersResponse400 | droneCommanderCampaignsRemoveUsersResponse401 | droneCommanderCampaignsRemoveUsersResponse403 | droneCommanderCampaignsRemoveUsersResponse404 | droneCommanderCampaignsRemoveUsersResponse500;
    
export type droneCommanderCampaignsRemoveUsersResponse = droneCommanderCampaignsRemoveUsersResponseComposite & {
  headers: Headers;
}

export const getDroneCommanderCampaignsRemoveUsersUrl = () => {


  

  return `/api/drone_commander/campaigns/remove-users/`
}

export const droneCommanderCampaignsRemoveUsers = async (campaignUserUpdateInputBody: CampaignUserUpdateInputBody, options?: RequestInit): Promise<droneCommanderCampaignsRemoveUsersResponse> => {
  
  return apiMutator<droneCommanderCampaignsRemoveUsersResponse>(getDroneCommanderCampaignsRemoveUsersUrl(),
  {      
    ...options,
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      campaignUserUpdateInputBody,)
  }
);}



export type droneCommanderCampaignsReadResponse200 = {
  data: Campaign
  status: 200
}

export type droneCommanderCampaignsReadResponse404 = {
  data: GeneralError
  status: 404
}

export type droneCommanderCampaignsReadResponse500 = {
  data: GeneralError
  status: 500
}
    
export type droneCommanderCampaignsReadResponseComposite = droneCommanderCampaignsReadResponse200 | droneCommanderCampaignsReadResponse404 | droneCommanderCampaignsReadResponse500;
    
export type droneCommanderCampaignsReadResponse = droneCommanderCampaignsReadResponseComposite & {
  headers: Headers;
}

export const getDroneCommanderCampaignsReadUrl = (id: string,) => {


  

  return `/api/drone_commander/campaigns/${id}/`
}

export const droneCommanderCampaignsRead = async (id: string, options?: RequestInit): Promise<droneCommanderCampaignsReadResponse> => {
  
  return apiMutator<droneCommanderCampaignsReadResponse>(getDroneCommanderCampaignsReadUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



export type droneCommanderCampaignsUpdateResponse200 = {
  data: CampaignUpdateInput
  status: 200
}

export type droneCommanderCampaignsUpdateResponse400 = {
  data: ValidationError
  status: 400
}

export type droneCommanderCampaignsUpdateResponse404 = {
  data: GeneralError
  status: 404
}
    
export type droneCommanderCampaignsUpdateResponseComposite = droneCommanderCampaignsUpdateResponse200 | droneCommanderCampaignsUpdateResponse400 | droneCommanderCampaignsUpdateResponse404;
    
export type droneCommanderCampaignsUpdateResponse = droneCommanderCampaignsUpdateResponseComposite & {
  headers: Headers;
}

export const getDroneCommanderCampaignsUpdateUrl = (id: string,) => {


  

  return `/api/drone_commander/campaigns/${id}/`
}

export const droneCommanderCampaignsUpdate = async (id: string,
    campaignUpdateInputBody: CampaignUpdateInputBody, options?: RequestInit): Promise<droneCommanderCampaignsUpdateResponse> => {
  
  return apiMutator<droneCommanderCampaignsUpdateResponse>(getDroneCommanderCampaignsUpdateUrl(id),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      campaignUpdateInputBody,)
  }
);}



/**
 * Update status and enable_dronesense fields of a campaign.
 */
export type droneCommanderCampaignsPartialUpdateResponse200 = {
  data: CompaignUpdateResponseEnvelope
  status: 200
}

export type droneCommanderCampaignsPartialUpdateResponse400 = {
  data: ValidationError
  status: 400
}

export type droneCommanderCampaignsPartialUpdateResponse401 = {
  data: UnauthorizedError
  status: 401
}

export type droneCommanderCampaignsPartialUpdateResponse403 = {
  data: ForbiddenError
  status: 403
}

export type droneCommanderCampaignsPartialUpdateResponse404 = {
  data: NotFoundError
  status: 404
}

export type droneCommanderCampaignsPartialUpdateResponse500 = {
  data: InternalServerError
  status: 500
}
    
export type droneCommanderCampaignsPartialUpdateResponseComposite = droneCommanderCampaignsPartialUpdateResponse200 | droneCommanderCampaignsPartialUpdateResponse400 | droneCommanderCampaignsPartialUpdateResponse401 | droneCommanderCampaignsPartialUpdateResponse403 | droneCommanderCampaignsPartialUpdateResponse404 | droneCommanderCampaignsPartialUpdateResponse500;
    
export type droneCommanderCampaignsPartialUpdateResponse = droneCommanderCampaignsPartialUpdateResponseComposite & {
  headers: Headers;
}

export const getDroneCommanderCampaignsPartialUpdateUrl = (id: string,) => {


  

  return `/api/drone_commander/campaigns/${id}/`
}

export const droneCommanderCampaignsPartialUpdate = async (id: string,
    campaignUpdateInputBody: CampaignUpdateInputBody, options?: RequestInit): Promise<droneCommanderCampaignsPartialUpdateResponse> => {
  
  return apiMutator<droneCommanderCampaignsPartialUpdateResponse>(getDroneCommanderCampaignsPartialUpdateUrl(id),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      campaignUpdateInputBody,)
  }
);}



/**
 * Permanently delete a campaign in the system. Campaign must be inactive before deletion.
 */
export type droneCommanderCampaignsDeleteResponse204 = {
  data: null
  status: 204
}

export type droneCommanderCampaignsDeleteResponse400 = {
  data: ValidationError
  status: 400
}

export type droneCommanderCampaignsDeleteResponse401 = {
  data: UnauthorizedError
  status: 401
}

export type droneCommanderCampaignsDeleteResponse403 = {
  data: ForbiddenError
  status: 403
}

export type droneCommanderCampaignsDeleteResponse404 = {
  data: NotFoundError
  status: 404
}

export type droneCommanderCampaignsDeleteResponse500 = {
  data: InternalServerError
  status: 500
}
    
export type droneCommanderCampaignsDeleteResponseComposite = droneCommanderCampaignsDeleteResponse204 | droneCommanderCampaignsDeleteResponse400 | droneCommanderCampaignsDeleteResponse401 | droneCommanderCampaignsDeleteResponse403 | droneCommanderCampaignsDeleteResponse404 | droneCommanderCampaignsDeleteResponse500;
    
export type droneCommanderCampaignsDeleteResponse = droneCommanderCampaignsDeleteResponseComposite & {
  headers: Headers;
}

export const getDroneCommanderCampaignsDeleteUrl = (id: string,) => {


  

  return `/api/drone_commander/campaigns/${id}/`
}

export const droneCommanderCampaignsDelete = async (id: string, options?: RequestInit): Promise<droneCommanderCampaignsDeleteResponse> => {
  
  return apiMutator<droneCommanderCampaignsDeleteResponse>(getDroneCommanderCampaignsDeleteUrl(id),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}



/**
 * Retrieve all users associated with a campaign and the current controller.
 * @summary Get Users in Campaign
 */
export type droneCommanderCampaignsGetCampaignUsersResponse200 = {
  data: CampaignGetUsersResponse
  status: 200
}

export type droneCommanderCampaignsGetCampaignUsersResponse400 = {
  data: ValidationError
  status: 400
}

export type droneCommanderCampaignsGetCampaignUsersResponse401 = {
  data: UnauthorizedError
  status: 401
}

export type droneCommanderCampaignsGetCampaignUsersResponse403 = {
  data: ForbiddenError
  status: 403
}

export type droneCommanderCampaignsGetCampaignUsersResponse404 = {
  data: NotFoundError
  status: 404
}

export type droneCommanderCampaignsGetCampaignUsersResponse500 = {
  data: InternalServerError
  status: 500
}
    
export type droneCommanderCampaignsGetCampaignUsersResponseComposite = droneCommanderCampaignsGetCampaignUsersResponse200 | droneCommanderCampaignsGetCampaignUsersResponse400 | droneCommanderCampaignsGetCampaignUsersResponse401 | droneCommanderCampaignsGetCampaignUsersResponse403 | droneCommanderCampaignsGetCampaignUsersResponse404 | droneCommanderCampaignsGetCampaignUsersResponse500;
    
export type droneCommanderCampaignsGetCampaignUsersResponse = droneCommanderCampaignsGetCampaignUsersResponseComposite & {
  headers: Headers;
}

export const getDroneCommanderCampaignsGetCampaignUsersUrl = (id: string,) => {


  

  return `/api/drone_commander/campaigns/${id}/users/`
}

export const droneCommanderCampaignsGetCampaignUsers = async (id: string, options?: RequestInit): Promise<droneCommanderCampaignsGetCampaignUsersResponse> => {
  
  return apiMutator<droneCommanderCampaignsGetCampaignUsersResponse>(getDroneCommanderCampaignsGetCampaignUsersUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * Retrieve detailed information about a specific device using the device_uuid field. User must have permission to access the device (belong to the device's organization or be a superuser).
 * @summary Get device details by device UUID
 */
export type droneCommanderDeviceDetailsResponse200 = {
  data: DeviceRetrieveApiResponse
  status: 200
}

export type droneCommanderDeviceDetailsResponse401 = {
  data: UnauthorizedError
  status: 401
}

export type droneCommanderDeviceDetailsResponse403 = {
  data: ForbiddenError
  status: 403
}

export type droneCommanderDeviceDetailsResponse404 = {
  data: NotFoundError
  status: 404
}

export type droneCommanderDeviceDetailsResponse500 = {
  data: InternalServerError
  status: 500
}
    
export type droneCommanderDeviceDetailsResponseComposite = droneCommanderDeviceDetailsResponse200 | droneCommanderDeviceDetailsResponse401 | droneCommanderDeviceDetailsResponse403 | droneCommanderDeviceDetailsResponse404 | droneCommanderDeviceDetailsResponse500;
    
export type droneCommanderDeviceDetailsResponse = droneCommanderDeviceDetailsResponseComposite & {
  headers: Headers;
}

export const getDroneCommanderDeviceDetailsUrl = (deviceId: string,) => {


  

  return `/api/drone_commander/device-details/${deviceId}/`
}

export const droneCommanderDeviceDetails = async (deviceId: string, options?: RequestInit): Promise<droneCommanderDeviceDetailsResponse> => {
  
  return apiMutator<droneCommanderDeviceDetailsResponse>(getDroneCommanderDeviceDetailsUrl(deviceId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * Retrieve a list of all device types in the system. This endpoint is accessible to all authenticated users.
 * @summary List device types
 */
export type droneCommanderDeviceTypesListResponse200 = {
  data: DroneCommanderDeviceTypesList200
  status: 200
}

export type droneCommanderDeviceTypesListResponse401 = {
  data: DroneCommanderDeviceTypesList401
  status: 401
}
    
export type droneCommanderDeviceTypesListResponseComposite = droneCommanderDeviceTypesListResponse200 | droneCommanderDeviceTypesListResponse401;
    
export type droneCommanderDeviceTypesListResponse = droneCommanderDeviceTypesListResponseComposite & {
  headers: Headers;
}

export const getDroneCommanderDeviceTypesListUrl = () => {


  

  return `/api/drone_commander/device-types/`
}

export const droneCommanderDeviceTypesList = async ( options?: RequestInit): Promise<droneCommanderDeviceTypesListResponse> => {
  
  return apiMutator<droneCommanderDeviceTypesListResponse>(getDroneCommanderDeviceTypesListUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * Create a new device type. Requires 'view_create_device_types' permission.
 * @summary Create device type
 */
export type droneCommanderDeviceTypesCreateResponse201 = {
  data: DeviceType
  status: 201
}

export type droneCommanderDeviceTypesCreateResponse400 = {
  data: DroneCommanderDeviceTypesCreate400
  status: 400
}

export type droneCommanderDeviceTypesCreateResponse403 = {
  data: DroneCommanderDeviceTypesCreate403
  status: 403
}
    
export type droneCommanderDeviceTypesCreateResponseComposite = droneCommanderDeviceTypesCreateResponse201 | droneCommanderDeviceTypesCreateResponse400 | droneCommanderDeviceTypesCreateResponse403;
    
export type droneCommanderDeviceTypesCreateResponse = droneCommanderDeviceTypesCreateResponseComposite & {
  headers: Headers;
}

export const getDroneCommanderDeviceTypesCreateUrl = () => {


  

  return `/api/drone_commander/device-types/`
}

export const droneCommanderDeviceTypesCreate = async (deviceTypeBody: DeviceTypeBody, options?: RequestInit): Promise<droneCommanderDeviceTypesCreateResponse> => {
  
  return apiMutator<droneCommanderDeviceTypesCreateResponse>(getDroneCommanderDeviceTypesCreateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      deviceTypeBody,)
  }
);}



/**
 * Retrieve a specific device type by its ID. Requires 'view_retrieve_device_types' permission.
 * @summary Get device type by ID
 */
export type droneCommanderDeviceTypesReadResponse200 = {
  data: DroneCommanderDeviceTypesRead200
  status: 200
}

export type droneCommanderDeviceTypesReadResponse403 = {
  data: DroneCommanderDeviceTypesRead403
  status: 403
}

export type droneCommanderDeviceTypesReadResponse404 = {
  data: DroneCommanderDeviceTypesRead404
  status: 404
}
    
export type droneCommanderDeviceTypesReadResponseComposite = droneCommanderDeviceTypesReadResponse200 | droneCommanderDeviceTypesReadResponse403 | droneCommanderDeviceTypesReadResponse404;
    
export type droneCommanderDeviceTypesReadResponse = droneCommanderDeviceTypesReadResponseComposite & {
  headers: Headers;
}

export const getDroneCommanderDeviceTypesReadUrl = (id: string,) => {


  

  return `/api/drone_commander/device-types/${id}/`
}

export const droneCommanderDeviceTypesRead = async (id: string, options?: RequestInit): Promise<droneCommanderDeviceTypesReadResponse> => {
  
  return apiMutator<droneCommanderDeviceTypesReadResponse>(getDroneCommanderDeviceTypesReadUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * Update an existing device type. Requires 'view_update_device_types' permission.
 * @summary Update device type
 */
export type droneCommanderDeviceTypesUpdateResponse200 = {
  data: DeviceType
  status: 200
}

export type droneCommanderDeviceTypesUpdateResponse400 = {
  data: DroneCommanderDeviceTypesUpdate400
  status: 400
}

export type droneCommanderDeviceTypesUpdateResponse403 = {
  data: DroneCommanderDeviceTypesUpdate403
  status: 403
}

export type droneCommanderDeviceTypesUpdateResponse404 = {
  data: DroneCommanderDeviceTypesUpdate404
  status: 404
}
    
export type droneCommanderDeviceTypesUpdateResponseComposite = droneCommanderDeviceTypesUpdateResponse200 | droneCommanderDeviceTypesUpdateResponse400 | droneCommanderDeviceTypesUpdateResponse403 | droneCommanderDeviceTypesUpdateResponse404;
    
export type droneCommanderDeviceTypesUpdateResponse = droneCommanderDeviceTypesUpdateResponseComposite & {
  headers: Headers;
}

export const getDroneCommanderDeviceTypesUpdateUrl = (id: string,) => {


  

  return `/api/drone_commander/device-types/${id}/`
}

export const droneCommanderDeviceTypesUpdate = async (id: string,
    deviceTypeBody: DeviceTypeBody, options?: RequestInit): Promise<droneCommanderDeviceTypesUpdateResponse> => {
  
  return apiMutator<droneCommanderDeviceTypesUpdateResponse>(getDroneCommanderDeviceTypesUpdateUrl(id),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      deviceTypeBody,)
  }
);}



/**
 * Partially update an existing device type. Requires 'view_update_device_types' permission.
 * @summary Partially update device type
 */
export type droneCommanderDeviceTypesPartialUpdateResponse200 = {
  data: DeviceType
  status: 200
}

export type droneCommanderDeviceTypesPartialUpdateResponse400 = {
  data: DroneCommanderDeviceTypesPartialUpdate400
  status: 400
}

export type droneCommanderDeviceTypesPartialUpdateResponse403 = {
  data: DroneCommanderDeviceTypesPartialUpdate403
  status: 403
}

export type droneCommanderDeviceTypesPartialUpdateResponse404 = {
  data: DroneCommanderDeviceTypesPartialUpdate404
  status: 404
}
    
export type droneCommanderDeviceTypesPartialUpdateResponseComposite = droneCommanderDeviceTypesPartialUpdateResponse200 | droneCommanderDeviceTypesPartialUpdateResponse400 | droneCommanderDeviceTypesPartialUpdateResponse403 | droneCommanderDeviceTypesPartialUpdateResponse404;
    
export type droneCommanderDeviceTypesPartialUpdateResponse = droneCommanderDeviceTypesPartialUpdateResponseComposite & {
  headers: Headers;
}

export const getDroneCommanderDeviceTypesPartialUpdateUrl = (id: string,) => {


  

  return `/api/drone_commander/device-types/${id}/`
}

export const droneCommanderDeviceTypesPartialUpdate = async (id: string,
    deviceTypeBody: DeviceTypeBody, options?: RequestInit): Promise<droneCommanderDeviceTypesPartialUpdateResponse> => {
  
  return apiMutator<droneCommanderDeviceTypesPartialUpdateResponse>(getDroneCommanderDeviceTypesPartialUpdateUrl(id),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      deviceTypeBody,)
  }
);}



/**
 * Delete an existing device type. Requires 'view_delete_device_types' permission.
 * @summary Delete device type
 */
export type droneCommanderDeviceTypesDeleteResponse204 = {
  data: null
  status: 204
}

export type droneCommanderDeviceTypesDeleteResponse403 = {
  data: DroneCommanderDeviceTypesDelete403
  status: 403
}

export type droneCommanderDeviceTypesDeleteResponse404 = {
  data: DroneCommanderDeviceTypesDelete404
  status: 404
}
    
export type droneCommanderDeviceTypesDeleteResponseComposite = droneCommanderDeviceTypesDeleteResponse204 | droneCommanderDeviceTypesDeleteResponse403 | droneCommanderDeviceTypesDeleteResponse404;
    
export type droneCommanderDeviceTypesDeleteResponse = droneCommanderDeviceTypesDeleteResponseComposite & {
  headers: Headers;
}

export const getDroneCommanderDeviceTypesDeleteUrl = (id: string,) => {


  

  return `/api/drone_commander/device-types/${id}/`
}

export const droneCommanderDeviceTypesDelete = async (id: string, options?: RequestInit): Promise<droneCommanderDeviceTypesDeleteResponse> => {
  
  return apiMutator<droneCommanderDeviceTypesDeleteResponse>(getDroneCommanderDeviceTypesDeleteUrl(id),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}



/**
 * Retrieve a list of all devices. Requires 'view_all_devices' permission. If user doesn't have permission, returns 403 Forbidden.
 * @summary List all devices
 */
export type droneCommanderDevicesListResponse200 = {
  data: DeviceListApiResponse
  status: 200
}

export type droneCommanderDevicesListResponse401 = {
  data: UnauthorizedError
  status: 401
}

export type droneCommanderDevicesListResponse403 = {
  data: ForbiddenError
  status: 403
}

export type droneCommanderDevicesListResponse500 = {
  data: InternalServerError
  status: 500
}
    
export type droneCommanderDevicesListResponseComposite = droneCommanderDevicesListResponse200 | droneCommanderDevicesListResponse401 | droneCommanderDevicesListResponse403 | droneCommanderDevicesListResponse500;
    
export type droneCommanderDevicesListResponse = droneCommanderDevicesListResponseComposite & {
  headers: Headers;
}

export const getDroneCommanderDevicesListUrl = (params?: DroneCommanderDevicesListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/drone_commander/devices/?${stringifiedParams}` : `/api/drone_commander/devices/`
}

export const droneCommanderDevicesList = async (params?: DroneCommanderDevicesListParams, options?: RequestInit): Promise<droneCommanderDevicesListResponse> => {
  
  return apiMutator<droneCommanderDevicesListResponse>(getDroneCommanderDevicesListUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * Create a new device. Requires 'manufacture' permission. If no organization is specified, the device will be created without an organization or assigned to the user's first organization.
 * @summary Create a new device
 */
export type droneCommanderDevicesCreateResponse201 = {
  data: DeviceCreateApiResponse
  status: 201
}

export type droneCommanderDevicesCreateResponse400 = {
  data: ValidationError
  status: 400
}

export type droneCommanderDevicesCreateResponse401 = {
  data: UnauthorizedError
  status: 401
}

export type droneCommanderDevicesCreateResponse403 = {
  data: ForbiddenError
  status: 403
}

export type droneCommanderDevicesCreateResponse404 = {
  data: NotFoundError
  status: 404
}

export type droneCommanderDevicesCreateResponse500 = {
  data: InternalServerError
  status: 500
}
    
export type droneCommanderDevicesCreateResponseComposite = droneCommanderDevicesCreateResponse201 | droneCommanderDevicesCreateResponse400 | droneCommanderDevicesCreateResponse401 | droneCommanderDevicesCreateResponse403 | droneCommanderDevicesCreateResponse404 | droneCommanderDevicesCreateResponse500;
    
export type droneCommanderDevicesCreateResponse = droneCommanderDevicesCreateResponseComposite & {
  headers: Headers;
}

export const getDroneCommanderDevicesCreateUrl = () => {


  

  return `/api/drone_commander/devices/`
}

export const droneCommanderDevicesCreate = async (deviceCreate: NonReadonly<DeviceCreate>, options?: RequestInit): Promise<droneCommanderDevicesCreateResponse> => {
  
  return apiMutator<droneCommanderDevicesCreateResponse>(getDroneCommanderDevicesCreateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      deviceCreate,)
  }
);}



/**
 * Retrieve a paginated list of all devices in the system. Requires 'manufacture' permission. This endpoint shows all devices regardless of organization.
 * @summary Get all devices
 */
export type droneCommanderDevicesAllDevicesResponse200 = {
  data: DeviceListApiResponse
  status: 200
}

export type droneCommanderDevicesAllDevicesResponse401 = {
  data: UnauthorizedError
  status: 401
}

export type droneCommanderDevicesAllDevicesResponse403 = {
  data: ForbiddenError
  status: 403
}

export type droneCommanderDevicesAllDevicesResponse500 = {
  data: InternalServerError
  status: 500
}
    
export type droneCommanderDevicesAllDevicesResponseComposite = droneCommanderDevicesAllDevicesResponse200 | droneCommanderDevicesAllDevicesResponse401 | droneCommanderDevicesAllDevicesResponse403 | droneCommanderDevicesAllDevicesResponse500;
    
export type droneCommanderDevicesAllDevicesResponse = droneCommanderDevicesAllDevicesResponseComposite & {
  headers: Headers;
}

export const getDroneCommanderDevicesAllDevicesUrl = (params?: DroneCommanderDevicesAllDevicesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/drone_commander/devices/all/?${stringifiedParams}` : `/api/drone_commander/devices/all/`
}

export const droneCommanderDevicesAllDevices = async (params?: DroneCommanderDevicesAllDevicesParams, options?: RequestInit): Promise<droneCommanderDevicesAllDevicesResponse> => {
  
  return apiMutator<droneCommanderDevicesAllDevicesResponse>(getDroneCommanderDevicesAllDevicesUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * Check whether a device is registered using its device_uuid.
 * @summary Check device registration status
 */
export type droneCommanderDevicesCheckRegistrationResponse200 = {
  data: DeviceRegistrationStatusApiResponse
  status: 200
}

export type droneCommanderDevicesCheckRegistrationResponse400 = {
  data: ValidationError
  status: 400
}

export type droneCommanderDevicesCheckRegistrationResponse401 = {
  data: UnauthorizedError
  status: 401
}

export type droneCommanderDevicesCheckRegistrationResponse403 = {
  data: ForbiddenError
  status: 403
}

export type droneCommanderDevicesCheckRegistrationResponse404 = {
  data: NotFoundError
  status: 404
}

export type droneCommanderDevicesCheckRegistrationResponse500 = {
  data: InternalServerError
  status: 500
}
    
export type droneCommanderDevicesCheckRegistrationResponseComposite = droneCommanderDevicesCheckRegistrationResponse200 | droneCommanderDevicesCheckRegistrationResponse400 | droneCommanderDevicesCheckRegistrationResponse401 | droneCommanderDevicesCheckRegistrationResponse403 | droneCommanderDevicesCheckRegistrationResponse404 | droneCommanderDevicesCheckRegistrationResponse500;
    
export type droneCommanderDevicesCheckRegistrationResponse = droneCommanderDevicesCheckRegistrationResponseComposite & {
  headers: Headers;
}

export const getDroneCommanderDevicesCheckRegistrationUrl = (params: DroneCommanderDevicesCheckRegistrationParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/drone_commander/devices/check-registration/?${stringifiedParams}` : `/api/drone_commander/devices/check-registration/`
}

export const droneCommanderDevicesCheckRegistration = async (params: DroneCommanderDevicesCheckRegistrationParams, options?: RequestInit): Promise<droneCommanderDevicesCheckRegistrationResponse> => {
  
  return apiMutator<droneCommanderDevicesCheckRegistrationResponse>(getDroneCommanderDevicesCheckRegistrationUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * Register a device by linking it to the user's organization. The device must exist in the system and have an active heartbeat, but not be already registered to an organization.
 * @summary Register a device
 */
export type droneCommanderDevicesRegisterResponse200 = {
  data: DeviceRegistrationApiResponse
  status: 200
}

export type droneCommanderDevicesRegisterResponse400 = {
  data: ValidationError
  status: 400
}

export type droneCommanderDevicesRegisterResponse401 = {
  data: UnauthorizedError
  status: 401
}

export type droneCommanderDevicesRegisterResponse403 = {
  data: ForbiddenError
  status: 403
}

export type droneCommanderDevicesRegisterResponse404 = {
  data: NotFoundError
  status: 404
}

export type droneCommanderDevicesRegisterResponse500 = {
  data: InternalServerError
  status: 500
}
    
export type droneCommanderDevicesRegisterResponseComposite = droneCommanderDevicesRegisterResponse200 | droneCommanderDevicesRegisterResponse400 | droneCommanderDevicesRegisterResponse401 | droneCommanderDevicesRegisterResponse403 | droneCommanderDevicesRegisterResponse404 | droneCommanderDevicesRegisterResponse500;
    
export type droneCommanderDevicesRegisterResponse = droneCommanderDevicesRegisterResponseComposite & {
  headers: Headers;
}

export const getDroneCommanderDevicesRegisterUrl = () => {


  

  return `/api/drone_commander/devices/register/`
}

export const droneCommanderDevicesRegister = async (deviceRegistrationRequest: DeviceRegistrationRequest, options?: RequestInit): Promise<droneCommanderDevicesRegisterResponse> => {
  
  return apiMutator<droneCommanderDevicesRegisterResponse>(getDroneCommanderDevicesRegisterUrl(),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      deviceRegistrationRequest,)
  }
);}



/**
 * Retrieve a paginated list of devices that belong to the user's organization(s). Regular users can only see devices from their organizations, while superusers can see all devices. Now includes heartbeat data and device type details.
 * @summary Get registered devices
 */
export type droneCommanderDevicesRegisteredDevicesResponse200 = {
  data: DeviceListApiResponse
  status: 200
}

export type droneCommanderDevicesRegisteredDevicesResponse401 = {
  data: UnauthorizedError
  status: 401
}

export type droneCommanderDevicesRegisteredDevicesResponse403 = {
  data: ForbiddenError
  status: 403
}

export type droneCommanderDevicesRegisteredDevicesResponse500 = {
  data: InternalServerError
  status: 500
}
    
export type droneCommanderDevicesRegisteredDevicesResponseComposite = droneCommanderDevicesRegisteredDevicesResponse200 | droneCommanderDevicesRegisteredDevicesResponse401 | droneCommanderDevicesRegisteredDevicesResponse403 | droneCommanderDevicesRegisteredDevicesResponse500;
    
export type droneCommanderDevicesRegisteredDevicesResponse = droneCommanderDevicesRegisteredDevicesResponseComposite & {
  headers: Headers;
}

export const getDroneCommanderDevicesRegisteredDevicesUrl = (params?: DroneCommanderDevicesRegisteredDevicesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/drone_commander/devices/registered/?${stringifiedParams}` : `/api/drone_commander/devices/registered/`
}

export const droneCommanderDevicesRegisteredDevices = async (params?: DroneCommanderDevicesRegisteredDevicesParams, options?: RequestInit): Promise<droneCommanderDevicesRegisteredDevicesResponse> => {
  
  return apiMutator<droneCommanderDevicesRegisteredDevicesResponse>(getDroneCommanderDevicesRegisteredDevicesUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * Unregister a device by removing its organization link. The device must exist in the system and be currently registered to an organization that the user has access to.
 * @summary Unregister a device
 */
export type droneCommanderDevicesUnregisterResponse200 = {
  data: DeviceRegistrationApiResponse
  status: 200
}

export type droneCommanderDevicesUnregisterResponse400 = {
  data: ValidationError
  status: 400
}

export type droneCommanderDevicesUnregisterResponse401 = {
  data: UnauthorizedError
  status: 401
}

export type droneCommanderDevicesUnregisterResponse403 = {
  data: ForbiddenError
  status: 403
}

export type droneCommanderDevicesUnregisterResponse404 = {
  data: NotFoundError
  status: 404
}

export type droneCommanderDevicesUnregisterResponse500 = {
  data: InternalServerError
  status: 500
}
    
export type droneCommanderDevicesUnregisterResponseComposite = droneCommanderDevicesUnregisterResponse200 | droneCommanderDevicesUnregisterResponse400 | droneCommanderDevicesUnregisterResponse401 | droneCommanderDevicesUnregisterResponse403 | droneCommanderDevicesUnregisterResponse404 | droneCommanderDevicesUnregisterResponse500;
    
export type droneCommanderDevicesUnregisterResponse = droneCommanderDevicesUnregisterResponseComposite & {
  headers: Headers;
}

export const getDroneCommanderDevicesUnregisterUrl = () => {


  

  return `/api/drone_commander/devices/unregister/`
}

export const droneCommanderDevicesUnregister = async (deviceUnregistrationRequest: DeviceUnregistrationRequest, options?: RequestInit): Promise<droneCommanderDevicesUnregisterResponse> => {
  
  return apiMutator<droneCommanderDevicesUnregisterResponse>(getDroneCommanderDevicesUnregisterUrl(),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      deviceUnregistrationRequest,)
  }
);}



/**
 * Retrieve a device by its ID. User must have permission to access the device (belong to the device's organization or be a superuser). Returns detailed device information including device type, settings, and heartbeat data.
 * @summary Get device by ID
 */
export type droneCommanderDevicesReadResponse200 = {
  data: DeviceRetrieveApiResponse
  status: 200
}

export type droneCommanderDevicesReadResponse401 = {
  data: UnauthorizedError
  status: 401
}

export type droneCommanderDevicesReadResponse403 = {
  data: ForbiddenError
  status: 403
}

export type droneCommanderDevicesReadResponse404 = {
  data: NotFoundError
  status: 404
}

export type droneCommanderDevicesReadResponse500 = {
  data: InternalServerError
  status: 500
}
    
export type droneCommanderDevicesReadResponseComposite = droneCommanderDevicesReadResponse200 | droneCommanderDevicesReadResponse401 | droneCommanderDevicesReadResponse403 | droneCommanderDevicesReadResponse404 | droneCommanderDevicesReadResponse500;
    
export type droneCommanderDevicesReadResponse = droneCommanderDevicesReadResponseComposite & {
  headers: Headers;
}

export const getDroneCommanderDevicesReadUrl = (id: string,) => {


  

  return `/api/drone_commander/devices/${id}/`
}

export const droneCommanderDevicesRead = async (id: string, options?: RequestInit): Promise<droneCommanderDevicesReadResponse> => {
  
  return apiMutator<droneCommanderDevicesReadResponse>(getDroneCommanderDevicesReadUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



export type droneCommanderDevicesUpdateResponse200 = {
  data: Device
  status: 200
}

export type droneCommanderDevicesUpdateResponse400 = {
  data: ValidationError
  status: 400
}

export type droneCommanderDevicesUpdateResponse404 = {
  data: GeneralError
  status: 404
}
    
export type droneCommanderDevicesUpdateResponseComposite = droneCommanderDevicesUpdateResponse200 | droneCommanderDevicesUpdateResponse400 | droneCommanderDevicesUpdateResponse404;
    
export type droneCommanderDevicesUpdateResponse = droneCommanderDevicesUpdateResponseComposite & {
  headers: Headers;
}

export const getDroneCommanderDevicesUpdateUrl = (id: string,) => {


  

  return `/api/drone_commander/devices/${id}/`
}

export const droneCommanderDevicesUpdate = async (id: string,
    device: NonReadonly<Device>, options?: RequestInit): Promise<droneCommanderDevicesUpdateResponse> => {
  
  return apiMutator<droneCommanderDevicesUpdateResponse>(getDroneCommanderDevicesUpdateUrl(id),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      device,)
  }
);}



/**
 * Partially update a device. User must have permission to access the device (belong to the device's organization or be a superuser).
 * @summary Update a device
 */
export type droneCommanderDevicesPartialUpdateResponse200 = {
  data: DeviceUpdateApiResponse
  status: 200
}

export type droneCommanderDevicesPartialUpdateResponse400 = {
  data: ValidationError
  status: 400
}

export type droneCommanderDevicesPartialUpdateResponse401 = {
  data: UnauthorizedError
  status: 401
}

export type droneCommanderDevicesPartialUpdateResponse403 = {
  data: ForbiddenError
  status: 403
}

export type droneCommanderDevicesPartialUpdateResponse404 = {
  data: NotFoundError
  status: 404
}

export type droneCommanderDevicesPartialUpdateResponse500 = {
  data: InternalServerError
  status: 500
}
    
export type droneCommanderDevicesPartialUpdateResponseComposite = droneCommanderDevicesPartialUpdateResponse200 | droneCommanderDevicesPartialUpdateResponse400 | droneCommanderDevicesPartialUpdateResponse401 | droneCommanderDevicesPartialUpdateResponse403 | droneCommanderDevicesPartialUpdateResponse404 | droneCommanderDevicesPartialUpdateResponse500;
    
export type droneCommanderDevicesPartialUpdateResponse = droneCommanderDevicesPartialUpdateResponseComposite & {
  headers: Headers;
}

export const getDroneCommanderDevicesPartialUpdateUrl = (id: string,) => {


  

  return `/api/drone_commander/devices/${id}/`
}

export const droneCommanderDevicesPartialUpdate = async (id: string,
    deviceUpdateRequest: DeviceUpdateRequest, options?: RequestInit): Promise<droneCommanderDevicesPartialUpdateResponse> => {
  
  return apiMutator<droneCommanderDevicesPartialUpdateResponse>(getDroneCommanderDevicesPartialUpdateUrl(id),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      deviceUpdateRequest,)
  }
);}



/**
 * Delete a device. User must have permission to access the device (belong to the device's organization or be a superuser).
 * @summary Delete a device
 */
export type droneCommanderDevicesDeleteResponse200 = {
  data: DeviceDeleteApiResponse
  status: 200
}

export type droneCommanderDevicesDeleteResponse401 = {
  data: UnauthorizedError
  status: 401
}

export type droneCommanderDevicesDeleteResponse403 = {
  data: ForbiddenError
  status: 403
}

export type droneCommanderDevicesDeleteResponse404 = {
  data: NotFoundError
  status: 404
}

export type droneCommanderDevicesDeleteResponse500 = {
  data: InternalServerError
  status: 500
}
    
export type droneCommanderDevicesDeleteResponseComposite = droneCommanderDevicesDeleteResponse200 | droneCommanderDevicesDeleteResponse401 | droneCommanderDevicesDeleteResponse403 | droneCommanderDevicesDeleteResponse404 | droneCommanderDevicesDeleteResponse500;
    
export type droneCommanderDevicesDeleteResponse = droneCommanderDevicesDeleteResponseComposite & {
  headers: Headers;
}

export const getDroneCommanderDevicesDeleteUrl = (id: string,) => {


  

  return `/api/drone_commander/devices/${id}/`
}

export const droneCommanderDevicesDelete = async (id: string, options?: RequestInit): Promise<droneCommanderDevicesDeleteResponse> => {
  
  return apiMutator<droneCommanderDevicesDeleteResponse>(getDroneCommanderDevicesDeleteUrl(id),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}



export type droneCommanderDroneModelsListResponse200 = {
  data: DroneModel[]
  status: 200
}

export type droneCommanderDroneModelsListResponse400 = {
  data: ValidationError
  status: 400
}

export type droneCommanderDroneModelsListResponse500 = {
  data: GeneralError
  status: 500
}
    
export type droneCommanderDroneModelsListResponseComposite = droneCommanderDroneModelsListResponse200 | droneCommanderDroneModelsListResponse400 | droneCommanderDroneModelsListResponse500;
    
export type droneCommanderDroneModelsListResponse = droneCommanderDroneModelsListResponseComposite & {
  headers: Headers;
}

export const getDroneCommanderDroneModelsListUrl = () => {


  

  return `/api/drone_commander/drone-models/`
}

export const droneCommanderDroneModelsList = async ( options?: RequestInit): Promise<droneCommanderDroneModelsListResponse> => {
  
  return apiMutator<droneCommanderDroneModelsListResponse>(getDroneCommanderDroneModelsListUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



export type droneCommanderDroneModelsCreateResponse201 = {
  data: DroneModel
  status: 201
}

export type droneCommanderDroneModelsCreateResponse400 = {
  data: ValidationError
  status: 400
}
    
export type droneCommanderDroneModelsCreateResponseComposite = droneCommanderDroneModelsCreateResponse201 | droneCommanderDroneModelsCreateResponse400;
    
export type droneCommanderDroneModelsCreateResponse = droneCommanderDroneModelsCreateResponseComposite & {
  headers: Headers;
}

export const getDroneCommanderDroneModelsCreateUrl = () => {


  

  return `/api/drone_commander/drone-models/`
}

export const droneCommanderDroneModelsCreate = async (droneModelBody: DroneModelBody, options?: RequestInit): Promise<droneCommanderDroneModelsCreateResponse> => {
  
  return apiMutator<droneCommanderDroneModelsCreateResponse>(getDroneCommanderDroneModelsCreateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      droneModelBody,)
  }
);}



export type droneCommanderDroneModelsReadResponse200 = {
  data: DroneModel
  status: 200
}

export type droneCommanderDroneModelsReadResponse404 = {
  data: GeneralError
  status: 404
}

export type droneCommanderDroneModelsReadResponse500 = {
  data: GeneralError
  status: 500
}
    
export type droneCommanderDroneModelsReadResponseComposite = droneCommanderDroneModelsReadResponse200 | droneCommanderDroneModelsReadResponse404 | droneCommanderDroneModelsReadResponse500;
    
export type droneCommanderDroneModelsReadResponse = droneCommanderDroneModelsReadResponseComposite & {
  headers: Headers;
}

export const getDroneCommanderDroneModelsReadUrl = (id: number,) => {


  

  return `/api/drone_commander/drone-models/${id}/`
}

export const droneCommanderDroneModelsRead = async (id: number, options?: RequestInit): Promise<droneCommanderDroneModelsReadResponse> => {
  
  return apiMutator<droneCommanderDroneModelsReadResponse>(getDroneCommanderDroneModelsReadUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



export type droneCommanderDroneModelsUpdateResponse200 = {
  data: DroneModel
  status: 200
}

export type droneCommanderDroneModelsUpdateResponse400 = {
  data: ValidationError
  status: 400
}

export type droneCommanderDroneModelsUpdateResponse404 = {
  data: GeneralError
  status: 404
}
    
export type droneCommanderDroneModelsUpdateResponseComposite = droneCommanderDroneModelsUpdateResponse200 | droneCommanderDroneModelsUpdateResponse400 | droneCommanderDroneModelsUpdateResponse404;
    
export type droneCommanderDroneModelsUpdateResponse = droneCommanderDroneModelsUpdateResponseComposite & {
  headers: Headers;
}

export const getDroneCommanderDroneModelsUpdateUrl = (id: number,) => {


  

  return `/api/drone_commander/drone-models/${id}/`
}

export const droneCommanderDroneModelsUpdate = async (id: number,
    droneModelBody: DroneModelBody, options?: RequestInit): Promise<droneCommanderDroneModelsUpdateResponse> => {
  
  return apiMutator<droneCommanderDroneModelsUpdateResponse>(getDroneCommanderDroneModelsUpdateUrl(id),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      droneModelBody,)
  }
);}



export type droneCommanderDroneModelsPartialUpdateResponse200 = {
  data: DroneModel
  status: 200
}

export type droneCommanderDroneModelsPartialUpdateResponse400 = {
  data: ValidationError
  status: 400
}

export type droneCommanderDroneModelsPartialUpdateResponse404 = {
  data: GeneralError
  status: 404
}
    
export type droneCommanderDroneModelsPartialUpdateResponseComposite = droneCommanderDroneModelsPartialUpdateResponse200 | droneCommanderDroneModelsPartialUpdateResponse400 | droneCommanderDroneModelsPartialUpdateResponse404;
    
export type droneCommanderDroneModelsPartialUpdateResponse = droneCommanderDroneModelsPartialUpdateResponseComposite & {
  headers: Headers;
}

export const getDroneCommanderDroneModelsPartialUpdateUrl = (id: number,) => {


  

  return `/api/drone_commander/drone-models/${id}/`
}

export const droneCommanderDroneModelsPartialUpdate = async (id: number,
    droneModelBody: DroneModelBody, options?: RequestInit): Promise<droneCommanderDroneModelsPartialUpdateResponse> => {
  
  return apiMutator<droneCommanderDroneModelsPartialUpdateResponse>(getDroneCommanderDroneModelsPartialUpdateUrl(id),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      droneModelBody,)
  }
);}



export type droneCommanderDroneModelsDeleteResponse204 = {
  data: null
  status: 204
}

export type droneCommanderDroneModelsDeleteResponse404 = {
  data: GeneralError
  status: 404
}
    
export type droneCommanderDroneModelsDeleteResponseComposite = droneCommanderDroneModelsDeleteResponse204 | droneCommanderDroneModelsDeleteResponse404;
    
export type droneCommanderDroneModelsDeleteResponse = droneCommanderDroneModelsDeleteResponseComposite & {
  headers: Headers;
}

export const getDroneCommanderDroneModelsDeleteUrl = (id: number,) => {


  

  return `/api/drone_commander/drone-models/${id}/`
}

export const droneCommanderDroneModelsDelete = async (id: number, options?: RequestInit): Promise<droneCommanderDroneModelsDeleteResponse> => {
  
  return apiMutator<droneCommanderDroneModelsDeleteResponse>(getDroneCommanderDroneModelsDeleteUrl(id),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}



/**
 * Fetch a DroneProfile using its unique EID.
 * @summary Retrieve a DroneProfile by EID
 */
export type droneCommanderGetByEidResponse200 = {
  data: DroneProfile
  status: 200
}

export type droneCommanderGetByEidResponse404 = {
  data: null
  status: 404
}
    
export type droneCommanderGetByEidResponseComposite = droneCommanderGetByEidResponse200 | droneCommanderGetByEidResponse404;
    
export type droneCommanderGetByEidResponse = droneCommanderGetByEidResponseComposite & {
  headers: Headers;
}

export const getDroneCommanderGetByEidUrl = (eid: string,) => {


  

  return `/api/drone_commander/drone-profile/${eid}/`
}

export const droneCommanderGetByEid = async (eid: string, options?: RequestInit): Promise<droneCommanderGetByEidResponse> => {
  
  return apiMutator<droneCommanderGetByEidResponse>(getDroneCommanderGetByEidUrl(eid),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



export type droneCommanderDroneProfilesListResponse200 = {
  data: DroneProfile[]
  status: 200
}

export type droneCommanderDroneProfilesListResponse400 = {
  data: ValidationError
  status: 400
}

export type droneCommanderDroneProfilesListResponse500 = {
  data: GeneralError
  status: 500
}
    
export type droneCommanderDroneProfilesListResponseComposite = droneCommanderDroneProfilesListResponse200 | droneCommanderDroneProfilesListResponse400 | droneCommanderDroneProfilesListResponse500;
    
export type droneCommanderDroneProfilesListResponse = droneCommanderDroneProfilesListResponseComposite & {
  headers: Headers;
}

export const getDroneCommanderDroneProfilesListUrl = () => {


  

  return `/api/drone_commander/drone-profiles/`
}

export const droneCommanderDroneProfilesList = async ( options?: RequestInit): Promise<droneCommanderDroneProfilesListResponse> => {
  
  return apiMutator<droneCommanderDroneProfilesListResponse>(getDroneCommanderDroneProfilesListUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



export type droneCommanderDroneProfilesCreateResponse201 = {
  data: DroneProfile
  status: 201
}

export type droneCommanderDroneProfilesCreateResponse400 = {
  data: ValidationError
  status: 400
}
    
export type droneCommanderDroneProfilesCreateResponseComposite = droneCommanderDroneProfilesCreateResponse201 | droneCommanderDroneProfilesCreateResponse400;
    
export type droneCommanderDroneProfilesCreateResponse = droneCommanderDroneProfilesCreateResponseComposite & {
  headers: Headers;
}

export const getDroneCommanderDroneProfilesCreateUrl = () => {


  

  return `/api/drone_commander/drone-profiles/`
}

export const droneCommanderDroneProfilesCreate = async (droneProfileBody: DroneProfileBody, options?: RequestInit): Promise<droneCommanderDroneProfilesCreateResponse> => {
  
  return apiMutator<droneCommanderDroneProfilesCreateResponse>(getDroneCommanderDroneProfilesCreateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      droneProfileBody,)
  }
);}



/**
 * This API allows you to delete multiple DroneProfile instances by passing their IDs in the request body.
 * @summary Delete multiple DroneProfile instances by their IDs
 */
export type droneCommanderDroneProfilesBulkRemoveDroneprofilesResponse500 = {
  data: null
  status: 500
}
    
export type droneCommanderDroneProfilesBulkRemoveDroneprofilesResponseComposite = droneCommanderDroneProfilesBulkRemoveDroneprofilesResponse500;
    
export type droneCommanderDroneProfilesBulkRemoveDroneprofilesResponse = droneCommanderDroneProfilesBulkRemoveDroneprofilesResponseComposite & {
  headers: Headers;
}

export const getDroneCommanderDroneProfilesBulkRemoveDroneprofilesUrl = () => {


  

  return `/api/drone_commander/drone-profiles/bulk-remove-droneprofiles/`
}

export const droneCommanderDroneProfilesBulkRemoveDroneprofiles = async (droneCommanderDroneProfilesBulkRemoveDroneprofilesBody: DroneCommanderDroneProfilesBulkRemoveDroneprofilesBody, options?: RequestInit): Promise<droneCommanderDroneProfilesBulkRemoveDroneprofilesResponse> => {
  
  return apiMutator<droneCommanderDroneProfilesBulkRemoveDroneprofilesResponse>(getDroneCommanderDroneProfilesBulkRemoveDroneprofilesUrl(),
  {      
    ...options,
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      droneCommanderDroneProfilesBulkRemoveDroneprofilesBody,)
  }
);}



export type droneCommanderDroneProfilesReadResponse200 = {
  data: DroneProfile
  status: 200
}

export type droneCommanderDroneProfilesReadResponse404 = {
  data: GeneralError
  status: 404
}

export type droneCommanderDroneProfilesReadResponse500 = {
  data: GeneralError
  status: 500
}
    
export type droneCommanderDroneProfilesReadResponseComposite = droneCommanderDroneProfilesReadResponse200 | droneCommanderDroneProfilesReadResponse404 | droneCommanderDroneProfilesReadResponse500;
    
export type droneCommanderDroneProfilesReadResponse = droneCommanderDroneProfilesReadResponseComposite & {
  headers: Headers;
}

export const getDroneCommanderDroneProfilesReadUrl = (id: number,) => {


  

  return `/api/drone_commander/drone-profiles/${id}/`
}

export const droneCommanderDroneProfilesRead = async (id: number, options?: RequestInit): Promise<droneCommanderDroneProfilesReadResponse> => {
  
  return apiMutator<droneCommanderDroneProfilesReadResponse>(getDroneCommanderDroneProfilesReadUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



export type droneCommanderDroneProfilesUpdateResponse200 = {
  data: DroneProfile
  status: 200
}

export type droneCommanderDroneProfilesUpdateResponse400 = {
  data: ValidationError
  status: 400
}

export type droneCommanderDroneProfilesUpdateResponse404 = {
  data: GeneralError
  status: 404
}
    
export type droneCommanderDroneProfilesUpdateResponseComposite = droneCommanderDroneProfilesUpdateResponse200 | droneCommanderDroneProfilesUpdateResponse400 | droneCommanderDroneProfilesUpdateResponse404;
    
export type droneCommanderDroneProfilesUpdateResponse = droneCommanderDroneProfilesUpdateResponseComposite & {
  headers: Headers;
}

export const getDroneCommanderDroneProfilesUpdateUrl = (id: number,) => {


  

  return `/api/drone_commander/drone-profiles/${id}/`
}

export const droneCommanderDroneProfilesUpdate = async (id: number,
    droneProfileBody: DroneProfileBody, options?: RequestInit): Promise<droneCommanderDroneProfilesUpdateResponse> => {
  
  return apiMutator<droneCommanderDroneProfilesUpdateResponse>(getDroneCommanderDroneProfilesUpdateUrl(id),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      droneProfileBody,)
  }
);}



export type droneCommanderDroneProfilesPartialUpdateResponse200 = {
  data: DroneProfile
  status: 200
}

export type droneCommanderDroneProfilesPartialUpdateResponse400 = {
  data: ValidationError
  status: 400
}

export type droneCommanderDroneProfilesPartialUpdateResponse404 = {
  data: GeneralError
  status: 404
}
    
export type droneCommanderDroneProfilesPartialUpdateResponseComposite = droneCommanderDroneProfilesPartialUpdateResponse200 | droneCommanderDroneProfilesPartialUpdateResponse400 | droneCommanderDroneProfilesPartialUpdateResponse404;
    
export type droneCommanderDroneProfilesPartialUpdateResponse = droneCommanderDroneProfilesPartialUpdateResponseComposite & {
  headers: Headers;
}

export const getDroneCommanderDroneProfilesPartialUpdateUrl = (id: number,) => {


  

  return `/api/drone_commander/drone-profiles/${id}/`
}

export const droneCommanderDroneProfilesPartialUpdate = async (id: number,
    droneProfileBody: DroneProfileBody, options?: RequestInit): Promise<droneCommanderDroneProfilesPartialUpdateResponse> => {
  
  return apiMutator<droneCommanderDroneProfilesPartialUpdateResponse>(getDroneCommanderDroneProfilesPartialUpdateUrl(id),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      droneProfileBody,)
  }
);}



export type droneCommanderDroneProfilesDeleteResponse204 = {
  data: null
  status: 204
}

export type droneCommanderDroneProfilesDeleteResponse404 = {
  data: GeneralError
  status: 404
}
    
export type droneCommanderDroneProfilesDeleteResponseComposite = droneCommanderDroneProfilesDeleteResponse204 | droneCommanderDroneProfilesDeleteResponse404;
    
export type droneCommanderDroneProfilesDeleteResponse = droneCommanderDroneProfilesDeleteResponseComposite & {
  headers: Headers;
}

export const getDroneCommanderDroneProfilesDeleteUrl = (id: number,) => {


  

  return `/api/drone_commander/drone-profiles/${id}/`
}

export const droneCommanderDroneProfilesDelete = async (id: number, options?: RequestInit): Promise<droneCommanderDroneProfilesDeleteResponse> => {
  
  return apiMutator<droneCommanderDroneProfilesDeleteResponse>(getDroneCommanderDroneProfilesDeleteUrl(id),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}



/**
 * Retrieve the latest heartbeat entry for a given drone_id.
 * @summary Get Latest Drone Heartbeat
 */
export type droneCommanderHeartbeatReadResponse200 = {
  data: DroneHeartBeat
  status: 200
}

export type droneCommanderHeartbeatReadResponse404 = {
  data: null
  status: 404
}
    
export type droneCommanderHeartbeatReadResponseComposite = droneCommanderHeartbeatReadResponse200 | droneCommanderHeartbeatReadResponse404;
    
export type droneCommanderHeartbeatReadResponse = droneCommanderHeartbeatReadResponseComposite & {
  headers: Headers;
}

export const getDroneCommanderHeartbeatReadUrl = (droneId: string,) => {


  

  return `/api/drone_commander/heartbeat/${droneId}/`
}

export const droneCommanderHeartbeatRead = async (droneId: string, options?: RequestInit): Promise<droneCommanderHeartbeatReadResponse> => {
  
  return apiMutator<droneCommanderHeartbeatReadResponse>(getDroneCommanderHeartbeatReadUrl(droneId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



export type droneCommanderManufacturersListResponse200 = {
  data: Manufacturer[]
  status: 200
}

export type droneCommanderManufacturersListResponse400 = {
  data: ValidationError
  status: 400
}

export type droneCommanderManufacturersListResponse500 = {
  data: GeneralError
  status: 500
}
    
export type droneCommanderManufacturersListResponseComposite = droneCommanderManufacturersListResponse200 | droneCommanderManufacturersListResponse400 | droneCommanderManufacturersListResponse500;
    
export type droneCommanderManufacturersListResponse = droneCommanderManufacturersListResponseComposite & {
  headers: Headers;
}

export const getDroneCommanderManufacturersListUrl = () => {


  

  return `/api/drone_commander/manufacturers/`
}

export const droneCommanderManufacturersList = async ( options?: RequestInit): Promise<droneCommanderManufacturersListResponse> => {
  
  return apiMutator<droneCommanderManufacturersListResponse>(getDroneCommanderManufacturersListUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



export type droneCommanderManufacturersCreateResponse201 = {
  data: Manufacturer
  status: 201
}

export type droneCommanderManufacturersCreateResponse400 = {
  data: ValidationError
  status: 400
}
    
export type droneCommanderManufacturersCreateResponseComposite = droneCommanderManufacturersCreateResponse201 | droneCommanderManufacturersCreateResponse400;
    
export type droneCommanderManufacturersCreateResponse = droneCommanderManufacturersCreateResponseComposite & {
  headers: Headers;
}

export const getDroneCommanderManufacturersCreateUrl = () => {


  

  return `/api/drone_commander/manufacturers/`
}

export const droneCommanderManufacturersCreate = async (manufacturerBody: ManufacturerBody, options?: RequestInit): Promise<droneCommanderManufacturersCreateResponse> => {
  
  return apiMutator<droneCommanderManufacturersCreateResponse>(getDroneCommanderManufacturersCreateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      manufacturerBody,)
  }
);}



export type droneCommanderManufacturersReadResponse200 = {
  data: Manufacturer
  status: 200
}

export type droneCommanderManufacturersReadResponse404 = {
  data: GeneralError
  status: 404
}

export type droneCommanderManufacturersReadResponse500 = {
  data: GeneralError
  status: 500
}
    
export type droneCommanderManufacturersReadResponseComposite = droneCommanderManufacturersReadResponse200 | droneCommanderManufacturersReadResponse404 | droneCommanderManufacturersReadResponse500;
    
export type droneCommanderManufacturersReadResponse = droneCommanderManufacturersReadResponseComposite & {
  headers: Headers;
}

export const getDroneCommanderManufacturersReadUrl = (id: number,) => {


  

  return `/api/drone_commander/manufacturers/${id}/`
}

export const droneCommanderManufacturersRead = async (id: number, options?: RequestInit): Promise<droneCommanderManufacturersReadResponse> => {
  
  return apiMutator<droneCommanderManufacturersReadResponse>(getDroneCommanderManufacturersReadUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



export type droneCommanderManufacturersUpdateResponse200 = {
  data: Manufacturer
  status: 200
}

export type droneCommanderManufacturersUpdateResponse400 = {
  data: ValidationError
  status: 400
}

export type droneCommanderManufacturersUpdateResponse404 = {
  data: GeneralError
  status: 404
}
    
export type droneCommanderManufacturersUpdateResponseComposite = droneCommanderManufacturersUpdateResponse200 | droneCommanderManufacturersUpdateResponse400 | droneCommanderManufacturersUpdateResponse404;
    
export type droneCommanderManufacturersUpdateResponse = droneCommanderManufacturersUpdateResponseComposite & {
  headers: Headers;
}

export const getDroneCommanderManufacturersUpdateUrl = (id: number,) => {


  

  return `/api/drone_commander/manufacturers/${id}/`
}

export const droneCommanderManufacturersUpdate = async (id: number,
    manufacturerBody: ManufacturerBody, options?: RequestInit): Promise<droneCommanderManufacturersUpdateResponse> => {
  
  return apiMutator<droneCommanderManufacturersUpdateResponse>(getDroneCommanderManufacturersUpdateUrl(id),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      manufacturerBody,)
  }
);}



export type droneCommanderManufacturersPartialUpdateResponse200 = {
  data: Manufacturer
  status: 200
}

export type droneCommanderManufacturersPartialUpdateResponse400 = {
  data: ValidationError
  status: 400
}

export type droneCommanderManufacturersPartialUpdateResponse404 = {
  data: GeneralError
  status: 404
}
    
export type droneCommanderManufacturersPartialUpdateResponseComposite = droneCommanderManufacturersPartialUpdateResponse200 | droneCommanderManufacturersPartialUpdateResponse400 | droneCommanderManufacturersPartialUpdateResponse404;
    
export type droneCommanderManufacturersPartialUpdateResponse = droneCommanderManufacturersPartialUpdateResponseComposite & {
  headers: Headers;
}

export const getDroneCommanderManufacturersPartialUpdateUrl = (id: number,) => {


  

  return `/api/drone_commander/manufacturers/${id}/`
}

export const droneCommanderManufacturersPartialUpdate = async (id: number,
    manufacturerBody: ManufacturerBody, options?: RequestInit): Promise<droneCommanderManufacturersPartialUpdateResponse> => {
  
  return apiMutator<droneCommanderManufacturersPartialUpdateResponse>(getDroneCommanderManufacturersPartialUpdateUrl(id),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      manufacturerBody,)
  }
);}



export type droneCommanderManufacturersDeleteResponse204 = {
  data: null
  status: 204
}

export type droneCommanderManufacturersDeleteResponse404 = {
  data: GeneralError
  status: 404
}
    
export type droneCommanderManufacturersDeleteResponseComposite = droneCommanderManufacturersDeleteResponse204 | droneCommanderManufacturersDeleteResponse404;
    
export type droneCommanderManufacturersDeleteResponse = droneCommanderManufacturersDeleteResponseComposite & {
  headers: Headers;
}

export const getDroneCommanderManufacturersDeleteUrl = (id: number,) => {


  

  return `/api/drone_commander/manufacturers/${id}/`
}

export const droneCommanderManufacturersDelete = async (id: number, options?: RequestInit): Promise<droneCommanderManufacturersDeleteResponse> => {
  
  return apiMutator<droneCommanderManufacturersDeleteResponse>(getDroneCommanderManufacturersDeleteUrl(id),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}



/**
 * Retrieve a list of all missions for the authenticated user's organization.
 * @summary List Missions
 */
export type droneCommanderMissionsListResponse200 = {
  data: MissionListApiResponse
  status: 200
}

export type droneCommanderMissionsListResponse400 = {
  data: ValidationError
  status: 400
}

export type droneCommanderMissionsListResponse401 = {
  data: UnauthorizedError
  status: 401
}

export type droneCommanderMissionsListResponse403 = {
  data: ForbiddenError
  status: 403
}

export type droneCommanderMissionsListResponse500 = {
  data: InternalServerError
  status: 500
}
    
export type droneCommanderMissionsListResponseComposite = droneCommanderMissionsListResponse200 | droneCommanderMissionsListResponse400 | droneCommanderMissionsListResponse401 | droneCommanderMissionsListResponse403 | droneCommanderMissionsListResponse500;
    
export type droneCommanderMissionsListResponse = droneCommanderMissionsListResponseComposite & {
  headers: Headers;
}

export const getDroneCommanderMissionsListUrl = () => {


  

  return `/api/drone_commander/missions/`
}

export const droneCommanderMissionsList = async ( options?: RequestInit): Promise<droneCommanderMissionsListResponse> => {
  
  return apiMutator<droneCommanderMissionsListResponse>(getDroneCommanderMissionsListUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * Create a new mission with sequences and steps for drone operations. 
 * @summary Create Mission
 */
export type droneCommanderMissionsCreateMissionResponse201 = {
  data: MissionCreateApiResponse
  status: 201
}

export type droneCommanderMissionsCreateMissionResponse400 = {
  data: ValidationError
  status: 400
}

export type droneCommanderMissionsCreateMissionResponse401 = {
  data: UnauthorizedError
  status: 401
}

export type droneCommanderMissionsCreateMissionResponse403 = {
  data: ForbiddenError
  status: 403
}

export type droneCommanderMissionsCreateMissionResponse500 = {
  data: InternalServerError
  status: 500
}
    
export type droneCommanderMissionsCreateMissionResponseComposite = droneCommanderMissionsCreateMissionResponse201 | droneCommanderMissionsCreateMissionResponse400 | droneCommanderMissionsCreateMissionResponse401 | droneCommanderMissionsCreateMissionResponse403 | droneCommanderMissionsCreateMissionResponse500;
    
export type droneCommanderMissionsCreateMissionResponse = droneCommanderMissionsCreateMissionResponseComposite & {
  headers: Headers;
}

export const getDroneCommanderMissionsCreateMissionUrl = () => {


  

  return `/api/drone_commander/missions/create-mission/`
}

export const droneCommanderMissionsCreateMission = async (missionCreateRequest: MissionCreateRequest, options?: RequestInit): Promise<droneCommanderMissionsCreateMissionResponse> => {
  
  return apiMutator<droneCommanderMissionsCreateMissionResponse>(getDroneCommanderMissionsCreateMissionUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      missionCreateRequest,)
  }
);}



/**
 * Retrieve a specific mission by ID.
 * @summary Retrieve Mission
 */
export type droneCommanderMissionsReadResponse200 = {
  data: MissionDetailApiResponse
  status: 200
}

export type droneCommanderMissionsReadResponse400 = {
  data: ValidationError
  status: 400
}

export type droneCommanderMissionsReadResponse401 = {
  data: UnauthorizedError
  status: 401
}

export type droneCommanderMissionsReadResponse403 = {
  data: ForbiddenError
  status: 403
}

export type droneCommanderMissionsReadResponse404 = {
  data: NotFoundError
  status: 404
}

export type droneCommanderMissionsReadResponse500 = {
  data: InternalServerError
  status: 500
}
    
export type droneCommanderMissionsReadResponseComposite = droneCommanderMissionsReadResponse200 | droneCommanderMissionsReadResponse400 | droneCommanderMissionsReadResponse401 | droneCommanderMissionsReadResponse403 | droneCommanderMissionsReadResponse404 | droneCommanderMissionsReadResponse500;
    
export type droneCommanderMissionsReadResponse = droneCommanderMissionsReadResponseComposite & {
  headers: Headers;
}

export const getDroneCommanderMissionsReadUrl = (id: string,) => {


  

  return `/api/drone_commander/missions/${id}/`
}

export const droneCommanderMissionsRead = async (id: string, options?: RequestInit): Promise<droneCommanderMissionsReadResponse> => {
  
  return apiMutator<droneCommanderMissionsReadResponse>(getDroneCommanderMissionsReadUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * Update an existing mission completely.
 * @summary Update Mission
 */
export type droneCommanderMissionsUpdateResponse200 = {
  data: MissionUpdateApiResponse
  status: 200
}

export type droneCommanderMissionsUpdateResponse400 = {
  data: ValidationError
  status: 400
}

export type droneCommanderMissionsUpdateResponse401 = {
  data: UnauthorizedError
  status: 401
}

export type droneCommanderMissionsUpdateResponse403 = {
  data: ForbiddenError
  status: 403
}

export type droneCommanderMissionsUpdateResponse404 = {
  data: NotFoundError
  status: 404
}

export type droneCommanderMissionsUpdateResponse500 = {
  data: InternalServerError
  status: 500
}
    
export type droneCommanderMissionsUpdateResponseComposite = droneCommanderMissionsUpdateResponse200 | droneCommanderMissionsUpdateResponse400 | droneCommanderMissionsUpdateResponse401 | droneCommanderMissionsUpdateResponse403 | droneCommanderMissionsUpdateResponse404 | droneCommanderMissionsUpdateResponse500;
    
export type droneCommanderMissionsUpdateResponse = droneCommanderMissionsUpdateResponseComposite & {
  headers: Headers;
}

export const getDroneCommanderMissionsUpdateUrl = (id: string,) => {


  

  return `/api/drone_commander/missions/${id}/`
}

export const droneCommanderMissionsUpdate = async (id: string,
    missionBody: MissionBody, options?: RequestInit): Promise<droneCommanderMissionsUpdateResponse> => {
  
  return apiMutator<droneCommanderMissionsUpdateResponse>(getDroneCommanderMissionsUpdateUrl(id),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      missionBody,)
  }
);}



/**
 * Partially update an existing mission.
 * @summary Partial Update Mission
 */
export type droneCommanderMissionsPartialUpdateResponse200 = {
  data: MissionUpdateApiResponse
  status: 200
}

export type droneCommanderMissionsPartialUpdateResponse400 = {
  data: ValidationError
  status: 400
}

export type droneCommanderMissionsPartialUpdateResponse401 = {
  data: UnauthorizedError
  status: 401
}

export type droneCommanderMissionsPartialUpdateResponse403 = {
  data: ForbiddenError
  status: 403
}

export type droneCommanderMissionsPartialUpdateResponse404 = {
  data: NotFoundError
  status: 404
}

export type droneCommanderMissionsPartialUpdateResponse500 = {
  data: InternalServerError
  status: 500
}
    
export type droneCommanderMissionsPartialUpdateResponseComposite = droneCommanderMissionsPartialUpdateResponse200 | droneCommanderMissionsPartialUpdateResponse400 | droneCommanderMissionsPartialUpdateResponse401 | droneCommanderMissionsPartialUpdateResponse403 | droneCommanderMissionsPartialUpdateResponse404 | droneCommanderMissionsPartialUpdateResponse500;
    
export type droneCommanderMissionsPartialUpdateResponse = droneCommanderMissionsPartialUpdateResponseComposite & {
  headers: Headers;
}

export const getDroneCommanderMissionsPartialUpdateUrl = (id: string,) => {


  

  return `/api/drone_commander/missions/${id}/`
}

export const droneCommanderMissionsPartialUpdate = async (id: string,
    missionBody: MissionBody, options?: RequestInit): Promise<droneCommanderMissionsPartialUpdateResponse> => {
  
  return apiMutator<droneCommanderMissionsPartialUpdateResponse>(getDroneCommanderMissionsPartialUpdateUrl(id),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      missionBody,)
  }
);}



/**
 * Delete a mission permanently.
 * @summary Delete Mission
 */
export type droneCommanderMissionsDeleteResponse204 = {
  data: null
  status: 204
}

export type droneCommanderMissionsDeleteResponse400 = {
  data: ValidationError
  status: 400
}

export type droneCommanderMissionsDeleteResponse401 = {
  data: UnauthorizedError
  status: 401
}

export type droneCommanderMissionsDeleteResponse403 = {
  data: ForbiddenError
  status: 403
}

export type droneCommanderMissionsDeleteResponse404 = {
  data: NotFoundError
  status: 404
}

export type droneCommanderMissionsDeleteResponse500 = {
  data: InternalServerError
  status: 500
}
    
export type droneCommanderMissionsDeleteResponseComposite = droneCommanderMissionsDeleteResponse204 | droneCommanderMissionsDeleteResponse400 | droneCommanderMissionsDeleteResponse401 | droneCommanderMissionsDeleteResponse403 | droneCommanderMissionsDeleteResponse404 | droneCommanderMissionsDeleteResponse500;
    
export type droneCommanderMissionsDeleteResponse = droneCommanderMissionsDeleteResponseComposite & {
  headers: Headers;
}

export const getDroneCommanderMissionsDeleteUrl = (id: string,) => {


  

  return `/api/drone_commander/missions/${id}/`
}

export const droneCommanderMissionsDelete = async (id: string, options?: RequestInit): Promise<droneCommanderMissionsDeleteResponse> => {
  
  return apiMutator<droneCommanderMissionsDeleteResponse>(getDroneCommanderMissionsDeleteUrl(id),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}



/**
 * Download the mission in QGroundControl (.plan) JSON format for the given mission ID.
 * @summary Download Mission in QGC format
 */
export type droneCommanderMissionsQgcDownloadResponse200 = {
  data: null
  status: 200
}

export type droneCommanderMissionsQgcDownloadResponse400 = {
  data: ValidationError
  status: 400
}

export type droneCommanderMissionsQgcDownloadResponse401 = {
  data: UnauthorizedError
  status: 401
}

export type droneCommanderMissionsQgcDownloadResponse403 = {
  data: ForbiddenError
  status: 403
}

export type droneCommanderMissionsQgcDownloadResponse404 = {
  data: NotFoundError
  status: 404
}

export type droneCommanderMissionsQgcDownloadResponse500 = {
  data: InternalServerError
  status: 500
}
    
export type droneCommanderMissionsQgcDownloadResponseComposite = droneCommanderMissionsQgcDownloadResponse200 | droneCommanderMissionsQgcDownloadResponse400 | droneCommanderMissionsQgcDownloadResponse401 | droneCommanderMissionsQgcDownloadResponse403 | droneCommanderMissionsQgcDownloadResponse404 | droneCommanderMissionsQgcDownloadResponse500;
    
export type droneCommanderMissionsQgcDownloadResponse = droneCommanderMissionsQgcDownloadResponseComposite & {
  headers: Headers;
}

export const getDroneCommanderMissionsQgcDownloadUrl = (id: string,) => {


  

  return `/api/drone_commander/missions/${id}/qgc-download/`
}

export const droneCommanderMissionsQgcDownload = async (id: string, options?: RequestInit): Promise<droneCommanderMissionsQgcDownloadResponse> => {
  
  return apiMutator<droneCommanderMissionsQgcDownloadResponse>(getDroneCommanderMissionsQgcDownloadUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * Return the mission in QGroundControl (QGC) JSON format for the given mission ID.
 * @summary Get Mission in QGC format
 */
export type droneCommanderMissionsQgcResponse200 = {
  data: MissionQgcApiResponse
  status: 200
}

export type droneCommanderMissionsQgcResponse400 = {
  data: ValidationError
  status: 400
}

export type droneCommanderMissionsQgcResponse401 = {
  data: UnauthorizedError
  status: 401
}

export type droneCommanderMissionsQgcResponse403 = {
  data: ForbiddenError
  status: 403
}

export type droneCommanderMissionsQgcResponse404 = {
  data: NotFoundError
  status: 404
}

export type droneCommanderMissionsQgcResponse500 = {
  data: InternalServerError
  status: 500
}
    
export type droneCommanderMissionsQgcResponseComposite = droneCommanderMissionsQgcResponse200 | droneCommanderMissionsQgcResponse400 | droneCommanderMissionsQgcResponse401 | droneCommanderMissionsQgcResponse403 | droneCommanderMissionsQgcResponse404 | droneCommanderMissionsQgcResponse500;
    
export type droneCommanderMissionsQgcResponse = droneCommanderMissionsQgcResponseComposite & {
  headers: Headers;
}

export const getDroneCommanderMissionsQgcUrl = (id: string,) => {


  

  return `/api/drone_commander/missions/${id}/qgc/`
}

export const droneCommanderMissionsQgc = async (id: string, options?: RequestInit): Promise<droneCommanderMissionsQgcResponse> => {
  
  return apiMutator<droneCommanderMissionsQgcResponse>(getDroneCommanderMissionsQgcUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * Fetch the available multispectral index choices for drones.
 * @summary Retrieve Multispectral Index Choices
 */
export type droneCommanderMultispectralIndexChoicesListResponse200 = {
  data: DroneCommanderMultispectralIndexChoicesList200
  status: 200
}
    
export type droneCommanderMultispectralIndexChoicesListResponseComposite = droneCommanderMultispectralIndexChoicesListResponse200;
    
export type droneCommanderMultispectralIndexChoicesListResponse = droneCommanderMultispectralIndexChoicesListResponseComposite & {
  headers: Headers;
}

export const getDroneCommanderMultispectralIndexChoicesListUrl = () => {


  

  return `/api/drone_commander/multispectral-index-choices/`
}

export const droneCommanderMultispectralIndexChoicesList = async ( options?: RequestInit): Promise<droneCommanderMultispectralIndexChoicesListResponse> => {
  
  return apiMutator<droneCommanderMultispectralIndexChoicesListResponse>(getDroneCommanderMultispectralIndexChoicesListUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * This API retrieves drone profiles associated with a specific organization.
 * @summary Retrieve drone profiles for an organization
 */
export type droneCommanderOrganizationsDroneProfilesListResponse404 = {
  data: null
  status: 404
}

export type droneCommanderOrganizationsDroneProfilesListResponse500 = {
  data: null
  status: 500
}
    
export type droneCommanderOrganizationsDroneProfilesListResponseComposite = droneCommanderOrganizationsDroneProfilesListResponse404 | droneCommanderOrganizationsDroneProfilesListResponse500;
    
export type droneCommanderOrganizationsDroneProfilesListResponse = droneCommanderOrganizationsDroneProfilesListResponseComposite & {
  headers: Headers;
}

export const getDroneCommanderOrganizationsDroneProfilesListUrl = (orgId: string,) => {


  

  return `/api/drone_commander/organizations/${orgId}/drone-profiles/`
}

export const droneCommanderOrganizationsDroneProfilesList = async (orgId: string, options?: RequestInit): Promise<droneCommanderOrganizationsDroneProfilesListResponse> => {
  
  return apiMutator<droneCommanderOrganizationsDroneProfilesListResponse>(getDroneCommanderOrganizationsDroneProfilesListUrl(orgId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * Executes the check_drone_status.sh script on the host to get current IP and service status.
 * @summary Check Drone Status
 */
export type droneCommanderWindscreenStatusListResponse200 = {
  data: DroneCommanderWindscreenStatusList200
  status: 200
}

export type droneCommanderWindscreenStatusListResponse500 = {
  data: GeneralError
  status: 500
}
    
export type droneCommanderWindscreenStatusListResponseComposite = droneCommanderWindscreenStatusListResponse200 | droneCommanderWindscreenStatusListResponse500;
    
export type droneCommanderWindscreenStatusListResponse = droneCommanderWindscreenStatusListResponseComposite & {
  headers: Headers;
}

export const getDroneCommanderWindscreenStatusListUrl = () => {


  

  return `/api/drone_commander/windscreen/status/`
}

export const droneCommanderWindscreenStatusList = async ( options?: RequestInit): Promise<droneCommanderWindscreenStatusListResponse> => {
  
  return apiMutator<droneCommanderWindscreenStatusListResponse>(getDroneCommanderWindscreenStatusListUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * Executes the update_drone_ip.sh script on the host to update the drone's IP address.
 * @summary Update Drone IP
 */
export type droneCommanderWindscreenUpdateIpCreateResponse200 = {
  data: DroneCommanderWindscreenUpdateIpCreate200
  status: 200
}

export type droneCommanderWindscreenUpdateIpCreateResponse400 = {
  data: ValidationError
  status: 400
}

export type droneCommanderWindscreenUpdateIpCreateResponse500 = {
  data: GeneralError
  status: 500
}
    
export type droneCommanderWindscreenUpdateIpCreateResponseComposite = droneCommanderWindscreenUpdateIpCreateResponse200 | droneCommanderWindscreenUpdateIpCreateResponse400 | droneCommanderWindscreenUpdateIpCreateResponse500;
    
export type droneCommanderWindscreenUpdateIpCreateResponse = droneCommanderWindscreenUpdateIpCreateResponseComposite & {
  headers: Headers;
}

export const getDroneCommanderWindscreenUpdateIpCreateUrl = () => {


  

  return `/api/drone_commander/windscreen/update-ip/`
}

export const droneCommanderWindscreenUpdateIpCreate = async (droneCommanderWindscreenUpdateIpCreateBody: DroneCommanderWindscreenUpdateIpCreateBody, options?: RequestInit): Promise<droneCommanderWindscreenUpdateIpCreateResponse> => {
  
  return apiMutator<droneCommanderWindscreenUpdateIpCreateResponse>(getDroneCommanderWindscreenUpdateIpCreateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      droneCommanderWindscreenUpdateIpCreateBody,)
  }
);}



/**
 * Return success if authenticated.
 */
export type gatedListResponse200 = {
  data: null
  status: 200
}
    
export type gatedListResponseComposite = gatedListResponse200;
    
export type gatedListResponse = gatedListResponseComposite & {
  headers: Headers;
}

export const getGatedListUrl = () => {


  

  return `/api/gated`
}

export const gatedList = async ( options?: RequestInit): Promise<gatedListResponse> => {
  
  return apiMutator<gatedListResponse>(getGatedListUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary List partner associations for a device
 */
export type integrationsDevicePartnersListResponse200 = {
  data: null
  status: 200
}
    
export type integrationsDevicePartnersListResponseComposite = integrationsDevicePartnersListResponse200;
    
export type integrationsDevicePartnersListResponse = integrationsDevicePartnersListResponseComposite & {
  headers: Headers;
}

export const getIntegrationsDevicePartnersListUrl = (deviceId: string,) => {


  

  return `/api/integrations/devices/${deviceId}/partners`
}

export const integrationsDevicePartnersList = async (deviceId: string, options?: RequestInit): Promise<integrationsDevicePartnersListResponse> => {
  
  return apiMutator<integrationsDevicePartnersListResponse>(getIntegrationsDevicePartnersListUrl(deviceId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Associate a partner with a device and ensure EMQX republish rule
 */
export type integrationsDevicePartnerAssociateResponse200 = {
  data: PartnerAssociationEnvelope
  status: 200
}

export type integrationsDevicePartnerAssociateResponse400 = {
  data: ValidationError
  status: 400
}

export type integrationsDevicePartnerAssociateResponse401 = {
  data: UnauthorizedError
  status: 401
}

export type integrationsDevicePartnerAssociateResponse403 = {
  data: ForbiddenError
  status: 403
}

export type integrationsDevicePartnerAssociateResponse404 = {
  data: NotFoundError
  status: 404
}

export type integrationsDevicePartnerAssociateResponse500 = {
  data: InternalServerError
  status: 500
}
    
export type integrationsDevicePartnerAssociateResponseComposite = integrationsDevicePartnerAssociateResponse200 | integrationsDevicePartnerAssociateResponse400 | integrationsDevicePartnerAssociateResponse401 | integrationsDevicePartnerAssociateResponse403 | integrationsDevicePartnerAssociateResponse404 | integrationsDevicePartnerAssociateResponse500;
    
export type integrationsDevicePartnerAssociateResponse = integrationsDevicePartnerAssociateResponseComposite & {
  headers: Headers;
}

export const getIntegrationsDevicePartnerAssociateUrl = (deviceId: string,
    provider: string,) => {


  

  return `/api/integrations/devices/${deviceId}/partners/${provider}`
}

export const integrationsDevicePartnerAssociate = async (deviceId: string,
    provider: string, options?: RequestInit): Promise<integrationsDevicePartnerAssociateResponse> => {
  
  return apiMutator<integrationsDevicePartnerAssociateResponse>(getIntegrationsDevicePartnerAssociateUrl(deviceId,provider),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}



/**
 * @summary Disassociate a partner from a device and clean up EMQX republish rule
 */
export type integrationsDevicePartnerDisassociateResponse200 = {
  data: PartnerDisassociateEnvelope
  status: 200
}

export type integrationsDevicePartnerDisassociateResponse400 = {
  data: ValidationError
  status: 400
}

export type integrationsDevicePartnerDisassociateResponse401 = {
  data: UnauthorizedError
  status: 401
}

export type integrationsDevicePartnerDisassociateResponse403 = {
  data: ForbiddenError
  status: 403
}

export type integrationsDevicePartnerDisassociateResponse404 = {
  data: NotFoundError
  status: 404
}

export type integrationsDevicePartnerDisassociateResponse500 = {
  data: InternalServerError
  status: 500
}
    
export type integrationsDevicePartnerDisassociateResponseComposite = integrationsDevicePartnerDisassociateResponse200 | integrationsDevicePartnerDisassociateResponse400 | integrationsDevicePartnerDisassociateResponse401 | integrationsDevicePartnerDisassociateResponse403 | integrationsDevicePartnerDisassociateResponse404 | integrationsDevicePartnerDisassociateResponse500;
    
export type integrationsDevicePartnerDisassociateResponse = integrationsDevicePartnerDisassociateResponseComposite & {
  headers: Headers;
}

export const getIntegrationsDevicePartnerDisassociateUrl = (deviceId: string,
    provider: string,) => {


  

  return `/api/integrations/devices/${deviceId}/partners/${provider}`
}

export const integrationsDevicePartnerDisassociate = async (deviceId: string,
    provider: string, options?: RequestInit): Promise<integrationsDevicePartnerDisassociateResponse> => {
  
  return apiMutator<integrationsDevicePartnerDisassociateResponse>(getIntegrationsDevicePartnerDisassociateUrl(deviceId,provider),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}



/**
 * @summary Start a provider integration session
 */
export type integrationsSessionsStartResponse200 = {
  data: IntegrationStartSessionEnvelope
  status: 200
}

export type integrationsSessionsStartResponse400 = {
  data: ValidationError
  status: 400
}

export type integrationsSessionsStartResponse401 = {
  data: UnauthorizedError
  status: 401
}

export type integrationsSessionsStartResponse403 = {
  data: ForbiddenError
  status: 403
}

export type integrationsSessionsStartResponse404 = {
  data: NotFoundError
  status: 404
}

export type integrationsSessionsStartResponse500 = {
  data: InternalServerError
  status: 500
}

export type integrationsSessionsStartResponse501 = {
  data: null
  status: 501
}
    
export type integrationsSessionsStartResponseComposite = integrationsSessionsStartResponse200 | integrationsSessionsStartResponse400 | integrationsSessionsStartResponse401 | integrationsSessionsStartResponse403 | integrationsSessionsStartResponse404 | integrationsSessionsStartResponse500 | integrationsSessionsStartResponse501;
    
export type integrationsSessionsStartResponse = integrationsSessionsStartResponseComposite & {
  headers: Headers;
}

export const getIntegrationsSessionsStartUrl = () => {


  

  return `/api/integrations/session/start`
}

export const integrationsSessionsStart = async (startSessionRequest: StartSessionRequest, options?: RequestInit): Promise<integrationsSessionsStartResponse> => {
  
  return apiMutator<integrationsSessionsStartResponse>(getIntegrationsSessionsStartUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      startSessionRequest,)
  }
);}



/**
 * @summary Stop a provider integration session
 */
export type integrationsSessionsStopResponse200 = {
  data: IntegrationStopSessionEnvelope
  status: 200
}

export type integrationsSessionsStopResponse400 = {
  data: ValidationError
  status: 400
}

export type integrationsSessionsStopResponse401 = {
  data: UnauthorizedError
  status: 401
}

export type integrationsSessionsStopResponse403 = {
  data: ForbiddenError
  status: 403
}

export type integrationsSessionsStopResponse404 = {
  data: NotFoundError
  status: 404
}

export type integrationsSessionsStopResponse500 = {
  data: InternalServerError
  status: 500
}

export type integrationsSessionsStopResponse501 = {
  data: null
  status: 501
}
    
export type integrationsSessionsStopResponseComposite = integrationsSessionsStopResponse200 | integrationsSessionsStopResponse400 | integrationsSessionsStopResponse401 | integrationsSessionsStopResponse403 | integrationsSessionsStopResponse404 | integrationsSessionsStopResponse500 | integrationsSessionsStopResponse501;
    
export type integrationsSessionsStopResponse = integrationsSessionsStopResponseComposite & {
  headers: Headers;
}

export const getIntegrationsSessionsStopUrl = () => {


  

  return `/api/integrations/session/stop`
}

export const integrationsSessionsStop = async (stopSessionRequest: StopSessionRequest, options?: RequestInit): Promise<integrationsSessionsStopResponse> => {
  
  return apiMutator<integrationsSessionsStopResponse>(getIntegrationsSessionsStopUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      stopSessionRequest,)
  }
);}



export type internalAdsbRegistryListResponse200 = {
  data: null
  status: 200
}
    
export type internalAdsbRegistryListResponseComposite = internalAdsbRegistryListResponse200;
    
export type internalAdsbRegistryListResponse = internalAdsbRegistryListResponseComposite & {
  headers: Headers;
}

export const getInternalAdsbRegistryListUrl = () => {


  

  return `/api/internal/adsb-registry/`
}

export const internalAdsbRegistryList = async ( options?: RequestInit): Promise<internalAdsbRegistryListResponse> => {
  
  return apiMutator<internalAdsbRegistryListResponse>(getInternalAdsbRegistryListUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



export type internalGetOrgCampaignListResponse200 = {
  data: null
  status: 200
}
    
export type internalGetOrgCampaignListResponseComposite = internalGetOrgCampaignListResponse200;
    
export type internalGetOrgCampaignListResponse = internalGetOrgCampaignListResponseComposite & {
  headers: Headers;
}

export const getInternalGetOrgCampaignListUrl = () => {


  

  return `/api/internal/get-org-campaign/`
}

export const internalGetOrgCampaignList = async ( options?: RequestInit): Promise<internalGetOrgCampaignListResponse> => {
  
  return apiMutator<internalGetOrgCampaignListResponse>(getInternalGetOrgCampaignListUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * Return current user info.
 */
export type meListResponse200 = {
  data: null
  status: 200
}
    
export type meListResponseComposite = meListResponse200;
    
export type meListResponse = meListResponseComposite & {
  headers: Headers;
}

export const getMeListUrl = () => {


  

  return `/api/me`
}

export const meList = async ( options?: RequestInit): Promise<meListResponse> => {
  
  return apiMutator<meListResponse>(getMeListUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * Simple API to get active streams for the test page
 */
export type videostreamhubActiveStreamsListResponse200 = {
  data: null
  status: 200
}
    
export type videostreamhubActiveStreamsListResponseComposite = videostreamhubActiveStreamsListResponse200;
    
export type videostreamhubActiveStreamsListResponse = videostreamhubActiveStreamsListResponseComposite & {
  headers: Headers;
}

export const getVideostreamhubActiveStreamsListUrl = () => {


  

  return `/api/videostreamhub/active_streams/`
}

export const videostreamhubActiveStreamsList = async ( options?: RequestInit): Promise<videostreamhubActiveStreamsListResponse> => {
  
  return apiMutator<videostreamhubActiveStreamsListResponse>(getVideostreamhubActiveStreamsListUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * Returns the Janus room ID and all active streams for a specific campaign.
 * @summary Get active streams for a campaign
 */
export type videostreamhubCampaignStreamsListResponse200 = {
  data: VideostreamhubCampaignStreamsList200
  status: 200
}

export type videostreamhubCampaignStreamsListResponse403 = {
  data: null
  status: 403
}

export type videostreamhubCampaignStreamsListResponse404 = {
  data: null
  status: 404
}

export type videostreamhubCampaignStreamsListResponse500 = {
  data: null
  status: 500
}
    
export type videostreamhubCampaignStreamsListResponseComposite = videostreamhubCampaignStreamsListResponse200 | videostreamhubCampaignStreamsListResponse403 | videostreamhubCampaignStreamsListResponse404 | videostreamhubCampaignStreamsListResponse500;
    
export type videostreamhubCampaignStreamsListResponse = videostreamhubCampaignStreamsListResponseComposite & {
  headers: Headers;
}

export const getVideostreamhubCampaignStreamsListUrl = (campaignId: string,) => {


  

  return `/api/videostreamhub/campaign/${campaignId}/streams/`
}

export const videostreamhubCampaignStreamsList = async (campaignId: string, options?: RequestInit): Promise<videostreamhubCampaignStreamsListResponse> => {
  
  return apiMutator<videostreamhubCampaignStreamsListResponse>(getVideostreamhubCampaignStreamsListUrl(campaignId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * API endpoint for stopping a stream.
 */
export type videostreamhubStopStreamCreateResponse200 = {
  data: null
  status: 200
}

export type videostreamhubStopStreamCreateResponse404 = {
  data: null
  status: 404
}

export type videostreamhubStopStreamCreateResponse500 = {
  data: null
  status: 500
}
    
export type videostreamhubStopStreamCreateResponseComposite = videostreamhubStopStreamCreateResponse200 | videostreamhubStopStreamCreateResponse404 | videostreamhubStopStreamCreateResponse500;
    
export type videostreamhubStopStreamCreateResponse = videostreamhubStopStreamCreateResponseComposite & {
  headers: Headers;
}

export const getVideostreamhubStopStreamCreateUrl = () => {


  

  return `/api/videostreamhub/stop_stream/`
}

export const videostreamhubStopStreamCreate = async (videostreamhubStopStreamCreateBody: VideostreamhubStopStreamCreateBody, options?: RequestInit): Promise<videostreamhubStopStreamCreateResponse> => {
  
  return apiMutator<videostreamhubStopStreamCreateResponse>(getVideostreamhubStopStreamCreateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      videostreamhubStopStreamCreateBody,)
  }
);}



/**
 * Retrieve a list of all video servers with optional filtering
 * @summary List all video servers
 */
export type videostreamhubVideoServersListResponse200 = {
  data: VideoServerListResponse
  status: 200
}

export type videostreamhubVideoServersListResponse401 = {
  data: UnauthorizedError
  status: 401
}

export type videostreamhubVideoServersListResponse403 = {
  data: ForbiddenError
  status: 403
}

export type videostreamhubVideoServersListResponse500 = {
  data: InternalServerError
  status: 500
}
    
export type videostreamhubVideoServersListResponseComposite = videostreamhubVideoServersListResponse200 | videostreamhubVideoServersListResponse401 | videostreamhubVideoServersListResponse403 | videostreamhubVideoServersListResponse500;
    
export type videostreamhubVideoServersListResponse = videostreamhubVideoServersListResponseComposite & {
  headers: Headers;
}

export const getVideostreamhubVideoServersListUrl = () => {


  

  return `/api/videostreamhub/video-servers/`
}

export const videostreamhubVideoServersList = async ( options?: RequestInit): Promise<videostreamhubVideoServersListResponse> => {
  
  return apiMutator<videostreamhubVideoServersListResponse>(getVideostreamhubVideoServersListUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * Add a new video server to the system
 * @summary Create a new video server
 */
export type videostreamhubVideoServersCreateResponse201 = {
  data: VideoServerDetailResponse
  status: 201
}

export type videostreamhubVideoServersCreateResponse400 = {
  data: ValidationError
  status: 400
}

export type videostreamhubVideoServersCreateResponse401 = {
  data: UnauthorizedError
  status: 401
}

export type videostreamhubVideoServersCreateResponse403 = {
  data: ForbiddenError
  status: 403
}

export type videostreamhubVideoServersCreateResponse404 = {
  data: NotFoundError
  status: 404
}

export type videostreamhubVideoServersCreateResponse500 = {
  data: InternalServerError
  status: 500
}
    
export type videostreamhubVideoServersCreateResponseComposite = videostreamhubVideoServersCreateResponse201 | videostreamhubVideoServersCreateResponse400 | videostreamhubVideoServersCreateResponse401 | videostreamhubVideoServersCreateResponse403 | videostreamhubVideoServersCreateResponse404 | videostreamhubVideoServersCreateResponse500;
    
export type videostreamhubVideoServersCreateResponse = videostreamhubVideoServersCreateResponseComposite & {
  headers: Headers;
}

export const getVideostreamhubVideoServersCreateUrl = () => {


  

  return `/api/videostreamhub/video-servers/`
}

export const videostreamhubVideoServersCreate = async (videoServerCreate: VideoServerCreate, options?: RequestInit): Promise<videostreamhubVideoServersCreateResponse> => {
  
  return apiMutator<videostreamhubVideoServersCreateResponse>(getVideostreamhubVideoServersCreateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      videoServerCreate,)
  }
);}



/**
 * Trigger an immediate broadcast of the video server list to MQTT. This endpoint is useful when you need to ensure all clients have the latest server list without waiting for the next scheduled broadcast. The message is published with retention enabled, so any drones connecting later will also receive this update.
 * @summary Manually trigger broadcast
 */
export type videostreamhubVideoServersBroadcastResponse200 = {
  data: VideoServerBroadcastResult
  status: 200
}

export type videostreamhubVideoServersBroadcastResponse401 = {
  data: UnauthorizedError
  status: 401
}

export type videostreamhubVideoServersBroadcastResponse403 = {
  data: ForbiddenError
  status: 403
}

export type videostreamhubVideoServersBroadcastResponse500 = {
  data: InternalServerError
  status: 500
}
    
export type videostreamhubVideoServersBroadcastResponseComposite = videostreamhubVideoServersBroadcastResponse200 | videostreamhubVideoServersBroadcastResponse401 | videostreamhubVideoServersBroadcastResponse403 | videostreamhubVideoServersBroadcastResponse500;
    
export type videostreamhubVideoServersBroadcastResponse = videostreamhubVideoServersBroadcastResponseComposite & {
  headers: Headers;
}

export const getVideostreamhubVideoServersBroadcastUrl = () => {


  

  return `/api/videostreamhub/video-servers/broadcast/`
}

export const videostreamhubVideoServersBroadcast = async (videoServerRead: NonReadonly<VideoServerRead>, options?: RequestInit): Promise<videostreamhubVideoServersBroadcastResponse> => {
  
  return apiMutator<videostreamhubVideoServersBroadcastResponse>(getVideostreamhubVideoServersBroadcastUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      videoServerRead,)
  }
);}



/**
 * Retrieve only enabled video servers (same format as broadcast payload)
 * @summary List enabled video servers
 */
export type videostreamhubVideoServersEnabledResponse200 = {
  data: VideoServerEnabledList
  status: 200
}

export type videostreamhubVideoServersEnabledResponse401 = {
  data: UnauthorizedError
  status: 401
}

export type videostreamhubVideoServersEnabledResponse403 = {
  data: ForbiddenError
  status: 403
}

export type videostreamhubVideoServersEnabledResponse500 = {
  data: InternalServerError
  status: 500
}
    
export type videostreamhubVideoServersEnabledResponseComposite = videostreamhubVideoServersEnabledResponse200 | videostreamhubVideoServersEnabledResponse401 | videostreamhubVideoServersEnabledResponse403 | videostreamhubVideoServersEnabledResponse500;
    
export type videostreamhubVideoServersEnabledResponse = videostreamhubVideoServersEnabledResponseComposite & {
  headers: Headers;
}

export const getVideostreamhubVideoServersEnabledUrl = () => {


  

  return `/api/videostreamhub/video-servers/enabled/`
}

export const videostreamhubVideoServersEnabled = async ( options?: RequestInit): Promise<videostreamhubVideoServersEnabledResponse> => {
  
  return apiMutator<videostreamhubVideoServersEnabledResponse>(getVideostreamhubVideoServersEnabledUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * Get details of a specific video server by ID
 * @summary Retrieve a video server
 */
export type videostreamhubVideoServersReadResponse200 = {
  data: VideoServerDetailResponse
  status: 200
}

export type videostreamhubVideoServersReadResponse401 = {
  data: UnauthorizedError
  status: 401
}

export type videostreamhubVideoServersReadResponse403 = {
  data: ForbiddenError
  status: 403
}

export type videostreamhubVideoServersReadResponse404 = {
  data: NotFoundError
  status: 404
}

export type videostreamhubVideoServersReadResponse500 = {
  data: InternalServerError
  status: 500
}
    
export type videostreamhubVideoServersReadResponseComposite = videostreamhubVideoServersReadResponse200 | videostreamhubVideoServersReadResponse401 | videostreamhubVideoServersReadResponse403 | videostreamhubVideoServersReadResponse404 | videostreamhubVideoServersReadResponse500;
    
export type videostreamhubVideoServersReadResponse = videostreamhubVideoServersReadResponseComposite & {
  headers: Headers;
}

export const getVideostreamhubVideoServersReadUrl = (id: string,) => {


  

  return `/api/videostreamhub/video-servers/${id}/`
}

export const videostreamhubVideoServersRead = async (id: string, options?: RequestInit): Promise<videostreamhubVideoServersReadResponse> => {
  
  return apiMutator<videostreamhubVideoServersReadResponse>(getVideostreamhubVideoServersReadUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * Update all fields of a video server
 * @summary Update a video server
 */
export type videostreamhubVideoServersUpdateResponse200 = {
  data: VideoServerDetailResponse
  status: 200
}

export type videostreamhubVideoServersUpdateResponse400 = {
  data: ValidationError
  status: 400
}

export type videostreamhubVideoServersUpdateResponse401 = {
  data: UnauthorizedError
  status: 401
}

export type videostreamhubVideoServersUpdateResponse403 = {
  data: ForbiddenError
  status: 403
}

export type videostreamhubVideoServersUpdateResponse404 = {
  data: NotFoundError
  status: 404
}

export type videostreamhubVideoServersUpdateResponse500 = {
  data: InternalServerError
  status: 500
}
    
export type videostreamhubVideoServersUpdateResponseComposite = videostreamhubVideoServersUpdateResponse200 | videostreamhubVideoServersUpdateResponse400 | videostreamhubVideoServersUpdateResponse401 | videostreamhubVideoServersUpdateResponse403 | videostreamhubVideoServersUpdateResponse404 | videostreamhubVideoServersUpdateResponse500;
    
export type videostreamhubVideoServersUpdateResponse = videostreamhubVideoServersUpdateResponseComposite & {
  headers: Headers;
}

export const getVideostreamhubVideoServersUpdateUrl = (id: string,) => {


  

  return `/api/videostreamhub/video-servers/${id}/`
}

export const videostreamhubVideoServersUpdate = async (id: string,
    videoServerUpdateBody: VideoServerUpdateBody, options?: RequestInit): Promise<videostreamhubVideoServersUpdateResponse> => {
  
  return apiMutator<videostreamhubVideoServersUpdateResponse>(getVideostreamhubVideoServersUpdateUrl(id),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      videoServerUpdateBody,)
  }
);}



/**
 * Update specific fields of a video server
 * @summary Partially update a video server
 */
export type videostreamhubVideoServersPartialUpdateResponse200 = {
  data: VideoServerDetailResponse
  status: 200
}

export type videostreamhubVideoServersPartialUpdateResponse400 = {
  data: ValidationError
  status: 400
}

export type videostreamhubVideoServersPartialUpdateResponse401 = {
  data: UnauthorizedError
  status: 401
}

export type videostreamhubVideoServersPartialUpdateResponse403 = {
  data: ForbiddenError
  status: 403
}

export type videostreamhubVideoServersPartialUpdateResponse404 = {
  data: NotFoundError
  status: 404
}

export type videostreamhubVideoServersPartialUpdateResponse500 = {
  data: InternalServerError
  status: 500
}
    
export type videostreamhubVideoServersPartialUpdateResponseComposite = videostreamhubVideoServersPartialUpdateResponse200 | videostreamhubVideoServersPartialUpdateResponse400 | videostreamhubVideoServersPartialUpdateResponse401 | videostreamhubVideoServersPartialUpdateResponse403 | videostreamhubVideoServersPartialUpdateResponse404 | videostreamhubVideoServersPartialUpdateResponse500;
    
export type videostreamhubVideoServersPartialUpdateResponse = videostreamhubVideoServersPartialUpdateResponseComposite & {
  headers: Headers;
}

export const getVideostreamhubVideoServersPartialUpdateUrl = (id: string,) => {


  

  return `/api/videostreamhub/video-servers/${id}/`
}

export const videostreamhubVideoServersPartialUpdate = async (id: string,
    videoServerUpdateBody: VideoServerUpdateBody, options?: RequestInit): Promise<videostreamhubVideoServersPartialUpdateResponse> => {
  
  return apiMutator<videostreamhubVideoServersPartialUpdateResponse>(getVideostreamhubVideoServersPartialUpdateUrl(id),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      videoServerUpdateBody,)
  }
);}



/**
 * Remove a video server from the system
 * @summary Delete a video server
 */
export type videostreamhubVideoServersDeleteResponse204 = {
  data: null
  status: 204
}

export type videostreamhubVideoServersDeleteResponse401 = {
  data: UnauthorizedError
  status: 401
}

export type videostreamhubVideoServersDeleteResponse403 = {
  data: ForbiddenError
  status: 403
}

export type videostreamhubVideoServersDeleteResponse404 = {
  data: NotFoundError
  status: 404
}

export type videostreamhubVideoServersDeleteResponse500 = {
  data: InternalServerError
  status: 500
}
    
export type videostreamhubVideoServersDeleteResponseComposite = videostreamhubVideoServersDeleteResponse204 | videostreamhubVideoServersDeleteResponse401 | videostreamhubVideoServersDeleteResponse403 | videostreamhubVideoServersDeleteResponse404 | videostreamhubVideoServersDeleteResponse500;
    
export type videostreamhubVideoServersDeleteResponse = videostreamhubVideoServersDeleteResponseComposite & {
  headers: Headers;
}

export const getVideostreamhubVideoServersDeleteUrl = (id: string,) => {


  

  return `/api/videostreamhub/video-servers/${id}/`
}

export const videostreamhubVideoServersDelete = async (id: string, options?: RequestInit): Promise<videostreamhubVideoServersDeleteResponse> => {
  
  return apiMutator<videostreamhubVideoServersDeleteResponse>(getVideostreamhubVideoServersDeleteUrl(id),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}
